// Code generated by balancegen from data/locale/<tag>/*.toml and
// data/contracts/languages.toml. DO NOT EDIT.
// Regenerate with scripts/gen-data.sh.
//
// One language part of the SOURCE language: some of its tables
// (i18n.md §1.1, R3123). gen/strings.ts imports every part statically
// and joins them, so every page has the English tables with no load.
// The parts keep each build chunk under Vite's limit (deployment.md
// §2.2).
//
// The module imports gen/strings.ts for its types alone. A runtime
// import would make the two chunks import each other.

import type * as S from './strings';

const pluralRules = new Intl.PluralRules('en');

/**
 * Picks the plural variant for a count. The category comes from the
 * platform's CLDR rule for the language of this file, so the file has
 * no rule of its own. `other` is the fallback: it is the one category every language
 * has, and a language that needs no `few` simply has none written.
 */
function plural(n: number, forms: Record<string, string | undefined> & { other: string }): string {
  return forms[pluralRules.select(n)] ?? forms.other;
}

const achievements_en: S.Achievements = {
  achievement_points_desc: 'Collect achievement points.',
  achievement_points_name: 'Deep Diver',
  arcade_bots_beaten_desc: 'Beat the bots.',
  arcade_bots_beaten_name: 'Bot Basher',
  arcade_cells_desc: 'Take cells in the arcade.',
  arcade_cells_name: 'Arcade Surveyor',
  arcade_daily_streak_desc: 'Play the arcade on many days.',
  arcade_daily_streak_name: 'Regular',
  arcade_fastest_win_desc: 'Win an arcade match quickly.',
  arcade_fastest_win_name: 'Lightning',
  arcade_hosted_desc: 'Host a private game.',
  arcade_hosted_name: 'Host',
  arcade_humans_beaten_desc: 'Beat a human.',
  arcade_humans_beaten_name: 'Duelist',
  arcade_kills_desc: 'Sink fleets in the arcade.',
  arcade_kills_name: 'Arcade Ace',
  arcade_maps_desc: 'Play the maps of the shelf.',
  arcade_maps_name: 'Cartographer',
  arcade_matches_desc: 'Finish arcade matches.',
  arcade_matches_name: 'Quick Match',
  arcade_mined_desc: 'Mine units in the arcade.',
  arcade_mined_name: 'Arcade Dredger',
  arcade_scans_desc: 'Scan in the arcade.',
  arcade_scans_name: 'Arcade Listener',
  arcade_spectated_desc: 'Watch a match as a spectator.',
  arcade_spectated_name: 'Spectator',
  arcade_torpedo_kills_desc: 'Sink arcade fleets with torpedoes.',
  arcade_torpedo_kills_name: 'Arcade Torpedoman',
  arcade_win_kinds_desc: 'Win by each win condition.',
  arcade_win_kinds_name: 'Every Verdict',
  arcade_wins_desc: 'Win arcade matches.',
  arcade_wins_name: 'Winner',
  auto_rebuilds_desc: 'Let a lost hull rebuild itself.',
  auto_rebuilds_name: 'Second Keel',
  battle_reports_desc: 'Collect battle reports.',
  battle_reports_name: 'After Action',
  beacon_anchors_desc: 'Set a Beacon\'s anchor.',
  beacon_anchors_name: 'Beacon Set',
  beacons_lost_desc: 'Lose a Beacon.',
  beacons_lost_name: 'Light Out',
  best_score_desc: 'Set a season score.',
  best_score_name: 'Personal Best',
  blueprint_hulls_desc: 'Install a print on each hull.',
  blueprint_hulls_name: 'Every Design',
  board_empty: 'The board is empty.',
  board_free: 'FREE',
  board_grades: 'GRADES',
  board_life: 'LIFETIME',
  board_premium: 'PREMIUM',
  board_season: 'SEASON',
  board_taken: (p: { when: string | number }) => `TAKEN ${p.when}`,
  branch_complete_desc: 'Finish every node of a branch.',
  branch_complete_name: 'To the Bottom',
  branches_opened_desc: 'Open a node of each branch.',
  branches_opened_name: 'Five Paths',
  bug_hunter_desc: 'Report a fault that reached a fix.',
  bug_hunter_name: 'Bug Hunter',
  buildings_levels_desc: 'Finish building levels on your hold.',
  buildings_levels_name: 'Foundations',
  cache_finders_desc: 'Other commanders find your caches.',
  cache_finders_name: 'Open Sea Bed',
  captain_all_round_desc: 'Raise many attributes of one captain through practice in one season.',
  captain_all_round_name: 'All-Rounder',
  captain_attr_max_desc: 'Raise a captain\'s attribute.',
  captain_attr_max_name: 'Peak Form',
  captain_practice_cap_desc: 'Take an attribute to the season cap of practice.',
  captain_practice_cap_name: 'Full Season',
  captain_practice_desc: 'Raise captain attributes through practice.',
  captain_practice_name: 'Learned at Sea',
  captain_retired_legend_desc: 'Retire a captain of eight seasons or more.',
  captain_retired_legend_name: 'Legend of the Trench',
  captain_seasons_max_desc: 'Keep one captain for many seasons.',
  captain_seasons_max_name: 'Old Salt',
  captains_captured_desc: 'Capture a hostile captain.',
  captains_captured_name: 'Boarding Party',
  captains_dismissed_desc: 'Dismiss a captain.',
  captains_dismissed_name: 'Paid Off',
  captains_lost_desc: 'Lose captains.',
  captains_lost_name: 'Missing in Action',
  captains_recruited_desc: 'Recruit captains.',
  captains_recruited_name: 'Commission',
  captains_trained_desc: 'Train a captain\'s talent.',
  captains_trained_name: 'Drill',
  captains_wounded_desc: 'See a captain wounded.',
  captains_wounded_name: 'Scars',
  cargo_landed_desc: 'Land cargo at the hold.',
  cargo_landed_name: 'Safe Home',
  cartographer_laureate_desc: 'Publish an arcade map the owner picked.',
  cartographer_laureate_name: 'Cartographer Laureate',
  casino_hands_desc: 'Settle hands at the casino tables.',
  casino_hands_name: 'House Regular',
  casino_jackpots_desc: 'Take top slot lines at the slot machine.',
  casino_jackpots_name: 'Jackpot',
  casino_pot_max_desc: 'Win one large pot at the hold\'em table.',
  casino_pot_max_name: 'Big Pot',
  casino_wagered_desc: 'Put credits on the casino tables.',
  casino_wagered_name: 'Stakes',
  category_arcade: 'Arcade',
  category_arsenal: 'Arsenal',
  category_casino: 'Casino',
  category_clanwar: 'Clan War',
  category_event: 'Event',
  category_fellowship: 'Fellowship',
  category_industry: 'Industry',
  category_invention: 'Invention',
  category_journey: 'Season Journey',
  category_progress: (p: { done: string | number; total: string | number }) => `${p.done} of ${p.total}`,
  category_prospecting: 'Prospecting',
  category_recognition: 'Recognition',
  category_research: 'Research',
  category_seamanship: 'Seamanship',
  category_service: 'Service Record',
  category_shipyard: 'Shipyard',
  category_siegecraft: 'Siegecraft',
  category_signals: 'Signals',
  category_territory: 'Territory',
  category_treasury: 'Treasury',
  category_wardroom: 'Wardroom',
  category_warfare: 'Warfare',
  cells_lost_desc: 'Lose cells.',
  cells_lost_name: 'Ebb',
  cells_owned_max_desc: 'Hold many cells at one time.',
  cells_owned_max_name: 'Wide Waters',
  cells_taken_desc: 'Take cells.',
  cells_taken_name: 'New Ground',
  challenger_count_desc: 'Reach the Challenger grade.',
  challenger_count_name: 'Challenger\'s Row',
  chat_lines_desc: 'Write on the net.',
  chat_lines_name: 'Voice on the Net',
  chronicler_desc: 'Write a season chronicle.',
  chronicler_name: 'Chronicler',
  clan_founded_desc: 'Found a clan.',
  clan_founded_name: 'Founder',
  clan_full_desc: 'Stand in a full clan.',
  clan_full_name: 'Full Muster',
  clan_seasons_desc: 'Play seasons inside a clan.',
  clan_seasons_name: 'Sworn',
  clanwar_banner_wins_desc: 'Stand under the war banner that takes the world.',
  clanwar_banner_wins_name: 'Banner Victory',
  clanwar_battles_defended_desc: 'Defend battles in a Clan War.',
  clanwar_battles_defended_name: 'Banner Guard',
  clanwar_cells_taken_desc: 'Take cells in a Clan War.',
  clanwar_cells_taken_name: 'War Ground',
  clanwar_division_desc: 'Stand with the clan that took rank 1 of a Clan War division.',
  clanwar_division_name: 'Division Victor',
  clanwar_first_desc: 'Take rank 1 of a clan war season.',
  clanwar_first_name: 'Clan War First',
  clanwar_first_war_desc: 'Fight your first Clan War.',
  clanwar_first_war_name: 'First Muster',
  clanwar_fleets_killed_desc: 'Sink enemy fleets in a Clan War.',
  clanwar_fleets_killed_name: 'War Hunter',
  clanwar_full_muster_desc: 'Stand with a war banner of two or more commanders that all play to the close of a Clan War.',
  clanwar_full_muster_name: 'Full Muster',
  clanwar_honour_desc: 'Earn Clan Honour in Clan Wars.',
  clanwar_honour_name: 'Clan Honour',
  clanwar_kills_in_siege_desc: 'Sink fleets inside open siege windows in a Clan War.',
  clanwar_kills_in_siege_name: 'Breach Fighter',
  clanwar_pledges_desc: 'Pledge fleets to siege windows in a Clan War.',
  clanwar_pledges_name: 'Sworn to the Banner',
  clanwar_points_desc: 'Collect Clan War achievement points.',
  clanwar_points_name: 'War Record',
  clanwar_scan_reports_shared_desc: 'Share scan reports in a Clan War.',
  clanwar_scan_reports_shared_name: 'War Scout',
  clanwar_sieges_won_desc: 'Win siege windows in a Clan War.',
  clanwar_sieges_won_name: 'War Sieges',
  clanwar_sieges_won_together_desc: 'Win a siege window in a Clan War beside a commander of your war banner.',
  clanwar_sieges_won_together_name: 'Shoulder to Shoulder',
  clanwar_victor_desc: 'Stand with the winning clan of a clan war.',
  clanwar_victor_name: 'Clan War Victor',
  clanwar_wars_desc: 'Fight Clan Wars.',
  clanwar_wars_finished_desc: 'Stay to the close of a Clan War.',
  clanwar_wars_finished_name: 'Held the Line',
  clanwar_wars_name: 'Banner Bearer',
  comeback_desc: 'Stand in the lower half at mid-season and the upper half at the close.',
  comeback_name: 'Comeback',
  comms_max_desc: 'Raise the Signal Station.',
  comms_max_name: 'Loud and Clear',
  community_pillar_desc: 'Work for the community.',
  community_pillar_name: 'Community Pillar',
  compact_units_desc: 'Save units through a Trade Compact.',
  compact_units_name: 'Saved from the Spill',
  contacts_heard_desc: 'Hear a contact for the first time.',
  contacts_heard_name: 'Hydrophone',
  control_groups_desc: 'Recall a control group.',
  control_groups_name: 'Squadron Drill',
  credit_rush_desc: 'Rush a job with credits.',
  credit_rush_name: 'Overtime',
  credits_earned_desc: 'Earn credits.',
  credits_earned_name: 'Ledger Black',
  credits_spent_desc: 'Spend credits.',
  credits_spent_name: 'Big Spender',
  damage_dealt_desc: 'Deal damage to hostiles.',
  damage_dealt_name: 'Broadside',
  damage_taken_survived_desc: 'Take damage and fight on.',
  damage_taken_survived_name: 'Battered',
  data_cores_found_desc: 'Find data cores.',
  data_cores_found_name: 'Black Box',
  data_cores_used_desc: 'Spend data cores on research.',
  data_cores_used_name: 'Decoded',
  days_active_desc: 'Play on many days.',
  days_active_name: 'Regular Watch',
  decoys_dropped_desc: 'Drop decoys.',
  decoys_dropped_name: 'Noisemaker',
  deep_runs_desc: 'Run deep.',
  deep_runs_name: 'Deep Water',
  deposits_emptied_desc: 'Empty a deposit.',
  deposits_emptied_name: 'Bare Rock',
  distance_travelled_desc: 'Sail a long way.',
  distance_travelled_name: 'Sea Miles',
  docked_desc: 'Dock fleets at the hold.',
  docked_name: 'Home Port',
  dozen_seasons_desc: 'Close your thirteenth season.',
  dozen_seasons_name: 'A Year Below',
  effect_worn_desc: 'Wear an effect.',
  effect_worn_name: 'Marked',
  event_blitz_finished_desc: 'Stay to the close of a blitz run.',
  event_blitz_finished_name: 'Blitz',
  event_captains_recruited_desc: 'Recruit captains on an event world.',
  event_captains_recruited_name: 'Storm Commission',
  event_cells_taken_desc: 'Take cells on an event world.',
  event_cells_taken_name: 'Storm Ground',
  event_every_window_desc: 'Play one run of each schedule rule in a year.',
  event_every_window_name: 'Every Window',
  event_finished_desc: 'Stay to the close of an event run.',
  event_finished_name: 'Rode It Out',
  event_first_desc: 'Take rank 1 of an event run.',
  event_first_name: 'Storm Victor',
  event_fleets_killed_desc: 'Sink fleets on an event world.',
  event_fleets_killed_name: 'Storm Blood',
  event_gathered_desc: 'Gather units on an event world.',
  event_gathered_name: 'Storm Haul',
  event_honour_desc: 'Collect event Honour.',
  event_honour_name: 'Storm Honour',
  event_journey_complete_desc: 'Complete the journey of an event run.',
  event_journey_complete_name: 'Storm Wayfarer',
  event_points_desc: 'Collect event achievement points.',
  event_points_name: 'Storm Diver',
  event_roster_full_desc: 'Fill the wardroom on an event world.',
  event_roster_full_name: 'Storm Wardroom',
  event_seasons_desc: 'Play event runs.',
  event_seasons_name: 'Storm Seasons',
  event_ships_desc: 'Finish ships on an event world.',
  event_ships_name: 'Storm Keels',
  event_sieges_won_desc: 'Win sieges on an event world.',
  event_sieges_won_name: 'Storm Breach',
  event_tech_desc: 'Recover tech on an event world.',
  event_tech_name: 'Storm Knowledge',
  event_top_decile_desc: 'Finish an event run in the top tenth.',
  event_top_decile_name: 'Storm Tenth',
  event_top_half_desc: 'Finish an event run in the upper half.',
  event_top_half_name: 'Storm Half',
  event_top_three_desc: 'Take rank 2 or 3 of an event run.',
  event_top_three_name: 'Storm Podium',
  event_win_kinds_desc: 'Play each kind of variant world.',
  event_win_kinds_name: 'Every Storm',
  every_building_desc: 'Finish one level of each building of the hold.',
  every_building_max_desc: 'Raise each building to its maximum level.',
  every_building_max_name: 'Nothing Left to Build',
  every_building_name: 'Full Complement',
  every_faction_desc: 'Play a season under each faction.',
  every_faction_name: 'Turncoat',
  every_faction_won_desc: 'Win under each faction.',
  every_faction_won_name: 'Every Banner',
  every_hull_desc: 'Finish one hull of each class.',
  every_hull_name: 'Twelve Keels',
  every_victim_desc: 'Sink one fleet of each class.',
  every_victim_name: 'Full Tally',
  expeditions_deep_desc: 'Dive to a deeper stage.',
  expeditions_deep_name: 'Hadal Dive',
  expeditions_desc: 'Send expeditions into a trench.',
  expeditions_name: 'Trench Dive',
  faction_champion_desc: 'Be the best of the winning faction.',
  faction_champion_name: 'Faction Champion',
  faction_seasons_abyssal_compact_desc: 'Play seasons under the Abyssal Compact.',
  faction_seasons_abyssal_compact_name: 'Abyssal Compact',
  faction_seasons_kelp_syndicate_desc: 'Play seasons under the Kelp Syndicate.',
  faction_seasons_kelp_syndicate_name: 'Kelp Syndicate',
  faction_seasons_mariana_sisters_desc: 'Play seasons under the Mariana Sisters.',
  faction_seasons_mariana_sisters_name: 'Mariana Sisters',
  faction_seasons_rust_fleet_desc: 'Play seasons under the Rust Fleet.',
  faction_seasons_rust_fleet_name: 'Rust Fleet',
  faction_seasons_void_choir_desc: 'Play seasons under the Void Choir.',
  faction_seasons_void_choir_name: 'Void Choir',
  first_blood_of_season_desc: 'Draw the world\'s first blood of a season.',
  first_blood_of_season_name: 'First Blood',
  first_hand_desc: 'Settle your first hand at a casino table.',
  first_hand_name: 'First Hand',
  first_season_desc: 'Close your first season.',
  first_season_name: 'First Season',
  first_strike_kills_desc: 'Sink a fleet on the first strike.',
  first_strike_kills_name: 'Ambush',
  fleet_hours_desc: 'Keep fleets at sea.',
  fleet_hours_name: 'Sea Time',
  fleets_killed_desc: 'Sink hostile fleets.',
  fleets_killed_name: 'First Blood',
  fleets_launched_desc: 'Deploy fleets from the hold.',
  fleets_launched_name: 'Put to Sea',
  fleets_lost_desc: 'Lose fleets to the enemy.',
  fleets_lost_name: 'Learned the Hard Way',
  flips_from_enemy_desc: 'Take a cell from a hostile.',
  flips_from_enemy_name: 'Turned the Tide',
  frontier_days_desc: 'Hold a frontier cell.',
  frontier_days_name: 'Frontier Life',
  full_holds_desc: 'Fill a hauler\'s hold.',
  full_holds_name: 'Brim Full',
  gather_in_sov_desc: 'Gather inside your own sovereignty.',
  gather_in_sov_name: 'Home Waters',
  gathered_alloy_desc: 'Gather alloy.',
  gathered_alloy_name: 'Alloy',
  gathered_biomass_desc: 'Gather biomass.',
  gathered_biomass_name: 'Biomass',
  gathered_isotopes_desc: 'Gather isotopes.',
  gathered_isotopes_name: 'Isotopes',
  gathered_units_desc: 'Gather resource units.',
  gathered_units_name: 'Dredger\'s Haul',
  gathered_volatiles_desc: 'Gather volatiles.',
  gathered_volatiles_name: 'Volatiles',
  grade_abyssal: 'Abyssal',
  grade_bathyal: 'Bathyal',
  grade_challenger: 'Challenger',
  grade_hadal: 'Hadal',
  grade_littoral: 'Littoral',
  grade_none: '—',
  grade_shelf: 'Shelf',
  granted_on: (p: { when: string | number }) => `GRANTED ${p.when}`,
  groups_formed_desc: 'Form control groups.',
  groups_formed_name: 'In Formation',
  hall_of_fame_desc: 'Take rank 1 a second time.',
  hall_of_fame_name: 'Hall of Fame',
  hold_under_fire_held_desc: 'Hold a base under fire.',
  hold_under_fire_held_name: 'Stood Fast',
  honour_total_desc: 'Collect Honour.',
  honour_total_name: 'Honour Roll',
  idle_credits_desc: 'Take credits from the idle mint.',
  idle_credits_name: 'Slow Mint',
  installations_held_desc: 'Hold a faction installation.',
  installations_held_name: 'Lighthouse Keeper',
  intel_received_desc: 'Take intel from another commander.',
  intel_received_name: 'Ears Open',
  inventions_desc: 'Invent prints.',
  inventions_name: 'Patent Office',
  isotopes_found_desc: 'Bring isotopes up from a dive.',
  isotopes_found_name: 'Glow',
  j_beacons_desc: 'Set Beacon anchors this season.',
  j_beacons_name: 'Lights Set',
  j_buildings_desc: 'Finish building levels this season.',
  j_buildings_name: 'Stone Laid',
  j_captain_desc: 'Recruit captains this season.',
  j_captain_name: 'New Officers',
  j_captain_practised_desc: 'Raise captain attributes through practice this season.',
  j_captain_practised_name: 'Sea Time',
  j_captain_trained_desc: 'Train captain talents this season.',
  j_captain_trained_name: 'Drill Season',
  j_cells_desc: 'Take cells this season.',
  j_cells_name: 'Ground Won',
  j_compacts_desc: 'Save units through Trade Compacts this season.',
  j_compacts_name: 'Nothing Spilled',
  j_data_cores_desc: 'Find data cores this season.',
  j_data_cores_name: 'Salvaged Records',
  j_days_desc: 'Play on days this season.',
  j_days_name: 'Days at the Chart',
  j_deep_run_hours_desc: 'Run deep this season.',
  j_deep_run_hours_name: 'Deep and Quiet',
  j_every_hull_class_desc: 'Finish hulls of different classes this season.',
  j_every_hull_class_name: 'Mixed Yard',
  j_everyone_home_desc: 'Close the season with no captain lost.',
  j_everyone_home_name: 'Everyone Home',
  j_expedition_desc: 'Send expeditions this season.',
  j_expedition_name: 'Into the Trench',
  j_first_ship_desc: 'Finish ships this season.',
  j_first_ship_name: 'First Keel',
  j_first_strike_desc: 'Sink fleets on the first strike this season.',
  j_first_strike_name: 'Ambusher',
  j_first_tech_desc: 'Recover tech this season.',
  j_first_tech_name: 'First Light',
  j_frontier_hours_desc: 'Hold a frontier cell this season.',
  j_frontier_hours_name: 'On the Edge',
  j_gathered_desc: 'Gather units this season.',
  j_gathered_name: 'Holds Filled',
  j_groups_formed_desc: 'Form control groups this season.',
  j_groups_formed_name: 'Squadrons',
  j_installations_held_desc: 'Hold a faction installation this season.',
  j_installations_held_name: 'Keeper',
  j_intel_desc: 'Share scan reports this season.',
  j_intel_name: 'Word Passed',
  j_inventions_desc: 'Invent prints this season.',
  j_inventions_name: 'Drafting Board',
  j_kills_desc: 'Sink fleets this season.',
  j_kills_name: 'Blood Drawn',
  j_kills_with_torpedo_desc: 'Sink fleets with torpedoes this season.',
  j_kills_with_torpedo_name: 'Torpedo Season',
  j_market_sales_desc: 'Sell on the market this season.',
  j_market_sales_name: 'Trade',
  j_night_watch_desc: 'Sit at the chart at night this season.',
  j_night_watch_name: 'Night Orders',
  j_no_env_death_desc: 'Close the season with no fleet lost to the water.',
  j_no_env_death_name: 'Read the Water',
  j_objects_held_desc: 'Hold objects through windows this season.',
  j_objects_held_name: 'Garrison Duty',
  j_pledges_desc: 'Pledge fleets to sieges this season.',
  j_pledges_name: 'Pledged',
  j_prints_installed_desc: 'Install prints this season.',
  j_prints_installed_name: 'Fitted',
  j_quake_desc: 'Keep a fleet at sea at each seaquake stage.',
  j_quake_name: 'Through the Quake',
  j_ransom_desc: 'Ransom captains this season.',
  j_ransom_name: 'Terms',
  j_repairs_desc: 'Repair hulls this season.',
  j_repairs_name: 'Patched Up',
  j_salvage_desc: 'Salvage units this season.',
  j_salvage_name: 'Pickings',
  j_siege_desc: 'Win or defend sieges this season.',
  j_siege_name: 'Walls',
  j_torpedo_hits_desc: 'Hit hostiles with torpedoes this season.',
  j_torpedo_hits_name: 'Running True',
  j_trench_cells_desc: 'Take trench cells this season.',
  j_trench_cells_name: 'Deep Ground',
  journey_complete_desc: 'Complete the season journey.',
  journey_complete_name: 'Wayfarer',
  journey_done: 'JOURNEY COMPLETE',
  journey_empty: 'No journey objective is open.',
  journey_no_record: 'Your progress did not load. The objectives show no value.',
  journey_progress: (p: { done: string | number; total: string | number }) => `${p.done} of ${p.total}`,
  journey_title: 'SEASON JOURNEY',
  journeys_completed_desc: 'Complete season journeys.',
  journeys_completed_name: 'Wayfarer',
  keystones_desc: 'Recover a keystone.',
  keystones_name: 'Keystone',
  kill_streak_desc: 'Sink fleets without losing one.',
  kill_streak_name: 'Unbroken',
  kills_basilisk_desc: 'Sink Basilisk fleets.',
  kills_basilisk_name: 'Basilisk Hunter',
  kills_beacon_desc: 'Sink Beacon fleets.',
  kills_beacon_name: 'Beacon Hunter',
  kills_bombard_desc: 'Sink Bombard fleets.',
  kills_bombard_name: 'Bombard Hunter',
  kills_corsair_desc: 'Sink Corsair fleets.',
  kills_corsair_name: 'Corsair Hunter',
  kills_cutlass_desc: 'Sink Cutlass fleets.',
  kills_cutlass_name: 'Cutlass Hunter',
  kills_dredger_desc: 'Sink Dredger fleets.',
  kills_dredger_name: 'Dredger Hunter',
  kills_falconet_desc: 'Sink Falconet fleets.',
  kills_falconet_name: 'Falconet Hunter',
  kills_in_enemy_sov_desc: 'Sink a fleet in hostile water.',
  kills_in_enemy_sov_name: 'Raider',
  kills_in_own_sov_desc: 'Sink a fleet in your own water.',
  kills_in_own_sov_name: 'Home Guard',
  kills_lancer_desc: 'Sink Lancer fleets.',
  kills_lancer_name: 'Lancer Hunter',
  kills_oracle_desc: 'Sink Oracle fleets.',
  kills_oracle_name: 'Oracle Hunter',
  kills_sentinel_desc: 'Sink Sentinel fleets.',
  kills_sentinel_name: 'Sentinel Hunter',
  kills_tender_desc: 'Sink Tender fleets.',
  kills_tender_name: 'Tender Hunter',
  kills_vedette_desc: 'Sink Vedette fleets.',
  kills_vedette_name: 'Vedette Hunter',
  kills_with_basilisk_desc: 'Sink a fleet with a Basilisk.',
  kills_with_basilisk_name: 'Basilisk Ace',
  kills_with_bombard_desc: 'Sink a fleet with a Bombard.',
  kills_with_bombard_name: 'Bombard Ace',
  kills_with_corsair_desc: 'Sink a fleet with a Corsair.',
  kills_with_corsair_name: 'Corsair Ace',
  kills_with_cutlass_desc: 'Sink a fleet with a Cutlass.',
  kills_with_cutlass_name: 'Cutlass Ace',
  kills_with_falconet_desc: 'Sink a fleet with a Falconet.',
  kills_with_falconet_name: 'Falconet Ace',
  kills_with_lancer_desc: 'Sink a fleet with a Lancer.',
  kills_with_lancer_name: 'Lancer Ace',
  kills_with_sentinel_desc: 'Sink a fleet with a Sentinel.',
  kills_with_sentinel_name: 'Sentinel Ace',
  kills_with_vedette_desc: 'Sink a fleet with a Vedette.',
  kills_with_vedette_name: 'Vedette Ace',
  largest_fleet_count_desc: 'Hold many fleets at sea at one time.',
  largest_fleet_count_name: 'Grand Fleet',
  last_hold_standing_desc: 'Close the season as your faction\'s one whole hold.',
  last_hold_standing_name: 'Last Hold Standing',
  level_academy_desc: 'Raise the Academy to the stated level.',
  level_academy_name: 'Academy',
  level_alloymine_desc: 'Raise the Alloy Mine to the stated level.',
  level_alloymine_name: 'Alloy Mine',
  level_base_desc: 'Raise the Command Centre to the stated level.',
  level_base_name: 'Command Centre',
  level_biomassfarm_desc: 'Raise the Biomass Farm to the stated level.',
  level_biomassfarm_name: 'Biomass Farm',
  level_communications_desc: 'Raise the Signal Station to the stated level.',
  level_communications_name: 'Signal Station',
  level_construction_desc: 'Raise the Works Yard to the stated level.',
  level_construction_name: 'Works Yard',
  level_harbour_desc: 'Raise the Dock to the stated level.',
  level_harbour_name: 'Dock',
  level_hospital_desc: 'Raise the Sickbay to the stated level.',
  level_hospital_name: 'Sickbay',
  level_logistics_desc: 'Raise the Fleet Command to the stated level.',
  level_logistics_name: 'Fleet Command',
  level_prison_desc: 'Raise the Brig to the stated level.',
  level_prison_name: 'Brig',
  level_radiationcontrol_desc: 'Raise the Dive Control to the stated level.',
  level_radiationcontrol_name: 'Dive Control',
  level_recruitment_desc: 'Raise the Recruiting Office to the stated level.',
  level_recruitment_name: 'Recruiting Office',
  level_researchlab_desc: 'Raise the Research Lab to the stated level.',
  level_researchlab_name: 'Research Lab',
  level_shipdesign_desc: 'Raise the Ship Design to the stated level.',
  level_shipdesign_name: 'Ship Design',
  level_sonar_desc: 'Raise the Sonar Station to the stated level.',
  level_sonar_name: 'Sonar Station',
  level_storage_desc: 'Raise the Storage to the stated level.',
  level_storage_name: 'Storage',
  level_torpedobanks_desc: 'Raise the Torpedo Battery to the stated level.',
  level_torpedobanks_name: 'Torpedo Battery',
  level_volatilesextractor_desc: 'Raise the Volatiles Extractor to the stated level.',
  level_volatilesextractor_name: 'Volatiles Extractor',
  level_wharf_desc: 'Raise the Shipyard to the stated level.',
  level_wharf_name: 'Shipyard',
  market_buys_desc: 'Buy on the market.',
  market_buys_name: 'Buyer',
  market_sales_desc: 'Sell on the market.',
  market_sales_name: 'Broker',
  market_volume_desc: 'Move units through the market.',
  market_volume_name: 'Market Maker',
  mastery_arcade_desc: 'Reach Challenger on every Arcade achievement.',
  mastery_arcade_name: 'Arcade Mastery',
  mastery_arsenal_desc: 'Reach Challenger on every Arsenal achievement.',
  mastery_arsenal_name: 'Arsenal Mastery',
  mastery_casino_desc: 'Reach Challenger on every Casino achievement.',
  mastery_casino_name: 'Casino Mastery',
  mastery_clanwar_desc: 'Reach Challenger on every Clan War achievement.',
  mastery_clanwar_name: 'Clan War Mastery',
  mastery_event_desc: 'Reach Challenger on every Event achievement.',
  mastery_event_name: 'Event Mastery',
  mastery_fellowship_desc: 'Reach Challenger on every Fellowship achievement.',
  mastery_fellowship_name: 'Fellowship Mastery',
  mastery_industry_desc: 'Reach Challenger on every Industry achievement.',
  mastery_industry_name: 'Industry Mastery',
  mastery_invention_desc: 'Reach Challenger on every Invention achievement.',
  mastery_invention_name: 'Invention Mastery',
  mastery_prospecting_desc: 'Reach Challenger on every Prospecting achievement.',
  mastery_prospecting_name: 'Prospecting Mastery',
  mastery_research_desc: 'Reach Challenger on every Research achievement.',
  mastery_research_name: 'Research Mastery',
  mastery_seamanship_desc: 'Reach Challenger on every Seamanship achievement.',
  mastery_seamanship_name: 'Seamanship Mastery',
  mastery_service_desc: 'Reach Challenger on every Service Record achievement.',
  mastery_service_name: 'Service Record Mastery',
  mastery_shipyard_desc: 'Reach Challenger on every Shipyard achievement.',
  mastery_shipyard_name: 'Shipyard Mastery',
  mastery_siegecraft_desc: 'Reach Challenger on every Siegecraft achievement.',
  mastery_siegecraft_name: 'Siegecraft Mastery',
  mastery_signals_desc: 'Reach Challenger on every Signals achievement.',
  mastery_signals_name: 'Signals Mastery',
  mastery_territory_desc: 'Reach Challenger on every Territory achievement.',
  mastery_territory_name: 'Territory Mastery',
  mastery_treasury_desc: 'Reach Challenger on every Treasury achievement.',
  mastery_treasury_name: 'Treasury Mastery',
  mastery_wardroom_desc: 'Reach Challenger on every Wardroom achievement.',
  mastery_wardroom_name: 'Wardroom Mastery',
  mastery_warfare_desc: 'Reach Challenger on every Warfare achievement.',
  mastery_warfare_name: 'Warfare Mastery',
  mined_units_desc: 'Mine units at the hold.',
  mined_units_name: 'Passive Income',
  missions_anchor_desc: 'Order the anchor mission.',
  missions_anchor_name: 'Anchor',
  missions_attack_move_desc: 'Order the attack move mission.',
  missions_attack_move_name: 'Attack Move',
  missions_defend_desc: 'Order the hold mission.',
  missions_defend_name: 'Hold',
  missions_gather_desc: 'Order the gather mission.',
  missions_gather_name: 'Gather',
  missions_move_desc: 'Order the move mission.',
  missions_move_name: 'Move',
  missions_patrol_desc: 'Order the patrol mission.',
  missions_patrol_name: 'Patrol',
  module_families_desc: 'Install a module of each family.',
  module_families_name: 'Every Family',
  natural_blackjack_desc: 'Take your first blackjack natural.',
  natural_blackjack_name: 'Natural',
  next_threshold: (p: { value: string | number }) => `NEXT AT ${p.value}`,
  nights_at_sea_desc: 'Sit at the chart at night.',
  nights_at_sea_name: 'Night Watch',
  npc_clan_left_desc: 'Join your first clan.',
  npc_clan_left_name: 'Struck Out',
  objects_held_windows_desc: 'Hold an object through a window.',
  objects_held_windows_name: 'Garrison',
  objects_taken_archive_desc: 'Take the Archive Vault.',
  objects_taken_archive_name: 'Archive Vault',
  objects_taken_battery_desc: 'Take the Deep Battery.',
  objects_taken_battery_name: 'Deep Battery',
  objects_taken_drydock_desc: 'Take the Drydock Shoal.',
  objects_taken_drydock_name: 'Drydock Shoal',
  objects_taken_forge_desc: 'Take the Forge Vent.',
  objects_taken_forge_name: 'Forge Vent',
  objects_taken_kelp_desc: 'Take the Kelp Terrace.',
  objects_taken_kelp_name: 'Kelp Terrace',
  objects_taken_marshal_desc: 'Take the Marshal Court.',
  objects_taken_marshal_name: 'Marshal Court',
  objects_taken_spire_desc: 'Take the Relay Spire.',
  objects_taken_spire_name: 'Relay Spire',
  objects_taken_throne_desc: 'Take the Trench Throne.',
  objects_taken_throne_name: 'Trench Throne',
  objects_taken_ward_desc: 'Take the Coral Ward.',
  objects_taken_ward_name: 'Coral Ward',
  operator_thanks_desc: 'Take the thanks of an operator.',
  operator_thanks_name: 'With Thanks',
  oracle_shares_desc: 'Share an Oracle\'s array.',
  oracle_shares_name: 'The Oracle Speaks',
  orders_given_desc: 'Give orders to fleets.',
  orders_given_name: 'Helm Orders',
  pacifist_desc: 'Close a season in the upper half with no kill.',
  pacifist_name: 'Pacifist',
  plank_owner_desc: 'Stand in the founding cohort of a deployment.',
  plank_owner_name: 'Plank Owner',
  pledges_desc: 'Pledge a fleet to a siege.',
  pledges_name: 'Pledged',
  pocket_connected_desc: 'Join a pocket to your base.',
  pocket_connected_name: 'Made Whole',
  prints_adopted_desc: 'Adopt another commander\'s print.',
  prints_adopted_name: 'Borrowed Genius',
  prints_installed_desc: 'Install prints on a design.',
  prints_installed_name: 'Fitted Out',
  prints_sold_desc: 'Sell a print on the market.',
  prints_sold_name: 'Licensed',
  prints_spent_desc: 'Spend print runs on hulls.',
  prints_spent_name: 'Run of the Mill',
  prisoners_freed_desc: 'Free a prisoner.',
  prisoners_freed_name: 'Jailbreak',
  prisoners_ransomed_desc: 'Ransom a captain back.',
  prisoners_ransomed_name: 'Ransom',
  progress_down: 'The record is not available.',
  quake_survived_desc: 'Ride out a seaquake at sea.',
  quake_survived_name: 'Quake Rider',
  queue_hours_desc: 'Keep the build queue busy.',
  queue_hours_name: 'Long Shift',
  queue_jobs_desc: 'Finish jobs in the build queue.',
  queue_jobs_name: 'Foreman',
  rank_titles_desc: 'Rise through the Honour ranks.',
  rank_titles_name: 'Title Holder',
  ranks_pill: 'ACHIEVEMENTS',
  recognition_label: 'RECOGNITION',
  record_empty: 'Nothing yet. Take a seat and play.',
  record_grades: (p: { count: string | number }) => `${p.count} GRADES`,
  record_points: (p: { points: string | number }) => `${p.points} POINTS`,
  registered_desc: 'Register the account.',
  registered_name: 'Signed On',
  repairs_done_desc: 'Repair damaged hulls.',
  repairs_done_name: 'Dry Dock',
  replay_shared_desc: 'Let another player open your replay.',
  replay_shared_name: 'Show Reel',
  research_hours_desc: 'Keep the research queue busy.',
  research_hours_name: 'Night Reading',
  reveals_desc: 'Reveal a contact with a scan.',
  reveals_name: 'Unmasked',
  rim_saved_desc: 'Save a rim cell.',
  rim_saved_name: 'Shored Up',
  rounds_shot_down_desc: 'Shoot down hostile rounds.',
  rounds_shot_down_name: 'Point Defence',
  row_max: 'COMPLETE',
  row_value: (p: { value: string | number }) => `NOW ${p.value}`,
  royal_flush_desc: 'Show your first royal flush at a showdown.',
  royal_flush_name: 'Royal Flush',
  sabbatical_kept_desc: 'Keep a captain through a Cryo Freeze.',
  sabbatical_kept_name: 'Shore Leave',
  salvaged_desc: 'Salvage units from a wreck.',
  salvaged_name: 'Wrecker',
  scan_pings_desc: 'Send active pings.',
  scan_pings_name: 'Ping',
  scan_reports_desc: 'Share a scan report.',
  scan_reports_name: 'Contact Report',
  season_first_desc: 'Take rank 1 of a world.',
  season_first_name: 'First of the World',
  season_podium_desc: 'Take rank 2 or 3 of a world.',
  season_podium_name: 'Podium',
  season_top_decile_desc: 'Finish a season in the top tenth.',
  season_top_decile_name: 'Top Tenth',
  seasons_finished_desc: 'Stay to the close of a season.',
  seasons_finished_name: 'Saw the Quake',
  seasons_played_desc: 'Play seasons.',
  seasons_played_name: 'Seasons at Sea',
  session_hours_desc: 'Sit at the chart.',
  session_hours_name: 'On Watch',
  ships_built_basilisk_desc: 'Finish Basilisk hulls.',
  ships_built_basilisk_name: 'Basilisk',
  ships_built_beacon_desc: 'Finish Beacon hulls.',
  ships_built_beacon_name: 'Beacon',
  ships_built_bombard_desc: 'Finish Bombard hulls.',
  ships_built_bombard_name: 'Bombard',
  ships_built_corsair_desc: 'Finish Corsair hulls.',
  ships_built_corsair_name: 'Corsair',
  ships_built_cutlass_desc: 'Finish Cutlass hulls.',
  ships_built_cutlass_name: 'Cutlass',
  ships_built_desc: 'Lay down and finish ships.',
  ships_built_dredger_desc: 'Finish Dredger hulls.',
  ships_built_dredger_name: 'Dredger',
  ships_built_falconet_desc: 'Finish Falconet hulls.',
  ships_built_falconet_name: 'Falconet',
  ships_built_lancer_desc: 'Finish Lancer hulls.',
  ships_built_lancer_name: 'Lancer',
  ships_built_name: 'Slipway',
  ships_built_oracle_desc: 'Finish Oracle hulls.',
  ships_built_oracle_name: 'Oracle',
  ships_built_sentinel_desc: 'Finish Sentinel hulls.',
  ships_built_sentinel_name: 'Sentinel',
  ships_built_tender_desc: 'Finish Tender hulls.',
  ships_built_tender_name: 'Tender',
  ships_built_vedette_desc: 'Finish Vedette hulls.',
  ships_built_vedette_name: 'Vedette',
  siege_kills_desc: 'Sink a fleet inside a siege window.',
  siege_kills_name: 'Storming Party',
  sieges_defended_desc: 'Defend an object.',
  sieges_defended_name: 'Held the Wall',
  sieges_lost_desc: 'Lose sieges.',
  sieges_lost_name: 'Repulsed',
  sieges_won_desc: 'Win sieges.',
  sieges_won_name: 'Breach',
  spent_building_desc: 'Spend on building.',
  spent_building_name: 'Building',
  spent_captain_desc: 'Spend on captain.',
  spent_captain_name: 'Captain',
  spent_expedition_desc: 'Spend on expedition.',
  spent_expedition_name: 'Expedition',
  spent_invent_desc: 'Spend on invent.',
  spent_invent_name: 'Invent',
  spent_market_desc: 'Spend on market.',
  spent_market_name: 'Market',
  spent_print_desc: 'Spend on print.',
  spent_print_name: 'Print',
  spent_repair_desc: 'Spend on repair.',
  spent_repair_name: 'Repair',
  spent_rush_desc: 'Spend on rush.',
  spent_rush_name: 'Rush',
  spent_ship_desc: 'Spend on ship.',
  spent_ship_name: 'Ship',
  spent_tech_desc: 'Spend on tech.',
  spent_tech_name: 'Tech',
  spent_torpedo_desc: 'Spend on torpedo.',
  spent_torpedo_name: 'Torpedo',
  squad_seasons_desc: 'Play seasons inside a squad.',
  squad_seasons_name: 'Shipmates',
  struck_survived_desc: 'Take a torpedo and stay afloat.',
  struck_survived_name: 'Hull Held',
  t3_module_invented_desc: 'Invent a tier-3 module.',
  t3_module_invented_name: 'Deep Alloy',
  tech_recovered_desc: 'Recover tech nodes.',
  tech_recovered_name: 'Recovered Knowledge',
  tender_rounds_desc: 'Let a Tender resupply a fleet.',
  tender_rounds_name: 'Tender Mercy',
  test_pilot_desc: 'Test on the development lane.',
  test_pilot_name: 'Test Pilot',
  theme_made_desc: 'Save a custom theme.',
  theme_made_name: 'Painter',
  three_krakens_desc: 'Take your first top slot line of three Krakens.',
  three_krakens_name: 'Three Krakens',
  three_slot_print_desc: 'Install a print of three modules.',
  three_slot_print_name: 'Full Slots',
  throne_at_close_desc: 'Hold the Trench Throne at the close.',
  throne_at_close_name: 'Throne at the Close',
  throne_hours_desc: 'Hold the Trench Throne.',
  throne_hours_name: 'On the Throne',
  top_half_desc: 'Finish a season in the upper half.',
  top_half_name: 'Upper Half',
  top_ten_pct_desc: 'Finish a season in the top tenth.',
  top_ten_pct_name: 'The Ten Percent',
  torpedo_hits_desc: 'Hit a hostile with a torpedo.',
  torpedo_hits_name: 'Running True',
  torpedo_kills_desc: 'Sink a fleet with a torpedo.',
  torpedo_kills_name: 'Sent Below',
  torpedo_kinds_desc: 'Launch one of each torpedo kind.',
  torpedo_kinds_name: 'Every Warhead',
  torpedoes_fired_bulwark_desc: 'Launch bulwark torpedoes.',
  torpedoes_fired_bulwark_name: 'Bulwark',
  torpedoes_fired_desc: 'Launch torpedoes.',
  torpedoes_fired_disruptor_desc: 'Launch disruptor torpedoes.',
  torpedoes_fired_disruptor_name: 'Disruptor',
  torpedoes_fired_heavy_desc: 'Launch heavy torpedoes.',
  torpedoes_fired_heavy_name: 'Heavy',
  torpedoes_fired_interceptor_desc: 'Launch interceptor torpedoes.',
  torpedoes_fired_interceptor_name: 'Interceptor',
  torpedoes_fired_light_desc: 'Launch light torpedoes.',
  torpedoes_fired_light_name: 'Light',
  torpedoes_fired_name: 'Fire One',
  torpedoes_fired_seeker_desc: 'Launch seeker torpedoes.',
  torpedoes_fired_seeker_name: 'Seeker',
  torpedoes_stowed_desc: 'Stow torpedoes in a magazine.',
  torpedoes_stowed_name: 'Magazine',
  tournament_victor_desc: 'Win an owner-run tournament.',
  tournament_victor_name: 'Tournament Victor',
  trench_cells_desc: 'Take trench cells.',
  trench_cells_name: 'Trench Holder',
  undefeated_desc: 'Fight in a season and close it with no captain lost.',
  undefeated_name: 'Undefeated',
  unlock_complete: (p: { total: string | number }) => `COMPLETE · ALL ${p.total} GRADES`,
  unlock_grade_of: (p: { grade: string | number; n: string | number; total: string | number }) => `${p.grade} · GRADE ${p.n} OF ${p.total}`,
  unlock_handover: (p: { count: number; names: string | number }) => plural(p.count, {
    one: `Before you took command, the autopilot reached ${p.count} grade: ${p.names}.`,
    other: `Before you took command, the autopilot reached ${p.count} grades: ${p.names}.`,
  }),
  unlock_many: (p: { count: string | number }) => `${p.count} ACHIEVEMENTS`,
  unlock_next: (p: { grade: string | number; value: string | number; left: string | number }) => `NEXT ${p.grade} AT ${p.value} · ${p.left} TO GO`,
  unlock_reached: (p: { value: string | number; threshold: string | number }) => `NOW ${p.value} · REACHED AT ${p.threshold}`,
  unlock_title: 'ACHIEVEMENT',
  value_hours: (p: { value: string | number }) => `${p.value} h`,
  value_minutes: (p: { value: string | number }) => `${p.value} min`,
  value_seconds: (p: { value: string | number }) => `${p.value} s`,
  wardroom_full_desc: 'Fill the wardroom.',
  wardroom_full_name: 'Full Wardroom',
  winning_faction_desc: 'Stand with the winning faction.',
  winning_faction_name: 'Winning Banner',
  withdrawals_desc: 'Withdraw a fleet from a fight.',
  withdrawals_name: 'Living to Fight',
  world_founder_desc: 'Play season 1 of a world.',
  world_founder_name: 'World Founder',
  wrecks_salvaged_desc: 'Salvage wrecks.',
  wrecks_salvaged_name: 'Beachcomber',
};

const advisor_en: S.Advisor = {
  building_first: (p: { name: string | number }) => `Build the ${p.name}.`,
  building_raise: (p: { name: string | number; level: string | number }) => `Raise the ${p.name} to level ${p.level}.`,
  commission: (p: { name: string | number }) => `Take the commission: ${p.name}. A fleet of yours fits it.`,
  design: (p: { name: string | number }) => `Draft a design for the ${p.name}.`,
  fleet_idle: (p: { name: string | number }) => `Give ${p.name} an order. A Dredger at rest gathers nothing.`,
  fold: 'Fold the advice to one line',
  label: 'ADVISOR',
  print: (p: { name: string | number }) => `Cut a print of the ${p.name} design.`,
  research: (p: { name: string | number }) => `Decrypt ${p.name}.`,
  save_building: (p: { name: string | number; level: string | number }) => `Save for the ${p.name} ${p.level}.`,
  save_ship: (p: { name: string | number }) => `Save for a ${p.name}.`,
  saving: (p: { pct: string | number }) => `You hold ${p.pct}% of the cost.`,
  ship: (p: { count: string | number; name: string | number }) => `Build ${p.count} × ${p.name}.`,
  title: 'Open the row of this job. The advisor gives no order.',
  torpedo: (p: { count: string | number; name: string | number }) => `Build ${p.count} × ${p.name}.`,
  unfold: 'Show the whole advice',
};

const alarms_en: S.Alarms = {
  act_build: 'BUILD',
  act_build_title: 'spend the full stores in BUILD',
  act_check: 'CHECK',
  act_check_title: 'open the network check of the connection',
  act_open: 'OPEN',
  act_open_title: 'open the INBOX',
  act_read: 'READ',
  act_read_title: 'read the card of the world clock',
  act_restart: 'RESTART',
  dev_head: 'DEV',
  full_many: (p: { n: number }) => plural(p.n, {
    one: `${p.n} STORE FULL`,
    other: `${p.n} STORES FULL`,
  }),
  full_one: (p: { name: string | number }) => `${p.name} FULL`,
  full_store: (p: { name: string | number; have: string | number }) => `${p.name} ${p.have}`,
  full_what: (p: { stores: string | number }) => `${p.stores} · at the cap`,
  go_to: 'GO TO',
  go_to_title: (p: { site: string | number }) => `move the map to ${p.site}`,
  inbox_head: 'INBOX',
  inbox_what: (p: { n: number }) => plural(p.n, {
    one: `${p.n} unread item`,
    other: `${p.n} unread items`,
  }),
  link_what: 'the game retries by itself · the orders wait',
  list_close: 'close the alarm list',
  list_count: (p: { n: number }) => plural(p.n, {
    one: `${p.n} RUNNING · MOST URGENT FIRST`,
    other: `${p.n} RUNNING · MOST URGENT FIRST`,
  }),
  list_head: 'ALARMS',
  maint_what: 'the worlds close for a release',
  quake_what_1: 'stage 1 · every fleet docks',
  quake_what_2: 'stage 2 · the deposits are dead',
  quake_what_3: 'stage 3 · the scores are locked',
  reset_head: (p: { season: string | number }) => `SEASON ${p.season} RESETS`,
  reset_real: (p: { world: string | number; real: string | number }) => `${p.world} · ${p.real} real`,
  seaview_what: 'the sea view starts at the end · any input stops it',
  siege_battle: (p: { at: string | number }) => `BATTLE ${p.at}`,
  siege_head: 'SIEGE WARNING',
  siege_title: (p: { site: string | number; at: string | number }) => `An enemy pledged an attack on ${p.site}. The window battle starts at ${p.at}. A press on the row opens the alarm list.`,
  siege_what: (p: { site: string | number; attacker: string | number }) => `${p.site} · ${p.attacker}`,
  truce_what: 'weapons free at the end',
};

const api_en: S.Api = {
  meta_no_answer: (p: { error: string | number }) => `the meta server did not answer (${p.error})`,
  meta_timeout: 'the meta server did not answer in time — try again',
  no_meta_api: (p: { status: string | number }) => `no meta API answered (HTTP ${p.status})`,
  not_json: 'the answer was not JSON',
  unexpected_answer: (p: { status: string | number }) => `unexpected answer (HTTP ${p.status})`,
};

const arcadeCatalog_en: S.ArcadeCatalog = {
  fetch_failed: (p: { status: string | number }) => `the arcade answered with code ${p.status}`,
  mixed_win_lines: (p: { count: string | number }) => `${p.count} WIN CONDITIONS`,
};

const arcadeChrome_en: S.ArcadeChrome = {
  anchor_dropping: (p: { left: string | number }) => `DROPPING ${p.left}`,
  anchor_weigh: 'WEIGH',
  anchor_weighing: (p: { left: string | number }) => `WEIGHING ${p.left}`,
  audio_sfx_what: 'torpedoes, hits, builds and the countdown',
  auto_spawn_every: (p: { every: string | number }) => `every ${p.every}`,
  back_arena: 'BACK TO THE ARENA',
  base_fire: 'FIRE',
  base_fire_aiming: 'AIMING',
  card_arrives: 'It arrives at your base at once.',
  card_bearing: 'runs a bearing',
  card_k_cap: 'cap',
  card_k_guidance: 'guidance',
  card_k_modules: 'modules',
  card_k_stock: 'stock',
  card_k_trigger: 'trigger',
  card_open_title: 'open the build card',
  card_out: 'You surrendered. Your team plays on, and you build nothing more in this match.',
  card_out_solo: 'You surrendered. You build nothing more in this match.',
  card_sea_stocked: 'It goes into your seat stock. A Sapper loads it at your base.',
  card_seeks: 'seeks the contact',
  card_stocked: 'It goes into the stock of your base.',
  chip_anchor: 'ANCHOR',
  chip_escort: 'ESCORT',
  chip_fire: 'FIRE',
  chip_fire_no_rounds: 'NO ROUNDS',
  chip_fire_reloading: (p: { left: string | number }) => `FIRE ${p.left}`,
  chip_gather: 'GATHER',
  chip_hold: 'HOLD',
  chip_hold_fire: 'GUNS TIGHT',
  chip_hunt: 'HUNT',
  chip_move: 'MOVE',
  chip_patrol: 'PATROL',
  chip_return: 'RETURN',
  chip_scan: 'SCAN',
  chip_scan_cooling: (p: { left: string | number }) => `SCAN ${p.left}`,
  chip_share: 'SHARE',
  chip_share_running: (p: { left: string | number }) => `SHARING ${p.left}`,
  clock_title: 'the time left in the match',
  dock_close_title: 'put the build pane away',
  dock_open_title: 'open the build pane',
  dock_out: 'OUT',
  dock_ready: (p: { count: number }) => plural(p.count, {
    one: `${p.count} READY`,
    other: `${p.count} READY`,
  }),
  dock_tab_build: 'BUILD',
  dock_tab_note: 'ARRIVES AT YOUR BASE AT ONCE',
  eyes_ops_title: 'operators watching this match',
  eyes_title: 'people watching this match',
  gest_close: '✕ on the card',
  gest_close_does: 'drop the selection',
  gest_close_title: 'close the gesture card',
  gest_drag_hull: 'drag from your hull',
  gest_drag_hull_does: 'its order at the release; a line shows it first',
  gest_drag_water: 'drag the water',
  gest_drag_water_does: 'pan the map',
  gest_group: 'ORDERS AND THE MAP',
  gest_heading: 'GESTURES',
  gest_hold_slot: 'hold a group slot',
  gest_hold_slot_does: 'with a hull selected: put it in that slot',
  gest_note: 'A drag from a hull gives MOVE, a focus on a contact, ESCORT, GATHER or RETURN by what it ends on. Every other order stands on the card.',
  gest_pinch: 'pinch',
  gest_pinch_does: 'zoom',
  gest_slot: 'a group slot',
  gest_slot_does: 'select that hull; again: centre the map on it',
  gest_sub: 'a match under a finger',
  gest_tap_hull: 'tap a hull',
  gest_tap_hull_does: 'select it; with no hull selected, a tap looks',
  gest_tap_water: 'tap the water',
  gest_tap_water_does: 'with your hull selected: its order there',
  gest_two_taps: 'two taps on one point',
  gest_two_taps_does: 'with FIRE armed: the first tap aims, the second fires',
  head_auto_aside: 'free at every base',
  head_auto_spawn: 'Auto-spawn',
  head_base_rounds: 'Base rounds',
  head_combat: 'Combat',
  head_hulls_aside: (p: { count: string | number }) => `${p.count} on this map`,
  head_sea_aside: 'a Sapper lays them',
  head_sea_objects: 'Sea objects',
  head_ship_rounds: 'Ship rounds',
  head_support: 'Support',
  help_gestures: 'GESTURES',
  help_gestures_what: 'every gesture of a match',
  help_keys: 'KEYS',
  help_keys_what: 'every key of a match',
  help_open: 'OPEN',
  help_sum_gestures: 'gestures',
  help_sum_keys: 'keys',
  hold_theirs: (p: { team: string | number }) => `${p.team} WINS IN`,
  hold_yours: 'YOU WIN IN',
  hotkeys_title: 'the keys this seat pressed',
  key_anchor: 'anchor / weigh anchor',
  key_base: 'centre the map on your base',
  key_base_fire: 'arm the base tubes (maps that let a base fire)',
  key_drill_next: 'NEXT on a reading drill step',
  key_escort: 'escort — pick a friendly hull',
  key_fire: 'aim the tubes (again cancels)',
  key_gather: 'gather — pick a deposit to cut',
  key_group_assign: 'put the selected hull in that control group',
  key_group_select: 'select the numbered hull · again centers the map on it',
  key_hold: 'hold this position',
  key_hold_fire: 'guns tight / guns free — a gun kept tight shoots only at a focus',
  key_hunt: 'hunt — pick an attack-move point',
  key_map_back: 'back out — pick mode, aim, selection',
  key_map_command: 'order the selected hull · back out of a pick',
  key_map_command_name: 'right-click',
  key_map_pan: 'pan the map · zoom toward the cursor',
  key_map_pan_name: 'drag / wheel',
  key_map_sheet: 'this list (esc closes)',
  key_move: 'move — pick a point, and keep course past any contact',
  key_next_round: 'the next round of the round pick (Lancer)',
  key_patrol: 'patrol — pick the far end of the lane',
  key_return: 'return home',
  key_row_ends: 'in the build pane: move the focus to the first or the last row',
  key_row_step: 'in the build pane: move the focus to the row above or below',
  key_scan: 'scan (Vedette) / share the array (Oracle) / signature order (warships)',
  keys: 'KEYS',
  keys_close: 'CLOSE',
  keys_group_map: 'MAP',
  keys_group_orders: 'ORDERS — the selected hull',
  keys_heading: 'KEYS',
  keys_title: 'keyboard shortcuts',
  lane_left: (p: { clock: string | number }) => `<b>${p.clock}</b> LEFT`,
  leave: 'LEAVE',
  leave_armed: 'LEAVE?',
  leave_armed_what: 'Press again to leave.',
  leave_drill: 'LEAVE DRILL',
  leave_drill_armed: 'LEAVE DRILL?',
  leave_drill_what: 'The drill ends at once, and its end card stands.',
  leave_match: 'LEAVE MATCH',
  leave_match_armed: 'LEAVE MATCH?',
  leave_match_what: 'A bot plays your seat on when you leave. SURRENDER takes you out of the fight, and your team plays on.',
  leave_match_what_solo: 'A bot plays your seat on when you leave. SURRENDER takes you out of the fight, and your hulls go down.',
  leave_out_what: 'You surrendered, so leaving costs nothing. No bot takes your seat, and your team plays on.',
  leave_out_what_solo: 'You surrendered, so leaving costs nothing. No bot takes your seat.',
  menu: 'MENU',
  menu_back: 'BACK',
  menu_title: 'the match menu: the sound, the UI scale, help and the way out',
  out_lobby: 'LOBBY',
  out_lobby_title: 'back to the lobby: you are out, so the press costs nothing',
  out_short: 'OUT',
  out_title: 'you surrendered: your team plays on, and you watch the match',
  out_title_solo: 'you surrendered: you are out, and you watch the match to its end',
  out_watching: 'OUT · WATCHING',
  report_line: (p: { map: string | number; tick: string | number }) => `${p.map} · tick ${p.tick}`,
  round_base_detail: 'your base fires it',
  round_hull_detail: 'a hull carries it',
  row_locked: 'builds open while the fight runs',
  row_wait: (p: { wait: string | number }) => `in ${p.wait}`,
  score: 'SCORE',
  score_fold_title: 'fold the score card to one line',
  score_open_title: 'open the score card',
  sea_row_detail: (p: { stock: string | number; sea: string | number; cap: string | number }) => `${p.stock} in stock · ${p.sea} at sea · cap ${p.cap}`,
  slot_spare_label: (p: { n: string | number }) => `group ${p.n} is empty · select a hull, then hold here to set it`,
  slot_tip: 'select a hull, then hold a slot to set it',
  sov_heading: 'SOVEREIGNTY',
  stats_offline: (p: { retries: number }) => plural(p.retries, {
    one: `offline · ${p.retries} attempt`,
    other: `offline · ${p.retries} attempts`,
  }),
  stats_render: (p: { fps: string | number; scale: string | number; timescale: string | number; tactical: string | number }) => `${p.fps} fps · ${p.scale}x · ${p.timescale}x world / ${p.tactical}x map`,
  stats_wire: (p: { tick: string | number; contacts: string | number; rtt: string | number; kb: string | number }) => `tick ${p.tick} · ${p.contacts} contacts · ${p.rtt} ms · ${p.kb} KB/s`,
  surrender: 'SURRENDER',
  surrender_armed: 'SURRENDER?',
  surrender_title: 'leave the fight: your hulls go down, your team plays on',
  surrender_title_solo: 'leave the fight: your hulls go down, and you are out of the match',
  view_base: 'GO TO THE BASE',
  view_gestures: 'GESTURES',
  view_gestures_sub: 'every gesture',
  view_head: 'VIEW',
  view_keys_sub: 'every key',
  view_marks: 'MARK SCALE',
  view_marks_off: 'hulls at full size',
  view_marks_on: (p: { percent: string | number }) => `hulls at ${p.percent}%`,
  view_muted: 'the sound is off',
  view_score_sub: 'who leads',
  view_sound: 'SOUND',
  view_sound_off: 'quiet',
  view_sound_on: 'all sound',
  view_sub: 'what stands over the arena',
  view_title: 'VIEW: the score card, the sound, the keys and the mark scale',
};

const arcadeCommunity_en: S.ArcadeCommunity = {
  apply: 'APPLY',
  apply_count: (p: { n: number }) => plural(p.n, {
    one: `APPLY · ${p.n} MAP`,
    other: `APPLY · ${p.n} MAPS`,
  }),
  author_tag: (p: { name: string | number; tag: string | number }) => `${p.name} [${p.tag}]`,
  card_by: (p: { name: string | number }) => `by <b>${p.name}</b>`,
  card_failed: (p: { error: string | number }) => `THE MAP CARD DID NOT LOAD: ${p.error}`,
  card_rev: (p: { n: string | number; at: string | number }) => `<b>REV ${p.n}</b> · published ${p.at}`,
  card_updated: (p: { at: string | number }) => ` · updated ${p.at}`,
  card_waits_note: (p: { n: string | number; pin: string | number }) => `r${p.n} plays in COMMUNITY and in a private game now. PLAY keeps r${p.pin} until an operator moves the pin.`,
  card_your_map: 'your map',
  cat_all: 'ALL CATEGORIES',
  cat_all_short: 'ALL',
  cat_note: (p: { filter: string | number }) => `A grey category holds no map under ${p.filter}. It stays in the list, so the order never moves.`,
  copy_code: 'COPY CODE',
  copy_link: 'COPY THE LINK',
  empty_all_line: (p: { slots: string | number }) => `No commander published a map yet. A Premium commander publishes up to ${p.slots} maps from the map designer.`,
  empty_all_title: 'NO MAP YET',
  empty_cat: (p: { filter: string | number }) => `No map of this category stands under ${p.filter}.`,
  empty_clan_line: (p: { slots: string | number }) => `No captain of your clan published a map. A Premium commander publishes up to ${p.slots} maps from the map designer.`,
  empty_clan_title: (p: { tag: string | number }) => `NO MAP OF [${p.tag}] YET`,
  empty_fav_line: 'Press ♥ on a map to like it. A map you like is a favourite, and it stands here in the order of the sort.',
  empty_fav_title: 'NO FAVOURITES YET',
  empty_mine_line: 'Publish a map from the map designer. It stands here and in MY MAPS.',
  empty_mine_title: 'NO MAP OF YOURS YET',
  empty_noclan_line: 'CLAN shows the maps of the captains of your clan. Join a clan on the hub page CLAN.',
  empty_noclan_title: 'YOU ARE IN NO CLAN',
  empty_slot: 'EMPTY SLOT',
  empty_slot_lapsed: 'A new map needs Premium.',
  empty_slot_line: 'Publish from the map designer.',
  fact_done: 'DONE',
  fact_done_value: (p: { pct: string | number }) => `${p.pct} % end on the win`,
  fact_likes: 'LIKES',
  fact_plays: 'PLAYS',
  fact_plays_value: (p: { plays: string | number; d7: string | number }) => `${p.plays} · ${p.d7} in 7 days`,
  featured_aside: 'the pick of the operator · from COMMUNITY',
  featured_elsewhere: (p: { name: string | number; size: string | number }) => `The FEATURED map ${p.name} plays at <b>${p.size}</b>.`,
  featured_head: 'FEATURED',
  fig_average: 'AVERAGE',
  fig_completed: 'COMPLETED',
  fig_likes: 'LIKES',
  fig_plays: 'PLAYS',
  fig_published: 'PUBLISHED',
  fig_seat_wins: 'WINS BY SEAT',
  fig_team_wins: 'TEAM WINS',
  filter_all: 'ALL',
  filter_clan: 'CLAN',
  filter_favourites: 'FAVOURITES',
  filter_favourites_short: 'FAVS',
  filter_mine: 'MINE',
  find_clan: 'FIND A CLAN',
  fresh_line: (p: { n: string | number }) => `The completed share, the average length and the team win split show after ${p.n} plays.`,
  fresh_title: 'NEW · FEW PLAYS YET',
  from_author: 'FROM THE AUTHOR',
  head_7d: '7 DAYS',
  head_done: 'DONE',
  head_likes: '♥ LIKES',
  head_map: 'MAP',
  head_plays: 'PLAYS',
  head_seats: 'SEATS',
  host: 'HOST',
  lapsed_line: 'Your maps stay playable. A new revision or a new map needs Premium.',
  lapsed_title: 'PREMIUM ENDED',
  like: 'LIKE',
  like_own_title: 'Your own map: the count only',
  liked: 'LIKED',
  list_failed: (p: { error: string | number }) => `THE MAP LIST DID NOT LOAD: ${p.error}`,
  loading: 'LOADING THE MAPS …',
  maps_count: (p: { n: number }) => plural(p.n, {
    one: `${p.n} map`,
    other: `${p.n} maps`,
  }),
  mark_featured: 'FEATURED',
  mark_inplay: (p: { n: string | number }) => `IN PLAY r${p.n}`,
  mark_new: 'NEW',
  mark_rated: 'RATED',
  more_elsewhere: (p: { n: number; names: string | number; size: string | number }) => plural(p.n, {
    one: `${p.n} more promoted map plays at <b>${p.size}</b>: ${p.names}.`,
    other: `${p.n} more promoted maps play at <b>${p.size}</b>: ${p.names}.`,
  }),
  more_title: 'More',
  mymaps_failed: (p: { error: string | number }) => `MY MAPS DID NOT LOAD: ${p.error}`,
  note_inplay: (p: { pin: string | number }) => `HOST starts a private game: it is <b>not rated</b>. PLAY · COMMUNITY plays <b>r${p.pin}</b> rated.`,
  note_waits: (p: { n: string | number }) => `r${p.n} waits for the operator.`,
  open_designer: 'OPEN THE MAP DESIGNER',
  open_designer_short: 'OPEN DESIGNER',
  open_in_designer: 'OPEN IN DESIGNER',
  pct: (p: { n: string | number }) => `${p.n} %`,
  pinned: 'PINNED IN PLAY',
  plays_word: 'plays',
  published_at: (p: { at: string | number }) => `published ${p.at}`,
  report_head: (p: { name: string | number; n: string | number }) => `REPORT ${p.name} · REV ${p.n}`,
  report_map: 'REPORT THIS MAP',
  report_reason_pick: 'PICK A REASON',
  reported: 'REPORTED',
  reset: 'RESET',
  rev: (p: { n: string | number }) => `REV ${p.n}`,
  rev_line: (p: { at: string | number; hash: string | number; size: string | number }) => `${p.at} · <code>${p.hash}</code> · ${p.size}`,
  revisions: 'REVISIONS',
  revisions_aside: (p: { n: number }) => plural(p.n, {
    one: `${p.n} · plays per revision`,
    other: `${p.n} · plays per revision`,
  }),
  row_likes: (p: { n: string | number }) => `♥ <b>${p.n}</b>`,
  row_plays: (p: { n: number }) => plural(p.n, {
    one: `<b>${p.n}</b> play`,
    other: `<b>${p.n}</b> plays`,
  }),
  row_rev: (p: { n: string | number }) => `r${p.n}`,
  seats_word: (p: { n: number }) => plural(p.n, {
    one: `${p.n} seat`,
    other: `${p.n} seats`,
  }),
  sec_community: 'COMMUNITY',
  sec_mymaps: 'MY MAPS',
  see_premium: 'SEE PREMIUM',
  sheet_category: 'CATEGORY',
  sheet_close: 'Close',
  sheet_title: 'SORT AND FILTER',
  show_all: (p: { n: number }) => plural(p.n, {
    one: `SHOW THE ${p.n} MAP`,
    other: `SHOW ALL ${p.n} MAPS`,
  }),
  show_cap: 'SHOW',
  show_more: 'SHOW MORE',
  side_map: 'THE MAP',
  size_kb: (p: { n: string | number }) => `${p.n} KB`,
  slots_free: (p: { n: number }) => plural(p.n, {
    one: `${p.n} slot free`,
    other: `${p.n} slots free`,
  }),
  slots_head: (p: { used: string | number; slots: string | number; tier: string | number }) => `<b>${p.used} of ${p.slots} map spaces</b> · ${p.tier}`,
  sort_cap: 'SORT',
  sort_liked: 'MOST LIKED',
  sort_played: 'MOST PLAYED',
  sort_recent: 'RECENT',
  st_community: 'COMMUNITY ONLY',
  st_featured: 'FEATURED',
  st_inplay: (p: { n: string | number }) => `IN PLAY · r${p.n}`,
  st_taken_down: 'TAKEN DOWN',
  st_waits: (p: { n: string | number }) => `r${p.n} WAITS FOR REVIEW`,
  st_waits_short: (p: { n: string | number }) => `r${p.n} WAITS`,
  sum_lapsed: 'Premium ended',
  sum_liked: (p: { maps: string | number; n: string | number }) => `${p.maps} · ${p.n} liked`,
  sum_mine: (p: { used: string | number; slots: string | number; likes: string | number }) => `${p.used} of ${p.slots} slots · ♥ ${p.likes}`,
  sum_new: (p: { maps: string | number; n: string | number }) => `${p.maps} · ${p.n} new`,
  sum_none: 'no map yet',
  taken_down: 'TAKEN DOWN',
  team_share: (p: { n: string | number; pct: string | number }) => `TEAM ${p.n} <b>${p.pct} %</b>`,
  tier_ended: 'Premium ended',
  tier_premium: 'Premium',
  unpublish: 'UNPUBLISH',
  unpublish_armed: 'UNPUBLISH?',
  unpublish_line: (p: { name: string | number }) => `COMMUNITY and the PLAY lane drop ${p.name}, and the slot opens. The match records keep its name.`,
  versus: 'v',
  waits_review: 'WAITS FOR REVIEW',
};

const arcadeDrill_en: S.ArcadeDrill = {
  act_ambush: 'AMBUSH SHOT',
  act_anchor: 'ANCHOR SET',
  act_braced: 'HIT BRACED',
  act_build: 'HULL BOUGHT',
  act_detonate: 'TORPEDO BURST',
  act_escort: 'ESCORT ON',
  act_fill: 'TUBES FULL',
  act_goal: 'GOAL MET',
  act_guard: 'ROUND KILL',
  act_haul: 'LOAD LANDED',
  act_hear: 'CONTACTS HEARD',
  act_hide: 'HULL UNHEARD',
  act_launch: 'TORPEDO AWAY',
  act_mend: 'HULLS AT FULL',
  act_outflank: 'STERN OUTFLANKED',
  act_patrol: 'PATROL OUT',
  act_ping: 'PING FIRED',
  act_reach: 'SPOT REACHED',
  act_rearm: 'ROUNDS LOADED',
  act_restock: 'ROUNDS BOUGHT',
  act_signature: 'ORDER SPENT',
  act_sink: 'HULL SUNK',
  act_stern: 'STERN HIT',
  act_stow: 'ROUNDS STOWED',
  act_take: 'CELL TAKEN',
  end_again: 'START AGAIN',
  end_bridge_last: 'You know the controls. Each row of the arcade lobby states how you win its matches. In conquest, the sea trials teach the rest: buildings, research and captains.',
  end_complete: 'COMPLETE',
  end_fine: 'A drill uses no run. It does not move the ladder, and it awards no honour and no captains.',
  end_kind_name: (p: { name: string | number }) => `DRILL · ${p.name}`,
  end_kind_place: (p: { name: string | number; place: string | number; count: string | number }) => `DRILL · ${p.name} · ${p.place} OF ${p.count}`,
  end_left: (p: { n: string | number; total: string | number }) => `You left the drill at step ${p.n} of ${p.total}. A drill that ends with LEAVE has no figures.`,
  end_lobby: 'LOBBY',
  end_next: 'NEXT DRILL',
  end_next_kind_place: (p: { place: string | number; count: string | number }) => `NEXT DRILL · ${p.place} OF ${p.count}`,
  end_next_steps: (p: { n: number }) => plural(p.n, {
    one: `${p.n} step`,
    other: `${p.n} steps`,
  }),
  end_play: 'PLAY A MATCH',
  end_spent: 'No arcade run is left today. Runs reset at 00:00 UTC.',
  end_spent_in: (p: { left: string | number }) => `No arcade run is left today. Runs reset at 00:00 UTC, in ${p.left}.`,
  end_steps: (p: { done: string | number; total: string | number; clock: string | number }) => `${p.done} OF ${p.total} STEPS · ${p.clock} PLAYED`,
  end_unfinished: 'UNFINISHED',
  kicker: 'DRILL',
  next: 'NEXT',
  skip: 'SKIP THE DRILL',
  stat_cells: 'Cells taken',
  stat_found: 'Hulls found by sonar',
  stat_spent: 'Credits spent',
  stat_sunk: 'Enemy hulls sunk',
  stat_torpedo: 'Torpedo kills',
  step_done: (p: { n: string | number }) => `STEP ${p.n} DONE`,
  step_done_act: (p: { n: string | number; act: string | number }) => `STEP ${p.n} DONE · ${p.act}`,
  step_kind: (p: { n: string | number; total: string | number }) => `DRILL · STEP ${p.n} OF ${p.total}`,
  strip_count: (p: { n: string | number; total: string | number }) => `STEP ${p.n}/${p.total}`,
};

const arcadeFormat_en: S.ArcadeFormat = {
  shortfall: (p: { missing: string | number }) => `NEEDS ¤ ${p.missing} MORE`,
  shortfall_wait: (p: { missing: string | number; wait: string | number }) => `NEEDS ¤ ${p.missing} MORE · ${p.wait}`,
};

const arcadeHistory_en: S.ArcadeHistory = {
  bot: 'BOT',
  bots: (p: { n: number }) => plural(p.n, {
    one: `${p.n} BOT`,
    other: `${p.n} BOTS`,
  }),
  copy_link: 'COPY LINK',
  draw: 'DRAW',
  empty: 'YOU HAVE PLAYED NO MATCH THAT IS STILL ON RECORD',
  failed: (p: { error: string | number }) => `YOUR MATCHES DID NOT LOAD: ${p.error}`,
  keep_days: (p: { n: number }) => plural(p.n, {
    one: `A MATCH IS KEPT ${p.n} DAY`,
    other: `A MATCH IS KEPT ${p.n} DAYS`,
  }),
  length: (p: { time: string | number }) => `LENGTH ${p.time}`,
  live: 'LIVE',
  loading: 'READING YOUR MATCHES',
  loading_more: 'READING',
  lost: 'LOST',
  more: 'MORE',
  retry: 'TRY AGAIN',
  share: 'SHARE',
  sign_in: 'SIGN IN TO KEEP A RECORD OF YOUR MATCHES',
  summary: (p: { games: string | number; won: string | number; lost: string | number }) => `${p.games} GAMES · ${p.won} WON · ${p.lost} LOST`,
  title: 'YOUR MATCHES',
  void: 'VOID',
  watch: 'WATCH',
  won: 'WON',
};

const arcadeHosting_en: S.ArcadeHosting = {
  ban: 'BAN',
  ban_armed: 'BAN?',
  bot: 'BOT',
  code: 'CODE',
  copy: 'COPY',
  cup_start: 'The match starts by itself: when every seat holds a captain, or at the set time with a bot in each empty seat.',
  delay: (p: { sec: string | number }) => `SPECTATOR DELAY ${p.sec} S`,
  delay_label: 'SPECTATOR DELAY',
  delay_unit: 'SECONDS',
  kick: 'KICK',
  kick_armed: 'KICK?',
  leave: 'LEAVE',
  leave_armed: 'END HOSTING?',
  link: 'LINK',
  map_category: 'CATEGORY',
  map_details_mode: 'MODE',
  map_details_revision: 'REVISION',
  map_details_size: 'SIZE',
  map_none: 'NO MAP IS PICKED YET',
  map_pick: 'PICK A MAP',
  observe: 'OBSERVE',
  observers: 'OBSERVERS',
  observers_none: 'NOBODY IS WATCHING',
  open: 'OPEN',
  reason_banned: 'THE GAME HOST BANNED YOU FROM THIS HOSTING',
  reason_draining: 'THE ARCADE CLOSES FOR A SHORT TIME, SO THE HOSTING IS GONE',
  reason_full: 'THAT HOSTING IS FULL',
  reason_host_left: 'THE GAME HOST LEFT, SO THE HOSTING IS GONE',
  reason_kicked: 'THE GAME HOST REMOVED YOU FROM THIS HOSTING',
  reason_no_such_code: 'NO HOSTING HOLDS THAT CODE',
  reason_not_host: 'ONLY THE GAME HOST DOES THAT',
  reason_seat_taken: 'SOMEBODY TOOK THAT SEAT FIRST',
  reason_start_failed: 'THE MATCH COULD NOT BE STARTED',
  reason_timed_out: 'THE HOSTING STOOD TOO LONG AND IS GONE',
  set_bot: 'BOT',
  set_bot_armed: 'BOT?',
  set_open: 'OPEN',
  set_open_armed: 'OPEN?',
  share: 'SHARE',
  slot: (p: { n: string | number }) => `SEAT ${p.n}`,
  start: 'START GAME',
  take: 'TAKE',
  team: (p: { n: string | number }) => `TEAM ${p.n}`,
  timeout: (p: { clock: string | number }) => `THE HOSTING ENDS IN ${p.clock}`,
  title: 'PRIVATE GAME',
  title_cup: 'CUP GAME',
  you: 'YOU',
};

const arcadeLobby_en: S.ArcadeLobby = {
  account_guest: 'GUEST',
  back_to_hub: '‹ HUB',
  back_to_tiles: 'MAIN MENU',
  board_empty: 'NO CATEGORY IS OPEN IN THE ARCADE NOW.',
  board_empty_size: (p: { n: number }) => plural(p.n, {
    one: `NO CATEGORY PLAYS A TEAM OF ${p.n} PLAYER.`,
    other: `NO CATEGORY PLAYS A TEAM OF ${p.n} PLAYERS.`,
  }),
  drill_done: '✓ DONE HERE',
  drill_done_note: '✓ DONE HERE marks a drill that this device finished.',
  drill_minutes: (p: { steps: string | number; minutes: string | number }) => `${p.steps} · about ${p.minutes} min`,
  drill_spent_note: 'No arcade run is left today. A drill uses no run, so START stays live.',
  drill_start: 'START',
  drill_steps: (p: { n: number }) => plural(p.n, {
    one: `${p.n} step`,
    other: `${p.n} steps`,
  }),
  drills_aside: (p: { n: number }) => plural(p.n, {
    one: `${p.n} drill teaches the controls and the rules of a fight, for an arcade match and for conquest. A drill uses no run and leaves no record.`,
    other: `${p.n} drills teach the controls and the rules of a fight, for an arcade match and for conquest. A drill uses no run and leaves no record.`,
  }),
  fact_depth: 'IN QUEUE',
  fact_maps: 'MAPS',
  fact_seats: 'SEATS',
  fact_seats_value: (p: { seats: string | number }) => `${p.seats} captains`,
  guest_default_note: 'A guest plays the default queue. An account picks any category.',
  guest_line: (p: { name: string | number }) => `A guest plays <b>${p.name}</b>, the default queue. An account picks any category and keeps a record.`,
  guest_upgrade: 'CREATE AN ACCOUNT',
  idle_chip: 'NOTHING QUEUED',
  idle_line: 'You are in no queue. Press JOIN on a row of the board, or QUICKJOIN.',
  idle_pick_last: 'YOUR LAST MATCH',
  play_default: (p: { name: string | number }) => `PLAY ${p.name}`,
  private_busy: 'Leave the queue first. A page in a queue or in a match hosts and joins no game.',
  private_code_bad: 'THAT IS NOT A CODE',
  private_code_ph: 'CODE',
  private_cup_line: 'A cup game opens here with its own name, CUP GAME, and starts at its set time. You press nothing to start it.',
  private_cup_title: 'A CUP GAME OF YOUR CLAN',
  private_host: 'HOST A GAME',
  private_host_line: 'You pick the map and the seats. Give the code to the captains you want.',
  private_host_title: 'HOST A GAME',
  private_join: 'JOIN',
  private_join_line: 'Type the three symbols of the code you were given.',
  private_join_title: 'JOIN A GAME',
  queue_bots_fill: (p: { clock: string | number }) => `Bots fill the empty seats in ${p.clock}.`,
  queue_conquest: 'PLAY CONQUEST',
  queue_found_building: 'LOADING THE ARENA',
  queue_found_captains: (p: { seats: string | number }) => `<b>${p.seats}</b> CAPTAINS`,
  queue_found_humans: (p: { humans: string | number }) => `<b>${p.humans}</b> HUMAN`,
  queue_found_state: 'LOADING',
  queue_found_title: 'MATCH FOUND',
  queue_guest_next: 'Try a drill, or take a world in conquest.',
  queue_hosting_note: 'The queue waits while you stand in a private game.',
  queue_hosting_title: 'PRIVATE GAME',
  queue_idle_title: 'QUEUE',
  queue_label: 'THE QUEUE',
  queue_leave: 'LEAVE QUEUE',
  queue_locked_chip: 'NO RUN LEFT',
  queue_locked_title: 'QUEUE LOCKED',
  queue_over_note: 'The lobby opens again in a moment.',
  queue_over_state: 'CLOSING',
  queue_over_title: 'MATCH OVER',
  queue_quickjoin_name: 'QUICKJOIN · EVERY QUEUE',
  queue_refused_chip: 'TRY AGAIN',
  queue_refused_title: 'JOIN REFUSED',
  queue_resume: 'RESUME THE MATCH',
  queue_running_note: 'A bot commands your fleet until you go back.',
  queue_running_state: 'YOUR SEAT PLAYS',
  queue_running_title: 'MATCH RUNNING',
  queue_searching: (p: { clock: string | number }) => `SEARCHING <b class="num">${p.clock}</b>`,
  queue_seats: 'SEATS',
  queue_waiting_title: 'IN QUEUE',
  quickjoin: 'QUICKJOIN',
  quickjoin_note: 'QUICKJOIN joins every queue. The first match that fills takes you.',
  row_account: 'ACCOUNT',
  row_depth: (p: { n: number }) => plural(p.n, {
    one: `<b>${p.n}</b> in queue`,
    other: `<b>${p.n}</b> in queue`,
  }),
  row_in_queue: 'in queue',
  row_join: 'JOIN',
  row_leave: 'LEAVE',
  row_maps: (p: { n: number }) => plural(p.n, {
    one: `<b>${p.n}</b> map`,
    other: `<b>${p.n}</b> maps`,
  }),
  runs_of: (p: { left: string | number; cap: string | number }) => `${p.left} OF ${p.cap}`,
  runs_resets: 'Runs reset at 00:00 UTC.',
  runs_resets_in: (p: { left: string | number }) => `Runs reset at 00:00 UTC, in <b class="clk">${p.left}</b>.`,
  runs_spent_reason: 'This account has no arcade run left today.',
  runs_supporter_link: 'A SUPPORTER SEAT PLAYS MORE · SHOP',
  runs_today: 'RUNS TODAY',
  runs_unlimited: 'UNLIMITED',
  seats_of: (p: { n: string | number; total: string | number }) => `${p.n} of ${p.total}`,
  sec_drills: 'DRILLS',
  sec_history: 'HISTORY',
  sec_ladder: 'LADDER',
  sec_play: 'PLAY',
  sec_private: 'PRIVATE',
  sheet_guest: 'QUEUE · GUEST',
  sheet_idle: 'QUEUE · IDLE',
  sheet_runs: (p: { runs: string | number }) => `arcade runs today: ${p.runs}`,
  sheet_spent_in: (p: { left: string | number }) => `no run left · open in ${p.left}`,
  sheet_waiting: (p: { name: string | number }) => `IN QUEUE · ${p.name}`,
  sheet_waiting_line: (p: { waited: string | number; fill: string | number }) => `searching ${p.waited} · bots fill in ${p.fill}`,
  shelf_count: (p: { n: number }) => plural(p.n, {
    one: `${p.n} VARIANT`,
    other: `${p.n} VARIANTS`,
  }),
  size_caption: 'PLAYERS PER TEAM',
  size_chip: (p: { n: number }) => plural(p.n, {
    one: `${p.n} PLAYER`,
    other: `${p.n} PLAYERS`,
  }),
  spent_band: 'No arcade run is left today, so every JOIN waits until 00:00 UTC. A drill uses no run.',
  spent_drill_line: 'A drill uses no run.',
  sum_drills_done: (p: { done: string | number; n: string | number }) => `${p.done} of ${p.n} done here`,
  sum_drills_none: 'no drill is open',
  sum_history_guest: 'an account keeps a record',
  sum_history_played: (p: { n: number }) => plural(p.n, {
    one: `${p.n} match played`,
    other: `${p.n} matches played`,
  }),
  sum_play_guest: (p: { name: string | number }) => `${p.name}, the default queue`,
  sum_play_open: (p: { n: number }) => plural(p.n, {
    one: `${p.n} category open`,
    other: `${p.n} categories open`,
  }),
  sum_play_queue: (p: { name: string | number }) => `in queue · ${p.name}`,
  sum_play_seat: 'a match holds your seat',
  sum_play_spent: 'no run left today',
  sum_play_waiting: (p: { n: number }) => plural(p.n, {
    one: `${p.n} waiting`,
    other: `${p.n} waiting`,
  }),
  sum_private_hosting: (p: { code: string | number }) => `hosting ${p.code}`,
  sum_private_none: 'no game hosted',
  tag_default: 'DEFAULT QUEUE',
  tag_last: 'LAST MATCH',
  watermark: 'ARCADE',
  wordmark: 'AQUAPHOBIA',
};

const arcadeMain_en: S.ArcadeMain = {
  catalog_failed: 'THE ARCADE MAPS DID NOT LOAD.',
  catalog_failed_reason: (p: { error: string | number }) => `THE ARCADE MAPS DID NOT LOAD: ${p.error}`,
  client_refused: (p: { reason: string | number }) => `THE ARCADE CLOSED THE LINK: ${p.reason}`,
  no_arcade: 'THE ARCADE IS NOT OPEN HERE.',
};

const arcadeMapschema_en: S.ArcadeMapschema = {
  all_rock: 'the map is all rock: there is no water to play on',
  auto_ship_class_cap: (p: { variant: string | number; hull: string | number; cap: string | number }) => `auto spawn "${p.variant}" puts a ${p.hull} to sea, and a seat holds ${p.cap}: a spawn past the cap puts nothing to sea`,
  auto_ship_period: (p: { variant: string | number; every: string | number }) => `auto spawn of "${p.variant}" every ${p.every} s must be above 0`,
  auto_ship_variant: (p: { variant: string | number }) => `auto spawn names variant "${p.variant}", which the map does not list`,
  auto_torpedo_kind: (p: { kind: string | number }) => `auto spawn names torpedo "${p.kind}", which is not a kind`,
  auto_torpedo_period: (p: { kind: string | number; every: string | number }) => `auto spawn of "${p.kind}" every ${p.every} s must be above 0`,
  base_per_slot_many: (p: { slot: string | number; count: string | number }) => `seat ${p.slot} has ${p.count} player bases, it must have exactly one`,
  base_per_slot_none: (p: { slot: string | number }) => `seat ${p.slot} has no player base`,
  base_unknown_slot: (p: { slot: string | number }) => `a player base names seat ${p.slot}, which the map does not list`,
  bit_present: 'an active map states no bit; give it the lowest bit no map holds',
  bit_range: (p: { have: string | number; max: string | number }) => `bit ${p.have} is outside 0 .. ${p.max}`,
  bit_status: (p: { status: string | number; have: string | number }) => `a ${p.status} map states the bit ${p.have}; a map no lane takes holds no bit`,
  capture_sec: (p: { value: string | number; min: string | number; max: string | number }) => `capture_sec ${p.value} must be 0 or ${p.min} to ${p.max} wall seconds: 0 means the default`,
  combat_pace: (p: { value: string | number }) => `combat_pace_divisor ${p.value} must be 0 or at least 1: combat never outruns the map`,
  credits_per_sec: (p: { value: string | number }) => `credits_per_sec ${p.value} must not be negative`,
  current_scale: (p: { value: string | number; min: string | number; max: string | number }) => `current_scale ${p.value} must be 0 or ${p.min} to ${p.max}: 0 means the default`,
  current_scale_unused: (p: { value: string | number }) => `current_scale ${p.value} does nothing: the map does not set currents`,
  currents_symmetry: 'currents and a d2 symmetry do not go together: a mirror turns the flow of the currents round',
  cut_off: 'this water is cut off from the main sea; a map has exactly one navigable component',
  den_apron: (p: { rings: string | number }) => `den stands inside an apron; a den stands outside every hold apron of ${p.rings} rings and outside ring 1 of a structure`,
  den_brotherhood: (p: { name: string | number; list: string | number }) => `den names brotherhood "${p.name}"; the brotherhoods are ${p.list}`,
  den_design: (p: { value: string | number; max: string | number }) => `den keeps design ${p.value}; a den design is 0 to ${p.max}`,
  den_wave: (p: { value: string | number; min: string | number; max: string | number }) => `den waves every ${p.value} s; wave_sec is 0 or ${p.min} to ${p.max} wall seconds: 0 means the default`,
  drill_bit: (p: { have: string | number }) => `a drill map states the bit ${p.have}; a drill writes no progress, so it holds no bit`,
  drill_bots: (p: { step: string | number; bots: string | number }) => `drill step ${p.step} sets the bots to "${p.bots}", which is not a bot mode`,
  drill_chrome: (p: { step: string | number; chrome: string | number }) => `drill step ${p.step} highlights "${p.chrome}", which is not a chrome element`,
  drill_chrome_and_spot: (p: { step: string | number }) => `drill step ${p.step} highlights a chrome element and a map spot; a drill step highlights one thing`,
  drill_count: (p: { steps: string | number; max: string | number }) => `${p.steps} drill steps, the maximum is ${p.max}`,
  drill_course_bots: (p: { step: string | number; bots: string | number }) => `drill step ${p.step} names a course, but its bots "${p.bots}" sail nowhere`,
  drill_course_cell: (p: { step: string | number }) => `drill step ${p.step} sends the bots to a course off the field or on rock`,
  drill_done: (p: { step: string | number; done: string | number }) => `drill step ${p.step} is done by "${p.done}", which is not a done check`,
  drill_done_count: (p: { step: string | number; count: string | number; done: string | number; max: string | number }) => `drill step ${p.step} counts ${p.count} for "${p.done}", outside 1 to ${p.max}`,
  drill_done_haul: (p: { step: string | number; hull: string | number }) => `drill step ${p.step} asks for a landed load, but the map lists no ${p.hull}; it is the only hull that gathers`,
  drill_done_no_count: (p: { step: string | number; count: string | number; done: string | number }) => `drill step ${p.step} counts ${p.count} for "${p.done}", which counts nothing`,
  drill_done_ping: (p: { step: string | number; hull: string | number }) => `drill step ${p.step} asks for a ping, but the map lists no ${p.hull}; it is the only hull that pings`,
  drill_done_rock: (p: { step: string | number }) => `drill step ${p.step} asks to take rock, which carries no owner`,
  drill_done_sov: (p: { step: string | number }) => `drill step ${p.step} asks to take a cell, but sov_enabled is false`,
  drill_done_spot: (p: { step: string | number; done: string | number }) => `drill step ${p.step} is done by "${p.done}", which needs a map spot`,
  drill_done_spot_rock: (p: { step: string | number; done: string | number }) => `drill step ${p.step} is done by "${p.done}", but its map spot is on rock, where no hull stands`,
  drill_goal_drill: (p: { step: string | number; drill: string | number }) => `drill step ${p.step} carries the "${p.drill}" win; a drill step carries the win of a lane`,
  drill_goal_win: (p: { step: string | number; goal: string | number }) => `drill step ${p.step} is done by "${p.goal}", which needs a win condition`,
  drill_minutes: (p: { have: string | number; max: string | number }) => `a drill map states ${p.have} minutes; a drill states the minutes a new player needs, 1 to ${p.max}`,
  drill_minutes_lane: (p: { have: string | number }) => `the map states ${p.have} minutes, but it is no drill; a lane map states none`,
  drill_order: (p: { have: string | number }) => `a drill map states the drill order ${p.have}; a drill states its place in the drill list, 1 or more`,
  drill_order_lane: (p: { have: string | number }) => `the map states the drill order ${p.have}, but it is no drill; a lane map states none`,
  drill_reset: (p: { step: string | number; reset: string | number }) => `drill step ${p.step} resets on "${p.reset}", which is not a step reset`,
  drill_reset_arrived: (p: { step: string | number; reset: string | number; bots: string | number }) => `drill step ${p.step} resets on "${p.reset}", but its bots "${p.bots}" sail nowhere`,
  drill_select: (p: { step: string | number; select: string | number }) => `drill step ${p.step} selects "${p.select}", which is no hull class of the ships of the map`,
  drill_spawn_cell: (p: { step: string | number; variant: string | number }) => `drill step ${p.step} spawns "${p.variant}" off the field`,
  drill_spawn_count: (p: { step: string | number; spawns: string | number; max: string | number }) => `drill step ${p.step} spawns ${p.spawns} hulls, the maximum is ${p.max}`,
  drill_spawn_hull: (p: { step: string | number; variant: string | number; hull: string | number }) => `drill step ${p.step} spawns "${p.variant}" with a hull of ${p.hull}; a fraction above 0 and up to 1`,
  drill_spawn_ridge: (p: { step: string | number; variant: string | number }) => `drill step ${p.step} spawns "${p.variant}" on rock`,
  drill_spawn_shield: (p: { step: string | number; variant: string | number; shield: string | number }) => `drill step ${p.step} spawns "${p.variant}" with a shield of ${p.shield}; a fraction from 0 to 1`,
  drill_spawn_slot: (p: { step: string | number; slot: string | number }) => `drill step ${p.step} spawns for seat ${p.slot}, which the map does not list`,
  drill_spawn_variant: (p: { step: string | number; variant: string | number }) => `drill step ${p.step} spawns variant "${p.variant}", which the map does not list`,
  drill_spot_cell: (p: { step: string | number }) => `drill step ${p.step} puts its map spot off the field`,
  drill_spot_radius: (p: { step: string | number; radius: string | number; max: string | number }) => `drill step ${p.step} has a map spot of ${p.radius} px, outside 1 to ${p.max}`,
  drill_step_id: (p: { step: string | number; id: string | number }) => `drill step ${p.step} has the id "${p.id}"; an id starts with a lower-case letter and holds lower-case letters, digits and "_"`,
  drill_step_id_twice: (p: { id: string | number }) => `the drill step id "${p.id}" is listed twice`,
  drill_step_text: (p: { step: string | number }) => `drill step ${p.step} names no text key`,
  drill_steps_win: (p: { type: string | number; drill: string | number }) => `the map lists drill steps, but its win condition is "${p.type}" and not "${p.drill}"`,
  drill_wait: (p: { step: string | number; wait: string | number; max: string | number }) => `drill step ${p.step} waits ${p.wait} s after its done check, outside 0 to ${p.max}`,
  drill_win_not_goal: (p: { step: string | number; done: string | number; goal: string | number }) => `drill step ${p.step} carries a win condition, but it is done by "${p.done}"; a "${p.goal}" step alone carries one`,
  drill_win_steps: 'a drill map lists no drill step',
  faction_base_sonar: (p: { sonar: string | number; max: string | number }) => `faction base hears ${p.sonar} px, outside 0 to ${p.max}`,
  faction_base_team: (p: { team: string | number; factions: string | number }) => `faction base has team ${p.team}, teams are 1 to ${p.factions}`,
  fairway_cell: (p: { chain: string | number }) => `fairway ${p.chain} names a cell off the field`,
  fairway_cell_unique: (p: { chain: string | number }) => `fairway ${p.chain} names a cell that a fairway names already`,
  fairway_count: (p: { chains: string | number; max: string | number }) => `${p.chains} fairway chains, the maximum is ${p.max}`,
  fairway_gap: (p: { chain: string | number; cell: string | number }) => `fairway ${p.chain}: cell ${p.cell} is no neighbour of the cell before it`,
  fairway_on_ridge: (p: { chain: string | number }) => `fairway ${p.chain} crosses rock or a trench; a fairway goes on open water`,
  fairway_short: (p: { chain: string | number; cells: string | number; min: string | number }) => `fairway ${p.chain} holds ${p.cells} cells, the minimum is ${p.min}`,
  field_resource: (p: { resource: string | number }) => `resource field carries "${p.resource}", which is not a resource`,
  field_units: (p: { units: string | number }) => `resource field holds ${p.units} units`,
  field_units_default: 'resource field holds no units and the map sets no resource_field_units default',
  fleet_cell: (p: { variant: string | number }) => `starting fleet "${p.variant}" is off the field`,
  fleet_class_cap: (p: { slot: string | number; count: string | number; hull: string | number; cap: string | number }) => `seat ${p.slot} starts with ${p.count} hulls of the ${p.hull}, and a seat holds ${p.cap}`,
  fleet_on_ridge: (p: { variant: string | number }) => `starting fleet "${p.variant}" sits on rock`,
  fleet_slot: (p: { slot: string | number }) => `a starting fleet names seat ${p.slot}, which the map does not list`,
  fleet_variant: (p: { variant: string | number }) => `starting fleet names variant "${p.variant}", which the map does not list`,
  grid_dims: (p: { cols: string | number; rows: string | number; min_cols: string | number; min_rows: string | number; max_cols: string | number; max_rows: string | number }) => `${p.cols} x ${p.rows} is outside ${p.min_cols} x ${p.min_rows} .. ${p.max_cols} x ${p.max_rows}`,
  guard_reach: (p: { kind: string | number; value: string | number; min: string | number; max: string | number }) => `structure "${p.kind}" keeps a reach of ${p.value} px; reach_px is 0 or ${p.min} to ${p.max}: 0 means the default`,
  guard_reach_kind: (p: { kind: string | number }) => `object "${p.kind}" sets reach_px; only a Reef Breakwater carries it`,
  guard_reload: (p: { kind: string | number; value: string | number; min: string | number; max: string | number }) => `structure "${p.kind}" reloads in ${p.value} s; reload_sec is 0 or ${p.min} to ${p.max} wall seconds: 0 means the default`,
  guard_reload_kind: (p: { kind: string | number }) => `object "${p.kind}" sets reload_sec; only a Reef Breakwater carries it`,
  laid_cell: (p: { kind: string | number }) => `laid object "${p.kind}" is off the field`,
  laid_heading: (p: { kind: string | number; heading: string | number; max: string | number }) => `laid object "${p.kind}" has heading ${p.heading}, outside 0 to ${p.max}`,
  laid_kind: (p: { kind: string | number }) => `laid object "${p.kind}" is not a kind a map may lay`,
  laid_near_base: (p: { kind: string | number }) => `laid object "${p.kind}" is inside ring 1 of a player base`,
  laid_on_object: (p: { kind: string | number }) => `laid object "${p.kind}" is on an object cell`,
  laid_on_ridge: (p: { kind: string | number }) => `laid object "${p.kind}" is on rock`,
  laid_team: (p: { kind: string | number; team: string | number }) => `laid object "${p.kind}" has team ${p.team}; a laid object is neutral (0) or belongs to a team the map seats`,
  lair_bounty: (p: { value: string | number; max: string | number }) => `lair pays a bounty of ${p.value} C; bounty is 0 or 1 to ${p.max} credits: 0 means the default`,
  lair_design: (p: { value: string | number; max: string | number }) => `lair keeps design ${p.value}; a lair design is 0 to ${p.max}`,
  lair_kind: (p: { name: string | number; list: string | number }) => `lair names monster "${p.name}"; the monsters are ${p.list}`,
  lair_respawn: (p: { value: string | number; min: string | number; max: string | number }) => `lair respawns in ${p.value} s; respawn_sec is 0 or ${p.min} to ${p.max} wall seconds: 0 means one beast a match`,
  lair_trench: 'lair stands on open water; a lair stands on a trench cell',
  marker_cell: (p: { shape: string | number }) => `marker "${p.shape}" is off the field`,
  marker_circle_heading: (p: { circle: string | number; heading: string | number }) => `a ${p.circle} marker heads ${p.heading} degrees; a circle points nowhere`,
  marker_color: (p: { color: string | number; factions: string | number }) => `marker colour ${p.color}, colours are 0 to ${p.factions}`,
  marker_count: (p: { markers: string | number; max: string | number }) => `${p.markers} markers, the maximum is ${p.max}`,
  marker_heading: (p: { heading: string | number; max: string | number }) => `marker heading ${p.heading}, headings are 0 to ${p.max}`,
  marker_shape: (p: { shape: string | number; arrow: string | number; circle: string | number }) => `marker shape "${p.shape}" is not one of "${p.arrow}" "${p.circle}"`,
  mined_credit_rate: (p: { value: string | number }) => `mined_credit_rate ${p.value} must not be negative`,
  module_duplicate: (p: { variant: string | number; family: string | number }) => `variant "${p.variant}" fits two ${p.family} modules`,
  module_family: (p: { variant: string | number; family: string | number }) => `variant "${p.variant}" fits module family "${p.family}", which does not exist`,
  module_roll: (p: { variant: string | number; family: string | number; roll: string | number; min: string | number; max: string | number }) => `variant "${p.variant}" rolls ${p.family} at ${p.roll}, outside ${p.min} to ${p.max}`,
  module_roll_invention: (p: { variant: string | number; family: string | number; roll: string | number; min: string | number; max: string | number }) => `variant "${p.variant}" rolls ${p.family} at ${p.roll}, outside the invention range ${p.min} to ${p.max}`,
  module_tier: (p: { variant: string | number; family: string | number; tier: string | number; min: string | number; max: string | number }) => `variant "${p.variant}" fits ${p.family} tier ${p.tier}, tiers are ${p.min} to ${p.max}`,
  name: 'the map has no name',
  npc_field: (p: { kind: string | number; field: string | number; owner: string | number }) => `object "${p.kind}" sets ${p.field}; only a ${p.owner} carries it`,
  object_cell: (p: { kind: string | number }) => `object "${p.kind}" is off the field`,
  object_cell_unique: 'two objects share this cell',
  object_kind: (p: { kind: string | number }) => `object kind "${p.kind}" does not exist`,
  object_on_ridge: (p: { kind: string | number }) => `object "${p.kind}" stands on rock; objects go on water`,
  objective_unused: (p: { kind: string | number; win: string | number; hold: string | number }) => `structure "${p.kind}" is an objective, but the win is "${p.win}"; only a "${p.hold}" win counts objectives`,
  player_count: (p: { seats: string | number; min: string | number; max: string | number }) => `${p.seats} seats, the map needs ${p.min} to ${p.max}`,
  player_slot_range: (p: { slot: string | number }) => `seat ${p.slot} is below 1`,
  player_slot_unique: (p: { slot: string | number }) => `seat ${p.slot} is listed twice`,
  player_team_count: (p: { teams: string | number; max: string | number }) => `${p.teams} teams, the maximum is ${p.max}`,
  player_team_range: (p: { slot: string | number; team: string | number; factions: string | number }) => `seat ${p.slot} has team ${p.team}, teams are 1 to ${p.factions}`,
  player_team_size: (p: { team: string | number; seats: string | number; max: string | number }) => `team ${p.team} has ${p.seats} seats, the maximum is ${p.max}`,
  regen_calm: (p: { value: string | number }) => `regen_calm_sec ${p.value} must not be negative: 0 means the default`,
  regen_refill: (p: { value: string | number }) => `regen_refill_sec ${p.value} must not be negative: 0 means the default`,
  resource_field_units: (p: { value: string | number }) => `resource_field_units ${p.value} must not be negative`,
  revision: (p: { have: string | number }) => `revision ${p.have} must be 1 or more`,
  scan_cooldown: (p: { value: string | number }) => `scan_cooldown_sec ${p.value} must not be negative`,
  sea_object_cap: (p: { kind: string | number; cap: string | number; max: string | number }) => `sea object "${p.kind}" has cap ${p.cap}, outside 0 to ${p.max}`,
  sea_object_kind: (p: { kind: string | number }) => `"${p.kind}" is not a sea object kind a map may sell`,
  sea_object_needs_sapper: (p: { list: string | number; kind: string | number }) => `${p.list} names "${p.kind}", but no Sapper variant is listed to lay it`,
  sea_object_price: (p: { kind: string | number; price: string | number; max: string | number }) => `sea object "${p.kind}" costs ${p.price} credits, outside 0 to ${p.max}`,
  sea_object_twice: (p: { kind: string | number }) => `sea object "${p.kind}" is listed twice`,
  settings_flat: (p: { setting: string | number }) => `${p.setting} on a map with no rock and no trench: the terrain gives the derived layer no shape`,
  ship_class: (p: { variant: string | number; hull: string | number }) => `variant "${p.variant}" names hull "${p.hull}", which is not a ship class`,
  ship_class_rule: (p: { variant: string | number; hull: string | number }) => `variant "${p.variant}" names hull "${p.hull}", which a match does not play yet`,
  ship_name_twice: (p: { variant: string | number }) => `variant "${p.variant}" is listed twice`,
  ship_no_name: (p: { hull: string | number }) => `a ${p.hull} variant has no name`,
  ship_not_buyable_price: (p: { variant: string | number; price: string | number }) => `variant "${p.variant}" is not buyable, so its price of ${p.price} credits buys nothing`,
  ship_not_buyable_unused: (p: { variant: string | number }) => `variant "${p.variant}" is not buyable and nothing references it: no auto spawn and no starting fleet`,
  ship_price: (p: { variant: string | number; price: string | number; max: string | number }) => `variant "${p.variant}" costs ${p.price} credits, outside 0 to ${p.max}`,
  ship_rounds_count: (p: { variant: string | number; count: string | number; kind: string | number }) => `variant "${p.variant}" loads ${p.count} of "${p.kind}"; a count is 1 or more`,
  ship_rounds_fits: (p: { variant: string | number; cargo: string | number; hull: string | number; room: string | number }) => `variant "${p.variant}" loads ${p.cargo} cargo of rounds, and the ${p.hull} magazine holds ${p.room}`,
  ship_rounds_kind: (p: { variant: string | number; kind: string | number; hull: string | number }) => `variant "${p.variant}" loads "${p.kind}", which hull "${p.hull}" cannot fire`,
  ship_rounds_twice: (p: { variant: string | number; kind: string | number }) => `variant "${p.variant}" loads "${p.kind}" in two rows`,
  ship_rounds_unknown: (p: { variant: string | number; kind: string | number }) => `variant "${p.variant}" loads "${p.kind}", which is not a torpedo kind`,
  ship_rounds_unsold: (p: { variant: string | number; kind: string | number }) => `variant "${p.variant}" loads "${p.kind}", but the map does not sell, grant or spawn it`,
  ship_sapper_idle: (p: { variant: string | number }) => `variant "${p.variant}" is a Sapper, but the map sells and grants no sea object`,
  ship_shield_type: (p: { variant: string | number; system: string | number; allowed: string | number }) => `variant "${p.variant}" names shield type "${p.system}", which is not one of ${p.allowed}`,
  ship_shield_type_module: (p: { variant: string | number; system: string | number }) => `variant "${p.variant}" names shield type "${p.system}" and fits no Shields module`,
  ship_stow_class: (p: { variant: string | number }) => `variant "${p.variant}" states a stow, and only a Sapper stows sea objects`,
  ship_stow_count: (p: { variant: string | number; count: string | number; kind: string | number }) => `variant "${p.variant}" stows ${p.count} of "${p.kind}"; a count is 1 or more`,
  ship_stow_fits: (p: { variant: string | number; cargo: string | number; room: string | number }) => `variant "${p.variant}" stows ${p.cargo} cargo, and the Sapper holds ${p.room}`,
  ship_stow_twice: (p: { variant: string | number; kind: string | number }) => `variant "${p.variant}" stows "${p.kind}" in two rows`,
  ship_stow_unknown: (p: { variant: string | number; kind: string | number }) => `variant "${p.variant}" stows "${p.kind}", which is not a sea object kind`,
  ship_stow_unsold: (p: { variant: string | number; kind: string | number }) => `variant "${p.variant}" stows "${p.kind}", but the map does not sell or grant it`,
  ship_weapon_type: (p: { variant: string | number; system: string | number; allowed: string | number }) => `variant "${p.variant}" names weapon type "${p.system}", which is not one of ${p.allowed}`,
  ship_weapon_type_module: (p: { variant: string | number; system: string | number }) => `variant "${p.variant}" names weapon type "${p.system}" and fits no Weapon module`,
  ships_present: 'the map lists no ship, no auto spawn and no starting fleet: nobody can act',
  sov_cell: 'painted cell is off the field',
  sov_cell_unique: 'the cell is painted twice',
  sov_on_ridge: 'rock carries no owner',
  sov_requires_enabled: (p: { cells: string | number }) => `the map paints ${p.cells} starting cells but sov_enabled is false`,
  sov_team: (p: { team: string | number; factions: string | number }) => `painted team ${p.team}, teams are 1 to ${p.factions}`,
  starting_credits: (p: { value: string | number }) => `starting_credits ${p.value} must not be negative`,
  starting_sea_object_count: (p: { count: string | number; kind: string | number; max: string | number }) => `starting sea objects grant ${p.count} of "${p.kind}", outside 1 to ${p.max}`,
  starting_sea_object_kind: (p: { kind: string | number }) => `starting sea objects name "${p.kind}", which is not a sea object kind a map may sell`,
  starting_sea_object_twice: (p: { kind: string | number }) => `starting sea object "${p.kind}" is listed twice`,
  starting_torpedo_count: (p: { count: string | number; kind: string | number; max: string | number }) => `starting torpedoes grant ${p.count} of "${p.kind}", outside 1 to ${p.max}`,
  starting_torpedo_kind: (p: { kind: string | number }) => `starting torpedoes name "${p.kind}", which is not a torpedo kind`,
  starting_torpedo_no_carrier: (p: { kind: string | number }) => `starting torpedoes grant "${p.kind}", but no listed hull loads it and no base can fire it`,
  starting_torpedo_twice: (p: { kind: string | number }) => `starting torpedo "${p.kind}" is listed twice`,
  status: (p: { have: string | number; allowed: string | number }) => `status "${p.have}" is not one of ${p.allowed}`,
  structure_flag: (p: { kind: string | number; flag: string | number }) => `object "${p.kind}" sets ${p.flag}; only a structure carries it`,
  structure_objective: (p: { kind: string | number }) => `structure "${p.kind}" is an objective that is not capturable; an objective must change hands`,
  structure_team: (p: { kind: string | number; team: string | number }) => `structure "${p.kind}" has team ${p.team}; a structure is neutral (0) or belongs to a team the map seats`,
  symmetry_at: (p: { kind: string | number; allowed: string | number; at: string | number }) => `a ${p.kind} symmetry turns about one of ${p.allowed}, not "${p.at}"`,
  symmetry_base: (p: { slot: string | number; image: string | number; element: string | number }) => `the base of seat ${p.slot} maps onto cell ${p.image} under ${p.element}, which holds no player base`,
  symmetry_centre_need: (p: { kind: string | number }) => `a ${p.kind} symmetry states its centre cell and its at`,
  symmetry_centre_none: (p: { kind: string | number }) => `a ${p.kind} symmetry turns about the grid centre and states no centre`,
  symmetry_centre_off: (p: { cell: string | number }) => `the symmetry centre ${p.cell} is off the field`,
  symmetry_centre_pair: 'a symmetry states its centre and its at together, or neither',
  symmetry_fairway: (p: { image: string | number; element: string | number }) => `the fairway cells differ from the fairway cells of cell ${p.image} under ${p.element}`,
  symmetry_fleet: (p: { image: string | number; element: string | number }) => `the starting fleets differ from the starting fleets of cell ${p.image} under ${p.element}`,
  symmetry_kind: (p: { kind: string | number; allowed: string | number }) => `symmetry kind "${p.kind}" is not one of ${p.allowed}`,
  symmetry_laid: (p: { image: string | number; element: string | number }) => `the laid objects differ from the laid objects of cell ${p.image} under ${p.element}`,
  symmetry_marker: (p: { image: string | number; element: string | number }) => `the markers differ from the markers of cell ${p.image} under ${p.element}`,
  symmetry_object: (p: { image: string | number; element: string | number }) => `the object differs from the object of cell ${p.image} under ${p.element}`,
  symmetry_required: (p: { category: string | number }) => `an active map of the category ${p.category} states its symmetry`,
  symmetry_rows: (p: { kind: string | number; rows: string | number }) => `a ${p.kind} symmetry needs an odd row count, the map has ${p.rows}`,
  symmetry_sov: (p: { image: string | number; element: string | number }) => `the starting owner differs from the starting owner of cell ${p.image} under ${p.element}`,
  symmetry_team: (p: { element: string | number; team: string | number }) => `under ${p.element} the seats of team ${p.team} do not map onto the seats of one team`,
  symmetry_terrain: (p: { image: string | number; element: string | number }) => `the terrain differs from cell ${p.image} under ${p.element}`,
  symmetry_unpaired: (p: { element: string | number }) => `this cell has no partner under ${p.element}; an unpaired cell must be rock`,
  symmetry_win_cell: (p: { image: string | number; element: string | number }) => `the win cell maps onto cell ${p.image} under ${p.element}; it must stand on the centre of the symmetry`,
  tactical_scale: (p: { value: string | number }) => `tacticalscale ${p.value} must not be negative`,
  terrain_char: (p: { char: string | number; water: string | number; ridge: string | number; trench: string | number }) => `terrain character "${p.char}" is not one of "${p.water}" "${p.ridge}" "${p.trench}"`,
  terrain_row_count: (p: { have: string | number; rows: string | number }) => `terrain has ${p.have} rows, the grid has ${p.rows}`,
  terrain_row_width: (p: { row: string | number; chars: string | number; cols: string | number }) => `terrain row ${p.row} is ${p.chars} characters, the grid is ${p.cols} wide`,
  timeout: (p: { value: string | number }) => `timeout_sec ${p.value} must be above 0: every match ends`,
  timescale: (p: { value: string | number }) => `timescale ${p.value} must be above 0`,
  torpedo_base_only: (p: { kind: string | number }) => `torpedo "${p.kind}" is a base round, but the map does not set base_can_fire_torpedoes`,
  torpedo_kind: (p: { kind: string | number }) => `"${p.kind}" is not a torpedo kind`,
  torpedo_needs_load: (p: { list: string | number; kind: string | number }) => `${p.list} names "${p.kind}", which AUTO never loads, and no variant names it in its rounds`,
  torpedo_no_carrier: (p: { kind: string | number }) => `torpedo "${p.kind}" is on sale but no listed hull can load it`,
  torpedo_price: (p: { kind: string | number; price: string | number; max: string | number }) => `torpedo "${p.kind}" costs ${p.price} credits, outside 0 to ${p.max}`,
  torpedo_twice: (p: { kind: string | number }) => `torpedo "${p.kind}" is listed twice`,
  version: (p: { have: string | number; want: string | number }) => `schema version ${p.have}, this build reads ${p.want}`,
  win_class: (p: { hull: string | number }) => `win condition names hull "${p.hull}", which is not a ship class`,
  win_count: (p: { count: string | number; max: string | number }) => `${p.count} win conditions, v1 maps carry exactly ${p.max}`,
  win_hold_structures_count: (p: { count: string | number }) => `hold_structures count ${p.count} must be above 0`,
  win_hold_structures_hold: (p: { hold: string | number }) => `hold_structures hold_sec ${p.hold} must not be negative`,
  win_hold_structures_objectives: (p: { count: string | number; have: string | number }) => `hold_structures asks for ${p.count} objectives, the map places ${p.have}`,
  win_kill_class_count: (p: { count: string | number }) => `kill_class count ${p.count} must be above 0`,
  win_kills_count: (p: { count: string | number }) => `kills count ${p.count} must be above 0`,
  win_means: (p: { means: string | number; any: string | number; ship: string | number; torpedo: string | number }) => `means "${p.means}" is not one of "${p.any}" "${p.ship}" "${p.torpedo}"`,
  win_mine_field: 'a mine map must place at least one resource field',
  win_mine_hull: (p: { hull: string | number }) => `a mine map must list a gathering hull; only the ${p.hull} works a deposit`,
  win_mine_units: (p: { units: string | number }) => `mine units ${p.units} must be above 0`,
  win_scan_class_count: (p: { count: string | number }) => `scan_class count ${p.count} must be above 0`,
  win_scan_hull: (p: { hull: string | number }) => `a scan_class map must unlock the ${p.hull}; it is the only hull that scans`,
  win_sov_cell_hold: (p: { hold: string | number }) => `sov_cell hold_sec ${p.hold} must not be negative`,
  win_sov_cell_off: 'sov_cell names a cell off the field',
  win_sov_cell_rock: 'sov_cell names rock, which carries no owner',
  win_sov_enabled: (p: { kind: string | number }) => `a ${p.kind} map must set sov_enabled`,
  win_sov_share_hold: (p: { hold: string | number }) => `sov_share hold_sec ${p.hold} must not be negative`,
  win_sov_share_percent: (p: { percent: string | number }) => `sov_share percent ${p.percent} must be above 0 and at most 100`,
  win_type: (p: { type: string | number }) => `win condition "${p.type}" does not exist`,
};

const arcadeMatch_en: S.ArcadeMatch = {
  aim_bearing: 'lead the contact — the round runs out of fuel where you aim',
  aim_in_reach: (p: { reach: string | number; range: string | number }) => `${p.reach} of ${p.range} px`,
  aim_out_of_reach: (p: { over: string | number }) => `${p.over} px out of reach`,
  aim_seeker: 'press a contact to lock, or water to run a bearing',
  aim_title: 'Firing solution',
  base_all_reloading: (p: { wait: string | number }) => `every tube is reloading — ${p.wait}s`,
  base_round: (p: { round: string | number }) => `${p.round} round from your base`,
  base_tubes_ready: (p: { free: number }) => plural(p.free, {
    one: `${p.free} tube ready`,
    other: `${p.free} tubes ready`,
  }),
  deposit_amount: (p: { amount: string | number }) => `≈ ${p.amount} units`,
  deposit_nothing_left: 'nothing left to cut',
  deposit_send_hauler: 'send a hauler to work it',
  deposit_worked_out: 'worked out',
  open_sea_title: 'Open sea',
  ridge_line: 'rock — impassable',
  ridge_title: 'Ridge',
  score_goal: (p: { percent: string | number }) => `GOAL ${p.percent}%`,
  score_goal_title: 'The share of the sea that wins the match',
  site_base: 'base',
  site_own_base: 'your base',
  territory_title: 'Territory',
  water_base_safe: 'bases cannot be taken',
  water_beam: (p: { faction: string | number; gauge: string | number }) => `${p.faction} beam — ${p.gauge}% taken`,
  water_object_tile: 'this tile belongs to the object — take the object',
  water_owned: (p: { faction: string | number }) => `${p.faction} sovereignty`,
  water_trench: 'trench — half speed, half noise',
  water_unclaimed: 'unclaimed water',
};

const arcadeMoments_en: S.ArcadeMoments = {
  beat_words: ['3', '2', '1', 'FIGHT'],
  col_captain: 'CAPTAIN',
  col_cells: 'CELLS',
  col_kills: 'KILLS',
  col_losses: 'LOSSES',
  col_mined: 'MINED',
  col_scans: 'SCANS',
  col_team: 'TEAM',
  input_locked: 'INPUT LOCKED · <u>SCROLL AND ZOOM ARE FREE</u>',
  kind_over: 'MATCH OVER',
  kind_replay: 'REPLAY',
  led_ground: 'held the ground',
  led_kill_class: (p: { hull_class: string | number }) => `sank the most ${p.hull_class} hulls`,
  led_kills: 'took the most kills',
  led_mined: 'mined the most units',
  led_objectives: 'held the most objectives',
  led_scan_class: (p: { hull_class: string | number }) => `found the most ${p.hull_class} hulls`,
  led_sea: 'held the most of the sea',
  load_grace_label: 'GRACE',
  load_note: 'The match starts when every captain is in, or when the grace ends.',
  load_title: 'LOADING THE ARENA',
  reason_draw_all_sank: 'every fleet went down',
  reason_hold_structures: (p: { team: string | number }) => `${p.team} has held the objectives`,
  reason_kill_class: (p: { team: string | number; hulls: string | number }) => `${p.team} has sunk ${p.hulls}`,
  reason_kills: (p: { team: string | number; kills: string | number }) => `${p.team} has taken ${p.kills}`,
  reason_last_fleet: (p: { team: string | number }) => `${p.team} is the last fleet on the water`,
  reason_mined: (p: { team: string | number; units: string | number }) => `${p.team} has mined ${p.units}`,
  reason_scan_class: (p: { team: string | number; hulls: string | number }) => `${p.team} has found ${p.hulls}`,
  reason_sov_cell: (p: { team: string | number }) => `${p.team} has held the ground`,
  reason_sov_share: (p: { team: string | number; percent: string | number }) => `${p.team} holds ${p.percent}% of the sea`,
  reason_surrender: (p: { team: string | number }) => `${p.team} surrendered`,
  reason_surrender_you: 'You surrendered',
  reason_surrender_your_team: 'Your team surrendered',
  reason_time_ran_out: 'time ran out',
  reason_time_ran_out_leader: (p: { team: string | number; led: string | number }) => `time ran out — ${p.team} ${p.led}`,
  seat_bot: 'BOT',
  seat_in: 'IN',
  seat_loading: 'LOADING',
  seat_unnamed: (p: { slot: string | number }) => `SEAT ${p.slot}`,
  seat_you: (p: { name: string | number }) => `YOU · ${p.name}`,
  start_title: 'STARTING IN',
  summary_achievements: 'ACHIEVEMENTS',
  summary_again: 'PLAY AGAIN',
  summary_captains: (p: { count: string | number }) => `${p.count} CAPTAINS`,
  summary_exit: 'LOBBY',
  summary_played: (p: { clock: string | number }) => `${p.clock} PLAYED`,
  verdict_draw: 'DRAW',
  verdict_lose: 'YOU LOST',
  verdict_win: 'YOU WON',
  viewer_again: 'WATCH AGAIN',
  viewer_arcade: 'PLAY THE ARCADE',
  viewer_share: 'SHARE',
  viewer_won_name: (p: { name: string | number }) => `${p.name} WON`,
  viewer_won_team: (p: { team: string | number }) => `${p.team} WON`,
};

const arcadeStructures_en: S.ArcadeStructures = {
  capturable: 'capturable: one team alone in the ring takes it',
  effect_battery_owned: 'Fires at the enemy hulls its own ear hears.',
  effect_battery_public: 'Fires at every hull its own ear hears.',
  effect_breakwater_owned: (p: { team: string | number }) => `Takes one round of another team out of the water every reload, inside its reach, for ${p.team}.`,
  effect_breakwater_public: 'Serves every team: takes one round of any team out of the water every reload, inside its reach.',
  effect_idle: 'No effect until a team takes it.',
  effect_spire_owned: (p: { team: string | number }) => `Gives sonar to ${p.team}.`,
  effect_spire_public: 'Serves every team: sonar for every team.',
  effect_throne: 'No effect. It counts for the win alone.',
  effect_ward_owned: (p: { team: string | number }) => `Mends the hulls of ${p.team} in its aura.`,
  effect_ward_public: 'Serves every team: mends every hull in its aura.',
  f_capture: 'CAPTURE',
  f_owner: 'OWNER',
  f_reach: 'REACH',
  f_taking: 'TAKING',
  fixed: 'fixed: no team takes it',
  guard_label: 'intercept',
  kind_battery: 'DEEP BATTERY',
  kind_breakwater: 'REEF BREAKWATER',
  kind_spire: 'RELAY SPIRE',
  kind_throne: 'TRENCH THRONE',
  kind_ward: 'CORAL WARD',
  objective: 'OBJECTIVE',
  objectives_heading: 'OBJECTIVES HELD',
  owner_neutral: 'NEUTRAL',
  reach: (p: { px: string | number; sec: string | number }) => `${p.px} px · one round every ${p.sec} s`,
  taking: (p: { team: string | number; sec: string | number }) => `${p.team} takes it in ${p.sec} s`,
};

const arcadeViewer_en: S.ArcadeViewer = {
  back: 'BACK 10 SECONDS',
  bad_format: 'THIS BUILD CANNOT READ THIS RECORD',
  channel_credits: (p: { name: string | number; credits: string | number }) => `${p.name}, ${p.credits} credits`,
  copy_link: 'COPY LINK',
  exit: 'EXIT',
  film_title: 'the place in the film and the length of the match',
  forward: 'FORWARD 10 SECONDS',
  go_live: 'GO TO THE LIVE EDGE',
  group_channels: 'WHAT IT SHOWS',
  group_transport: 'THE FILM',
  inputs: 'PRESSES',
  inputs_title: 'SHOW WHAT THE SEATS PRESSED',
  key_back: 'back ten seconds',
  key_exit: 'leave the viewer',
  key_faster: 'play faster',
  key_forward: 'forward ten seconds',
  key_inputs: 'show what the seats pressed',
  key_keys: 'show this key sheet',
  key_last: 'to the end of the record; in the watch strip, the last channel',
  key_live: 'go to the live edge',
  key_next_keyframe: 'the keyframe after',
  key_omniscient: 'watch all sides',
  key_play: 'play / pause',
  key_prev_keyframe: 'the keyframe before',
  key_restart: 'back to the first fight tick; in the watch strip, the first channel',
  key_seat: 'watch that seat',
  key_slower: 'play slower',
  key_step_back: 'back ten seconds; in the watch strip, the channel before',
  key_step_forward: 'forward ten seconds; in the watch strip, the channel after',
  live: 'LIVE',
  loading: 'READING THE RECORD',
  omni: 'ALL SIDES',
  past_failed: 'THE PAST OF THIS MATCH DID NOT ARRIVE',
  past_none: 'THE PAST OF THIS MATCH IS NOT ON RECORD HERE',
  past_too_large: 'THE PAST OF THIS MATCH IS TOO LARGE TO FETCH',
  pause: 'PAUSE',
  play: 'PLAY',
  restart: 'RESTART',
  scrub: 'PLACE IN THE MATCH',
  share: 'SHARE',
  show: 'SHOW',
  speed: 'SPEED',
  tag_live: 'LIVE',
  tag_replay: 'REPLAY',
  watching: (p: { who: string | number }) => `WATCHING ${p.who}`,
  with_key: (p: { name: string | number; key: string | number }) => `${p.name} (${p.key})`,
};

const arcadeWinline_en: S.ArcadeWinline = {
  class_or: (p: { rest: string | number; last: string | number }) => `${p.rest} or ${p.last}`,
  class_sep: ', ',
  hold_clause: (p: { hold: string | number }) => ` and hold it ${p.hold}`,
  hold_minutes: (p: { count: number }) => plural(p.count, {
    one: `${p.count} minute`,
    other: `${p.count} minutes`,
  }),
  hold_minutes_range: (p: { high: number; low: string | number }) => plural(p.high, {
    one: `${p.low}–${p.high} minute`,
    other: `${p.low}–${p.high} minutes`,
  }),
  hold_seconds: (p: { count: number }) => plural(p.count, {
    one: `${p.count} second`,
    other: `${p.count} seconds`,
  }),
  hold_seconds_range: (p: { high: number; low: string | number }) => plural(p.high, {
    one: `${p.low}–${p.high} second`,
    other: `${p.low}–${p.high} seconds`,
  }),
  hulls: (p: { count: number; hull_class: string | number }) => plural(p.count, {
    one: `${p.count} ${p.hull_class} hull`,
    other: `${p.count} ${p.hull_class} hulls`,
  }),
  hulls_range: (p: { high: number; hull_class: string | number; low: string | number }) => plural(p.high, {
    one: `${p.low}–${p.high} ${p.hull_class} hull`,
    other: `${p.low}–${p.high} ${p.hull_class} hulls`,
  }),
  kills: (p: { count: number }) => plural(p.count, {
    one: `${p.count} kill`,
    other: `${p.count} kills`,
  }),
  kills_range: (p: { high: number; low: string | number }) => plural(p.high, {
    one: `${p.low}–${p.high} kill`,
    other: `${p.low}–${p.high} kills`,
  }),
  means_ship: ' with a ship',
  means_torpedo: ' with a torpedo',
  range: (p: { low: string | number; high: string | number }) => `${p.low}–${p.high}`,
  units: (p: { count: number }) => plural(p.count, {
    one: `${p.count} unit`,
    other: `${p.count} units`,
  }),
  units_range: (p: { high: number; low: string | number }) => plural(p.high, {
    one: `${p.low}–${p.high} unit`,
    other: `${p.low}–${p.high} units`,
  }),
  win_drill: 'Do every drill step.',
  win_hold_structures: (p: { count: number; hold: string | number }) => plural(p.count, {
    one: `Take ${p.count} objective and hold it ${p.hold}.`,
    other: `Take ${p.count} objectives and hold them ${p.hold}.`,
  }),
  win_hold_structures_now: (p: { count: number }) => plural(p.count, {
    one: `Take ${p.count} objective.`,
    other: `Take ${p.count} objectives.`,
  }),
  win_hold_structures_range: (p: { high: number; hold: string | number; low: string | number }) => plural(p.high, {
    one: `Take ${p.low}–${p.high} objective and hold it ${p.hold}.`,
    other: `Take ${p.low}–${p.high} objectives and hold them ${p.hold}.`,
  }),
  win_hold_structures_range_now: (p: { high: number; low: string | number }) => plural(p.high, {
    one: `Take ${p.low}–${p.high} objective.`,
    other: `Take ${p.low}–${p.high} objectives.`,
  }),
  win_kill_all: 'Sink every enemy fleet.',
  win_kill_class: (p: { hulls: string | number; means: string | number }) => `Sink ${p.hulls}${p.means}.`,
  win_kills: (p: { kills: string | number; means: string | number }) => `Take ${p.kills}${p.means}.`,
  win_mine: (p: { units: string | number }) => `Mine ${p.units}.`,
  win_scan_class: (p: { hulls: string | number }) => `Find ${p.hulls} with an active ping.`,
  win_sov_cell: (p: { hold: string | number }) => `Take the marked ground${p.hold}.`,
  win_sov_share: (p: { percent: string | number; hold: string | number }) => `Take ${p.percent}% of the sea${p.hold}.`,
};

const banner_en: S.Banner = {
  bar_day: (p: { day: string | number }) => `day ${p.day}`,
  foot_remaining: (p: { left: string | number }) => `${p.left} remaining`,
  gauge_season: 'Season',
  hero_season: (p: { season: string | number }) => `Season ${p.season}`,
  remaining: 'remaining',
};

const battlelab_en: S.Battlelab = {
  add_fleet: 'ADD FLEET',
  add_fleet_of: (p: { n: string | number; max: string | number }) => `${p.n} OF ${p.max}`,
  arena: 'arena',
  arena_note: 'The map, the object and its gauge. homeWater and objectsHeld set the defender\'s edge.',
  arena_pick: (p: { seed: string | number; object: string | number; gauge: string | number; pace: string | number }) => `seed ${p.seed} · ${p.object} · gauge ${p.gauge} · ${p.pace}`,
  attack_won: 'THE ATTACK WINS',
  attack_won_short: 'the attack wins',
  batch_kicker: (p: { runs: string | number; first: string | number; last: string | number }) => `fight ×${p.runs} maps · world seeds ${p.first}–${p.last}`,
  battle_plan: 'battle plan',
  before: (p: { pct: string | number }) => `before ${p.pct} %`,
  before_title: 'the tally before this one, on this page',
  behaviour: 'what the fleet does in the fight',
  behaviour_engage: 'ENGAGE',
  behaviour_flank: 'FLANK',
  behaviour_hold: 'HOLD',
  build_price_title: 'what the hulls of this row cost to build, modules included',
  captain: 'captain',
  captain_title: 'a captain aboard',
  captured: 'captured',
  col_dealt: 'dealt',
  col_name: 'fleet',
  col_out: 'out',
  col_shield: 'shield',
  col_taken: 'taken',
  column_hide: 'HIDE COLUMN',
  column_hint: 'the stage takes the width',
  column_show: 'SHOW COLUMN',
  copy: 'COPY',
  copy_link: 'COPY LINK',
  copy_link_title: 'copy a link to this scenario',
  copy_title: 'add a copy of this fleet',
  count: 'how many equal fleets this row stands for',
  damage_ratio: 'damage ratio',
  dealt: 'dealt',
  defaults: 'DEFAULTS',
  defaults_hint: 'the engine\'s scenario',
  defence_held: 'THE DEFENCE HOLDS',
  defence_held_short: 'the defence holds',
  defender_edge: 'defender\'s edge',
  dice_title: 'a random seed',
  duration: 'duration',
  duration_value: (p: { s: string | number }) => `${p.s} map s`,
  edge_value: (p: { edge: string | number }) => `×${p.edge}`,
  engine_loading: 'the battle engine loads…',
  engine_missing: (p: { why: string | number }) => `no battle engine: run scripts/build-battlelab-wasm.sh, then load the page again (${p.why})`,
  engine_ready: 'the battle engine is ready',
  export_hint: 'every preset, as one file',
  fight: 'FIGHT',
  fight_many: (p: { runs: string | number }) => `FIGHT ×${p.runs} MAPS`,
  fight_many_title: (p: { runs: string | number }) => `fight the scenario on ${p.runs} maps: the world seed of the arena and the next seeds`,
  fit: 'fit',
  fleet_changed_title: 'this fleet differs from the default',
  fleet_kind: (p: { side: string | number; hull: string | number; role: string | number }) => `${p.side} · ${p.hull} · ${p.role}`,
  fleet_title: 'open this fleet',
  gauge: 'the gauge when the window opens',
  gauge_label: 'gauge',
  gauge_value: (p: { before: string | number; after: string | number }) => `${p.before} → ${p.after}`,
  home_water: 'the object stands in the water of the defence',
  hull: 'the hull class',
  hull_pct: 'the hull at the start, in percent',
  hull_refused: (p: { hull: string | number }) => `${p.hull} · the pledge refuses a support hull`,
  import_hint: 'add the presets of a file',
  key_column: 'hide or show the column',
  key_fight: 'run one window battle and play the film',
  key_many: 'fight the scenario on many maps',
  key_watch: 'play the film of the last fight again',
  keys: 'keys',
  kicker: (p: { object: string | number; seed: string | number }) => `battle report · ${p.object} · seed ${p.seed}`,
  legend_foot: (p: { gauge: string | number; edge: string | number }) => `gauge ${p.gauge} · edge ×${p.edge}`,
  legend_side: (p: { side: string | number; faction: string | number }) => `${p.side} · ${p.faction}`,
  legend_title: (p: { object: string | number }) => `${p.object} · the last run`,
  mean_duration: 'mean duration',
  mean_gauge_hit: 'mean gauge hit',
  menu_file: 'presets',
  menu_run: 'run',
  menu_view: 'view',
  module_add_title: 'fit this module',
  module_remove_title: 'take this module off',
  modules: 'modules',
  modules_value: (p: { on: string | number; max: string | number }) => `${p.on} of ${p.max} slots`,
  name: 'the name of the fleet',
  no: 'no',
  no_renderer: 'this browser gives no WebGPU and no WebGL2, so the lab cannot show the fight',
  none: 'none',
  notice_import_bad: (p: { file: string | number }) => `${p.file} is no preset file of the battle lab`,
  notice_imported: (p: { count: number }) => plural(p.count, {
    one: `${p.count} preset imported`,
    other: `${p.count} presets imported`,
  }),
  notice_link: 'the link is on the clipboard',
  notice_loaded: (p: { name: string | number }) => `${p.name} loaded`,
  notice_no_name: 'type a name first',
  notice_saved: (p: { name: string | number }) => `saved ${p.name}`,
  notice_storage_refused: 'the browser refused the preset',
  object: 'the strategic object',
  objects_held: 'the strategic objects the defence holds',
  out_sunk: 'SUNK',
  out_withdrew: 'WITHDREW',
  pace: 'the combat pace of the mode',
  pace_core: 'core',
  pace_event: 'event',
  pace_value: (p: { pace: string | number; divisor: string | number }) => `${p.pace} ÷${p.divisor}`,
  position: 'the place in the line',
  position_centre: 'CENTRE',
  position_front: 'FRONT',
  position_rear: 'REAR',
  preset_delete: 'DELETE',
  preset_delete_sure: 'DELETE?',
  preset_export: 'EXPORT',
  preset_import: 'IMPORT',
  preset_load: 'LOAD',
  preset_name: 'name',
  preset_none: 'no preset yet',
  preset_save: 'SAVE',
  presets: 'presets',
  presets_pick: (p: { count: string | number }) => `${p.count} saved`,
  remove: 'REMOVE',
  remove_title: 'remove this fleet',
  report: 'report',
  report_none: (p: { runs: string | number }) => `No fight yet. FIGHT writes the battle report here, and FIGHT ×${p.runs} MAPS writes the tally.`,
  report_pick: (p: { ms: string | number }) => `the last run · ${p.ms} ms`,
  roll_title: 'the invention roll of this module',
  rounds: 'the torpedoes aboard',
  row_title: (p: { label: string | number; value: string | number }) => `${p.label} · default ${p.value}`,
  run_failed: (p: { error: string | number }) => `the run failed: ${p.error}`,
  running: 'the window battle runs…',
  running_many: (p: { runs: string | number }) => `the window battle runs on ${p.runs} maps…`,
  seats: 'the seat count',
  seed: 'the world seed',
  sentence_captured: (p: { before: string | number; after: string | number }) => `The gauge fell from ${p.before} to ${p.after}, so the object changed owner.`,
  sentence_fell: (p: { before: string | number; after: string | number }) => `The gauge fell from ${p.before} to ${p.after}.`,
  sentence_held: (p: { before: string | number }) => `The gauge stayed at ${p.before}.`,
  sentence_out: 'Every attacking fleet withdrew or sank, so the gauge did not move.',
  sentence_rose: (p: { before: string | number; after: string | number }) => `The gauge rose from ${p.before} to ${p.after}.`,
  sheet_arena: (p: { seed: string | number; object: string | number; attack: string | number; defence: string | number }) => `seed ${p.seed} · ${p.object} · ${p.attack} against ${p.defence} fleets`,
  sheet_tally: (p: { wins: string | number; runs: string | number }) => `${p.wins} of ${p.runs}`,
  sheet_verdict: (p: { ratio: string | number; before: string | number; after: string | number }) => `${p.ratio} · ${p.before} → ${p.after}`,
  shield: 'the shield type',
  shield_pct: 'the shield at the start, in percent',
  side_attack: 'ATTACK',
  side_defence: 'DEFENCE',
  side_group: (p: { side: string | number; faction: string | number }) => `${p.side} · ${p.faction}`,
  side_note: (p: { fleets: string | number; hulls: string | number }) => `fleets ${p.fleets} · hulls ${p.hulls} · a press on a row opens the fleet`,
  side_note_run: (p: { faction: string | number; fleets: string | number; hulls: string | number }) => `${p.faction} in the last run · fleets ${p.fleets} · hulls ${p.hulls}`,
  side_pick: (p: { fleets: string | number; hulls: string | number }) => `fleets ${p.fleets} · hulls ${p.hulls}`,
  start_state: 'start state',
  status_last: (p: { seed: string | number; object: string | number; verdict: string | number }) => `the battle engine is ready · last run <b>seed ${p.seed}</b> · ${p.object} · ${p.verdict}`,
  status_many: (p: { runs: string | number; wins: string | number }) => `the window battle ran on ${p.runs} maps · <b>${p.wins} of ${p.runs}</b> for the attack`,
  storage_off: 'this browser keeps no preset, because the storage is off',
  tactical_scale: 'the map clock the film plays at; it moves no outcome',
  tag_captain: 'CAPT',
  tag_torpedo: (p: { n: string | number }) => `TORP ${p.n}`,
  tech: 'tech',
  tech_none: 'none',
  tech_of: (p: { all: string | number }) => `of ${p.all} nodes`,
  tech_title: 'the tech nodes the side has researched; a press opens the list',
  tech_value: (p: { on: string | number; all: string | number }) => `${p.on} of ${p.all} nodes`,
  title: 'BATTLE LAB',
  torpedo: 'the torpedo kind',
  torpedo_auto: 'none or auto',
  versus: 'vs',
  viewer_fallback: 'battle lab',
  watch: 'WATCH',
  watch_off_title: 'no fight yet: press FIGHT first',
  weapon: 'the weapon type',
  win_rate_sub: (p: { wins: string | number; runs: string | number }) => `attack win rate · ${p.wins} of ${p.runs}`,
  win_rate_value: (p: { pct: string | number }) => `${p.pct} %`,
  yes: 'yes',
};

const brandart_en: S.Brandart = {
  card_12: 'THE DEEP ICON',
  card_16: 'HEADER LOCKUP',
  card_17: 'STACKED LOCKUP',
  card_19: 'SHARE CARD',
  card_20: 'DISCORD IMAGE',
  card_21: 'SOCIAL HEADER',
  card_22: 'CHANNEL ART',
  card_23: 'SEASON IMAGE',
  card_28: 'LAUNCH IMAGES',
  card_29: 'MARK IN MOTION',
  card_live_deep_drift: 'LIVE WALLPAPER · THE DEEP · DRIFT',
  card_live_deep_pulse: 'LIVE WALLPAPER · THE DEEP · PULSE',
  card_live_deep_sweep: 'LIVE WALLPAPER · THE DEEP · SWEEP',
  card_live_ping_pulse: 'LIVE WALLPAPER · THE PING · PULSE',
  card_live_ping_sweep: 'LIVE WALLPAPER · THE PING · SWEEP',
  card_wall_chart: 'WALLPAPER · THE CHART',
  card_wall_deep: 'WALLPAPER · THE DEEP',
  card_wall_ping: 'WALLPAPER · THE PING',
  check_leaves: (p: { what: string | number; guide: string | number }) => `${p.what} leaves the area ${p.guide}.`,
  check_ok: 'The sign, the name and the lines stay inside every crop and safe area, and clear of every covered area.',
  check_touches: (p: { what: string | number; guide: string | number }) => `${p.what} touches the area ${p.guide}.`,
  desc_12: 'The sign glows in deep water, under light from the surface and a faint grid of the map. The icon fills the square, and a launcher cuts the corners. The press kit offers it.',
  desc_16: 'The sign and the name side by side, as the headers of the chrome set them. A small file for a web page and a large file for print, each on a transparent ground and on the ink. Each file holds the clear space of the lockup.',
  desc_17: 'The sign above the name, for a launch image, a share card and an article. A small file and a large file, each on a transparent ground and on the ink. Each file holds the clear space of the lockup.',
  desc_19: 'The picture that a chat or a feed shows under a link to the game. The stacked lockup stays inside the 2:1 crop of a large card and inside the centred square that some messengers cut.',
  desc_20: 'The image at the top of the channel list of the Discord server. Discord writes the server name over its upper part, so the lockup stays under that band.',
  desc_21: 'The profile header of a social network. The lockup stays clear of the avatar at the lower left and inside the telephone crop. Both guides are estimates: check them on each network.',
  desc_22: 'The header picture of a video channel. A television shows all of it, a desktop shows the middle band, and every device shows the safe area in the middle of the band, so the lockup stays there.',
  desc_23: 'The picture that announces a season in Discord, in a feed or on the landing screen. Type the season number and the name, then save. The game gives a season no name, so the sample takes the name of a world.',
  desc_28: 'The picture iOS shows while the game starts from the home screen: the ink, and the stacked lockup with the middle of the sign on the middle of the screen. One image for each screen size and orientation.',
  desc_29: 'The sting: the sign and the name in motion for 2.5 s, as a match start, a replay and the season timelapse play it. PLAY runs it on the clock. The slider shows one frame, and SAVE PNG saves that frame.',
  desc_dev: 'The dev identity: the same picture with the DEV line under the name, as the dev environment shows it. The dev corner of the icons is a file of the icon set.',
  desc_live_deep_drift: 'The deep in its own motion and nothing more: the shafts sway and the snow drifts round the still sign. The quietest of the five. A loop of 30 s for a macOS desktop.',
  desc_live_deep_pulse: 'The deep in motion: the shafts sway, the snow drifts, and a ring leaves the sign every 3.75 s. Each ring lights the grid it crosses and fades as it grows. A loop of 30 s for a macOS desktop.',
  desc_live_deep_sweep: 'The deep in motion: the shafts sway, the snow drifts, and a sonar sweep turns round the sign. Its trail lights the grid, and three contacts flash as it passes. A loop of 30 s for a macOS desktop.',
  desc_live_ping_pulse: 'The ping in motion: its five rings travel out from the sign, one every 3 s, and every frame shows the still ping with its rings moved on. A loop of 30 s for a macOS desktop.',
  desc_live_ping_sweep: 'The ping with a sonar sweep out to its fifth ring. Three contacts between the rings flash as it passes. A loop of 30 s for a macOS desktop.',
  desc_wall_chart: 'The ground of the platform images: a sea in play, with the lockup on a calm area. A telephone takes the stacked lockup, and a desktop takes the header lockup.',
  desc_wall_deep: 'The deep icon on a whole screen: the sign glows in deep water, under light from the surface and over a faint grid of the map. For a lock screen and a desktop. The sign stands in the safe area, clear of the clock, the controls and the bars.',
  desc_wall_ping: 'The quiet design, for a home screen full of icons: the water, a patch of the grid, and the five rings of the sonar ping of the season image round the sign.',
  fault: (p: { message: string | number }) => `This picture did not draw: ${p.message}`,
  ground: 'GROUND',
  ground_arcade: 'arcade',
  ground_chart: 'chart',
  ground_clanwar: 'clan war',
  ground_conquest: 'conquest',
  ground_event: 'event',
  guide_avatar: 'THE AVATAR · ABOUT',
  guide_desktop_band: (p: { w: string | number; h: string | number }) => `DESKTOP · ${p.w} × ${p.h}`,
  guide_dock: 'THE DOCK · MACOS',
  guide_feed_square: 'SQUARE · A FEED',
  guide_icons_mac: 'THE ICONS · MACOS',
  guide_icons_windows: 'THE ICONS · WINDOWS',
  guide_large_card: '2:1 · A LARGE CARD',
  guide_lock_android: 'THE SHORTCUTS, THE FINGERPRINT AND THE GESTURE BAR · ANDROID',
  guide_lock_clock: 'THE CLOCK AND THE WIDGETS · LOCK SCREEN',
  guide_lock_ios: 'THE TWO BUTTONS AND THE HOME BAR · IOS',
  guide_menu_bar: 'THE MENU BAR · MACOS',
  guide_messenger: 'SQUARE · A MESSENGER',
  guide_notch: (p: { ratio: string | number }) => `${p.ratio}:1 · A MACBOOK WITH A NOTCH`,
  guide_safe_area: (p: { w: string | number; h: string | number }) => `SAFE AREA · ${p.w} × ${p.h} · EVERY DEVICE`,
  guide_safe_circle: (p: { pct: string | number }) => `THE SAFE CIRCLE OF A ROUND MASK · ${p.pct} %`,
  guide_safe_wall: 'SAFE · THE SYSTEM COVERS NOTHING HERE',
  guide_server_name: 'THE SERVER NAME · ABOUT',
  guide_slot_name: 'SLOT · THE NAME',
  guide_slot_season: 'SLOT · THE SEASON NUMBER',
  guide_tablet_band: (p: { w: string | number; h: string | number }) => `TABLET · ${p.w} × ${p.h}`,
  guide_taskbar: 'THE TASK BAR · WINDOWS',
  guide_telephone: 'TELEPHONE · ABOUT',
  guide_title_safe: (p: { pct: string | number }) => `TITLE SAFE · ${p.pct} %`,
  guide_ultrawide: '21:9 · AN ULTRAWIDE SCREEN',
  guide_under_name: 'SAFE · UNDER THE NAME',
  guides_off: 'GUIDES OFF',
  guides_on: 'GUIDES ON',
  landscape: 'landscape',
  launch_count: (p: { count: number }) => plural(p.count, {
    one: `${p.count} launch image`,
    other: `${p.count} launch images`,
  }),
  launch_option: (p: { w: string | number; h: string | number; orientation: string | number; devices: string | number }) => `${p.w} × ${p.h} · ${p.orientation} · ${p.devices}`,
  live_frame: (p: { t: string | number; i: string | number }) => `${p.t} S · FRAME ${p.i}`,
  live_pause: 'PAUSE',
  live_play: 'PLAY',
  lockup_ink: 'ON THE INK',
  lockup_label: (p: { size: string | number; ground: string | number; w: string | number; h: string | number }) => `${p.size} · ${p.ground} · ${p.w} × ${p.h} PX`,
  lockup_large: 'LARGE',
  lockup_small: 'SMALL',
  lockup_transparent: 'TRANSPARENT',
  portrait: 'portrait',
  save: 'SAVE PNG',
  season: 'SEASON',
  season_name: 'NAME',
  size: (p: { w: string | number; h: string | number }) => `${p.w} × ${p.h} PX`,
  sting_play: 'PLAY',
  sting_time: (p: { t: string | number }) => `${p.t} S`,
  sub: 'Every picture of the brand at its true pixel size. SAVE PNG saves one file. scripts/build-brand-art.sh writes every file into client/public/brand/.',
  title: 'BRAND ART',
  wall_option: (p: { w: string | number; h: string | number; devices: string | number }) => `${p.w} × ${p.h} · ${p.devices}`,
  what_dev: 'THE DEV LINE',
  what_name: 'THE NAME',
  what_season: 'THE SEASON LINE',
  what_sign: 'THE SIGN',
  what_slot: 'THE NAME LINE',
  what_tag: 'THE TAG LINE',
};

const brandartDiscord_en: S.BrandartDiscord = {
  animated: 'APNG',
  card_emoji: 'DISCORD EMOJIS',
  card_kraken: 'KRAKEN STICKERS',
  card_sticker: 'DISCORD STICKERS',
  desc_e_abyssal_compact: 'The Abyssal Compact badge: three cyan wavy bars in a cyan ring on a dark roundel.',
  desc_e_alloy: 'An alloy deposit: a pale grey diamond with one chip.',
  desc_e_archive_vault: 'The Archive Vault: a cyan arched door with a dark keyhole.',
  desc_e_attack: 'An attack map marker: a white map pin with an arrow cut into its head.',
  desc_e_basilisk: 'A white Basilisk warship mark with long straight wings, nose up to the right.',
  desc_e_battle: 'A battle mark: two crossed white swords.',
  desc_e_beacon: 'A white Beacon support ship mark: a thin needle through a core with seven spokes.',
  desc_e_biomass: 'A biomass deposit: a green diamond with two chips.',
  desc_e_bombard: 'A white Bombard warship mark with broad swept wings, nose up to the right.',
  desc_e_clan_war: 'The Clan War: two crossed amber war banners on staffs.',
  desc_e_contact: 'An enemy contact: a red dart with no class mark, nose up to the right.',
  desc_e_coral_ward: 'The Coral Ward: a cyan coral fan with a bud on each tip.',
  desc_e_corsair: 'A white Corsair warship mark with small wings far back on the tail, nose up to the right.',
  desc_e_cup: 'The clan cup: a gold cup with two handles on a foot.',
  desc_e_cutlass: 'A white Cutlass warship mark with short swept wings, nose up to the right.',
  desc_e_danger: 'A danger map marker: a white map pin with a warning triangle cut into its head.',
  desc_e_deep_battery: 'The Deep Battery: a cyan gun tube on a dome, aimed up to the right.',
  desc_e_defend: 'A hold map marker: a white map pin with a shield cut into its head.',
  desc_e_dredger: 'A white Dredger support ship mark: a thin needle that tows two open crates.',
  desc_e_drydock_shoal: 'The Drydock Shoal: a cyan cradle with a hull in it.',
  desc_e_falconet: 'A white Falconet warship mark with straight wings square to the hull, nose up to the right.',
  desc_e_forge_vent: 'The Forge Vent: a cyan chimney with three balls of smoke over its mouth.',
  desc_e_gather: 'A gather map marker: a white map pin with a funnel over a dot cut into its head.',
  desc_e_gg: 'Well done: a gold rosette with two ribbons and a star in its centre.',
  desc_e_hit: 'A torpedo hit: a white flash in an orange fireball on a dark disc of water with a cyan edge.',
  desc_e_hold: 'An own hold: the cyan beacon post with its white light on a hex ground plate with a white rim.',
  desc_e_kelp_syndicate: 'The Kelp Syndicate badge: a green kelp frond in a green ring on a dark roundel.',
  desc_e_kelp_terrace: 'The Kelp Terrace: three cyan kelp blades.',
  desc_e_kraken: 'The kraken of the old charts: a dark dome with two staring cyan eyes over eight hanging arms, its edges lit blue.',
  desc_e_kraken_breach: 'The kraken of the old charts: a dark leaning dome cut flat at the surface, two staring cyan eyes and three arms raised, its edges lit blue.',
  desc_e_kraken_hood: 'The kraken of the old charts: a dark hooded head with two staring cyan eyes, eight arms hooked up over it, its edges lit blue.',
  desc_e_kraken_keel: 'The kraken of the old charts: a long dark finned body with one staring cyan eye and eight trailing arms, nose up to the right, its edges lit blue.',
  desc_e_ladder_blackwater: 'The BLACKWATER ladder tier: a filled gold sounding lead with two dark chevrons.',
  desc_e_ladder_crush: 'The CRUSH ladder tier: a filled gold sounding lead with three dark chevrons in a gold ring.',
  desc_e_ladder_midnight: 'The MIDNIGHT ladder tier: a filled cyan sounding lead with one dark chevron.',
  desc_e_ladder_shallows: 'The SHALLOWS ladder tier: a pale open sounding lead with one chevron.',
  desc_e_ladder_sunlit: 'The SUNLIT ladder tier: a pale open sounding lead with two chevrons.',
  desc_e_ladder_twilight: 'The TWILIGHT ladder tier: a cyan open sounding lead with three chevrons.',
  desc_e_lancer: 'A white Lancer warship mark with wings swept forward, nose up to the right.',
  desc_e_mariana_sisters: 'The Mariana Sisters badge: three pink discs, one above two, in a pink ring on a dark roundel.',
  desc_e_marshal_court: 'The Marshal Court: a cyan hall with a pediment, four columns and steps.',
  desc_e_oracle: 'A white Oracle support ship mark: a thin needle with two open arcs ahead of it.',
  desc_e_ping: 'A sonar ping: three cyan rings spread out from a bright dot on a dark disc of water.',
  desc_e_relay_spire: 'The Relay Spire: a cyan mast with a round head and a yard.',
  desc_e_rust_fleet: 'The Rust Fleet badge: an orange gear in an orange ring on a dark roundel.',
  desc_e_seaquake: 'A seaquake: a gold epicentre star in a dashed gold ring on a dark disc of water with a cyan edge.',
  desc_e_sentinel: 'A white Sentinel support ship mark: a thin needle between two swept bars.',
  desc_e_siege: 'A siege: two crossed white swords over a cyan bastion.',
  desc_e_sign: 'The Aquaphobia sign: a dark hex plate with a cyan edge and a pale chevron.',
  desc_e_tender: 'A white Tender support ship mark: a thin needle through a lifebuoy ring.',
  desc_e_torpedo: 'A steel torpedo with fins, nose up to the right, with an amber burn behind it.',
  desc_e_trench_throne: 'The Trench Throne: a cyan seat with a crown on a dais.',
  desc_e_vedette: 'A white Vedette support ship mark: a thin needle with three quills astern.',
  desc_e_void_choir: 'The Void Choir badge: three violet chevrons in a violet ring on a dark roundel.',
  desc_e_volatiles: 'A volatiles deposit: a violet diamond with three chips.',
  desc_e_whale: 'A whale: a pale blue whale with a forked tail, nose up to the right.',
  desc_e_wreck: 'A wreck on the sea bed: a pale hull with three bare masts.',
  desc_emoji: 'Fifty-seven custom emojis, 128 px a side, each one a game object. Discord shows an emoji at about 22 px in a line of text and at 48 px alone. Each tile shows the file at those sizes.',
  desc_kraken: 'Four candidates for one kraken sticker, one for each beast of the old charts, each with its water on a disc of sonar water. The owner picks one of the four, and only that one goes up.',
  desc_s_aquaphobia: 'The Aquaphobia sign above the name AQUAPHOBIA in pale capitals.',
  desc_s_attack: 'A white warship charges a white map pin with an arrow. The word ATTACK.',
  desc_s_clan_cup: 'A gold cup with two handles on a foot. The words CLAN CUP.',
  desc_s_clan_war: 'Two crossed war banners on staffs. The words CLAN WAR.',
  desc_s_defend: 'A white map pin with a shield over a cyan hold. The word HOLD.',
  desc_s_enemy: 'A sonar ping on a dark disc of water lights two red enemy contacts. The word ENEMY.',
  desc_s_factions: 'The Aquaphobia sign in a ring of the five faction badges, each in its own colour.',
  desc_s_gg: 'A gold rosette with a dark star and two ribbons. The letters GG.',
  desc_s_help: 'A white map pin with a warning triangle in red rings. The word HELP.',
  desc_s_hull_sunk: 'On a dark disc, a white warship goes down in a flash and leaves a wreck. The words HULL SUNK.',
  desc_s_kraken_breach: 'A sonar ping lights a kraken that breaks the surface with three arms and spray. The word KRAKEN.',
  desc_s_kraken_dome: 'A sonar ping lights a kraken dome with hanging arms in a dark blur. The word KRAKEN.',
  desc_s_kraken_hood: 'A sonar ping lights a hooded kraken that rises out of drawn rings of water. The word KRAKEN.',
  desc_s_kraken_keel: 'A sonar ping lights a long finned kraken with trailing arms in a dark blur. The word KRAKEN.',
  desc_s_on_my_way: 'A white warship runs on a dashed course to a move crosshair. The words ON MY WAY.',
  desc_s_regroup: 'Three white warships turn in to one map pin. The word REGROUP.',
  desc_s_seaquake: 'On a dark disc, a gold epicentre star in a dashed gold ring. The word SEAQUAKE.',
  desc_s_siege: 'Two crossed white swords over a cyan bastion. The word SIEGE.',
  desc_s_torpedo_away: 'A steel torpedo with a hot amber burn behind it. The words TORPEDO AWAY.',
  desc_sticker: 'Fifteen server stickers, 320 px a side, each one a game object and a word of the game. Discord shows a sticker at 160 px in the chat. A sticker marked APNG moves.',
  ground: 'GROUND',
  ground_dark: 'dark',
  ground_light: 'light',
  manifest_about: 'The Discord emojis and stickers of Aquaphobia (docs/design/brand.md §14). scripts/build-brand-art.sh writes this file. Upload each file by hand in the server settings with the name, the description and the related emoji of its row. Upload at most one row of sticker_candidates: the one the owner picks.',
  name_factions: 'FIVE FACTIONS',
  word_gg: 'GG',
  word_kraken: 'KRAKEN',
};

const briefing_en: S.Briefing = {
  all_figures: 'ALL FIGURES',
  auction: (p: { lots: string | number; credits: string | number }) => `Lots sold: ${p.lots} · credits: ${p.credits}`,
  away_for: (p: { span: string | number }) => `${p.span} away`,
  away_span: (p: { away: string | number; span: string | number }) => `${p.away} · ${p.span}`,
  back: '‹ BACK',
  cell_credits: 'CREDITS',
  cell_isotopes: 'ISOTOPES',
  cell_sinkings: 'SINKINGS',
  cells: (p: { won: string | number; lost: string | number }) => `${p.won} won · ${p.lost} lost`,
  ch_dives: 'THE DIVES',
  ch_dives_aside: 'isotopes · ◆ a Data Core',
  ch_ground: 'THE GROUND',
  ch_ground_aside: 'cells won over cells lost',
  ch_ledger: 'THE LEDGER',
  ch_moments: 'TOP MOMENTS',
  ch_moments_aside: 'the messages the INBOX still holds',
  ch_objects: 'STRATEGIC OBJECTS',
  ch_objects_aside: '◆ taken · ■ held · ✕ lost',
  ch_war: 'THE WAR',
  ch_war_aside: 'sinkings over fleets lost',
  cover_hub: 'The autopilot kept your empire while you were away',
  cover_line: 'Standing orders kept your empire while you were away',
  cover_on: 'ON',
  down: (p: { n: string | number }) => `▼ ${p.n}`,
  ended: 'ENDED',
  events: (p: { n: number }) => plural(p.n, {
    one: `${p.n} event`,
    other: `${p.n} events`,
  }),
  fell: 'FELL',
  fig_battles: 'WINDOW BATTLES',
  fig_captains_captured: 'CAPTURED',
  fig_captains_hurt: 'CAPTAINS HURT',
  fig_captains_recruited: 'RECRUITS',
  fig_cargo_blocked: 'STORAGE FULL',
  fig_cargo_landed: 'CARGO LANDED',
  fig_cargo_lost: 'CARGO LOST',
  fig_cells_lost: 'CELLS LOST',
  fig_cells_won: 'CELLS WON',
  fig_cores: 'DATA CORES',
  fig_credits: 'CREDITS',
  fig_dives: 'DIVES',
  fig_dmg_dealt: 'SUNK HULL DMG',
  fig_dmg_dealt_title: 'The damage that you dealt to enemy fleets, counted only for the fleets that sank.',
  fig_dmg_taken: 'LOST HULL DMG',
  fig_dmg_taken_title: 'The damage that your own fleets took, counted only for the fleets that sank.',
  fig_dockings: 'DOCKINGS',
  fig_fire_events: 'FIRE NEAR',
  fig_fleets_lost: 'FLEETS LOST',
  fig_iso_bought: 'ISO BOUGHT',
  fig_isotopes: 'ISOTOPES',
  fig_jobs_done: 'LEVELS BUILT',
  fig_kills: 'SINKINGS',
  fig_msg_dive: 'DIVE EVENTS',
  fig_msg_hold: 'HOLD EVENTS',
  fig_msg_loss: 'LOSS EVENTS',
  fig_msg_trade: 'TRADE EVENTS',
  fig_msg_war: 'WAR EVENTS',
  fig_msg_world: 'WORLD EVENTS',
  fig_obj_held: 'OBJECTS HELD',
  fig_obj_lost: 'OBJECTS LOST',
  fig_obj_taken: 'OBJECTS TAKEN',
  fig_practice: 'PRACTICE',
  fig_prints_bought: 'PRINTS BOUGHT',
  fig_repairs: 'REPAIRS',
  fig_research_done: 'TECH NODES',
  fig_sales: 'SALES',
  fig_salvage: 'SALVAGE',
  fig_ships_ready: 'HULLS READY',
  fig_torp_hit: 'STRIKES MADE',
  fig_torp_struck: 'STRIKES TAKEN',
  fig_torps_stowed: 'TORPEDO JOBS',
  fleets: (p: { sunk: string | number; lost: string | number }) => `Enemy fleets sunk: ${p.sunk} · own fleets lost: ${p.lost}`,
  fold_close: 'fold SINCE YOU LEFT',
  fold_open: 'open SINCE YOU LEFT',
  g_cores: 'CORES',
  g_dives: 'DIVES',
  g_held: 'HELD',
  g_iso: 'ISO',
  g_lost: 'LOST',
  g_sunk: 'SUNK',
  g_taken: 'TAKEN',
  g_total: 'Σ',
  g_won: 'WON',
  held: 'HELD',
  lab_cover: 'COVER',
  lab_losses: 'LOSSES',
  lab_sickbay: 'SICKBAY',
  lab_siege: 'SIEGE',
  lab_water: 'WATER',
  lab_works: 'WORKS',
  ledger_aside: 'every figure in every range',
  left_hours: (p: { hours: string | number; min: string | number }) => `${p.hours}h ${p.min}m`,
  left_min: (p: { min: string | number }) => `${p.min}m`,
  less_one: '<1',
  line_cells: 'cells',
  line_lost: (p: { n: string | number }) => `${p.n} lost`,
  line_quiet: 'nothing new',
  line_siege: (p: { site: string | number; at: string | number }) => `siege ${p.site} ${p.at}`,
  line_unread: (p: { n: string | number }) => `${p.n} unread`,
  line_wait: 'the figures are on the way',
  line_works: (p: { n: number }) => plural(p.n, {
    one: `${p.n} job done`,
    other: `${p.n} jobs done`,
  }),
  link_down: 'No link to the world: nothing was sent.',
  loss_captured: (p: { n: string | number }) => `${p.n} captured`,
  loss_cargo: (p: { n: string | number }) => `${p.n} cargo lost`,
  loss_fleets: (p: { n: number }) => plural(p.n, {
    one: `${p.n} fleet`,
    other: `${p.n} fleets`,
  }),
  loss_hurt: (p: { n: string | number }) => `${p.n} hurt`,
  m_battle: 'THE LARGEST BATTLE',
  m_dive: 'THE BEST DIVE',
  m_goto: 'GO TO',
  m_loss: 'THE WORST LOSS',
  m_none: 'No message of this range is in the INBOX now.',
  m_replay: '▶ REPLAY',
  m_sale: 'THE BEST SALE',
  mark_these: 'MARK THESE READ',
  mauled: 'MAULED',
  more: (p: { n: string | number }) => `+${p.n} MORE`,
  obj_held: (p: { n: string | number }) => `${p.n} held`,
  obj_lost: (p: { n: string | number }) => `${p.n} lost`,
  obj_taken: (p: { n: string | number }) => `${p.n} taken`,
  open_window: 'open the report of the window',
  page_head: 'DIGEST',
  quiet: 'Nothing to report in this range.',
  range_away: 'SINCE YOU LEFT',
  range_d7: '7D',
  range_h24: '24H',
  range_no_away: 'No absence is on record yet.',
  range_season: 'SEASON',
  recent_fold_close: 'fold RECENT',
  recent_fold_open: 'open RECENT, the notices of this session',
  recent_head: 'RECENT',
  row_auction: 'Auction sales',
  row_cells: 'Cells',
  row_cover: 'Standing orders',
  row_fleets: 'Fleets',
  row_sickbay: 'Captains in the Sickbay',
  row_siege: 'Siege against you',
  row_works: 'Builds and research',
  same: '= 0',
  show_every: 'SHOW ALL',
  show_only: 'SHOW ONLY THESE',
  sickbay_fit: (p: { name: string | number; left: string | number }) => `${p.name} · fit in ${p.left}`,
  sickbay_in: (p: { name: string | number; left: string | number }) => `${p.name} rests · fit for duty in ${p.left}`,
  siege_ended: (p: { site: string | number }) => `${p.site} · the window has ended`,
  siege_fell: (p: { site: string | number; foe: string | number }) => `${p.site} fell to the ${p.foe}`,
  siege_fell_bare: (p: { site: string | number }) => `${p.site} fell`,
  siege_held: (p: { site: string | number }) => `${p.site} held`,
  siege_in: (p: { site: string | number; attacker: string | number; left: string | number }) => `${p.site} · ${p.attacker} · the window opens in ${p.left}`,
  siege_live: (p: { site: string | number; attacker: string | number; left: string | number }) => `${p.site} · ${p.attacker} · battle in ${p.left}`,
  siege_live_bare: (p: { site: string | number; left: string | number }) => `${p.site} · battle in ${p.left}`,
  siege_mauled: (p: { site: string | number }) => `${p.site} was mauled · the gauge does not heal`,
  siege_open: (p: { site: string | number; attacker: string | number }) => `${p.site} · ${p.attacker} · the window is open`,
  since_day: (p: { day: string | number }) => `since ${p.day}`,
  slot_days: (p: { n: number }) => plural(p.n, {
    one: `a slot is ${p.n} day`,
    other: `a slot is ${p.n} days`,
  }),
  slot_hours: (p: { n: string | number }) => `a slot is ${p.n}h`,
  span: (p: { from: string | number; to: string | number }) => `${p.from} – ${p.to}`,
  t_day: 'A DAY',
  t_delta: 'Δ 7D',
  t_figure: 'FIGURE',
  thousand: (p: { n: string | number }) => `${p.n}k`,
  up: (p: { n: string | number }) => `▲ ${p.n}`,
  water_cells: (p: { won: string | number; lost: string | number }) => `won ${p.won} · lost ${p.lost} cells`,
  water_objects: (p: { list: string | number }) => `objects: ${p.list}`,
  window_open: 'OPEN',
  works_hub: (p: { levels: string | number; nodes: string | number }) => `Building levels: ${p.levels} · tech nodes: ${p.nodes}`,
  works_hulls: (p: { n: number }) => plural(p.n, {
    one: `${p.n} hull ready`,
    other: `${p.n} hulls ready`,
  }),
  works_levels: (p: { n: number }) => plural(p.n, {
    one: `${p.n} level`,
    other: `${p.n} levels`,
  }),
  works_recruits: (p: { n: number }) => plural(p.n, {
    one: `${p.n} recruit`,
    other: `${p.n} recruits`,
  }),
  works_repairs: (p: { n: number }) => plural(p.n, {
    one: `${p.n} repair`,
    other: `${p.n} repairs`,
  }),
  works_research: (p: { n: number }) => plural(p.n, {
    one: `${p.n} tech node`,
    other: `${p.n} tech nodes`,
  }),
  works_torps: (p: { n: number }) => plural(p.n, {
    one: `${p.n} torpedo job`,
    other: `${p.n} torpedo jobs`,
  }),
};

const cacheNote_en: S.CacheNote = {
  phrases: ['Good hunting.', 'Fair winds and deep water.', 'Well found.', 'The deep pays the patient.', 'Spend it well.', 'A gift from the cold water.', 'Keep your sonar sharp.', 'Mind the currents.', 'Silence keeps a hull alive.', 'You found it first.', 'Remember who left this.', 'For the faction.', 'Dive deeper next time.', 'Nothing here is free.', 'The sea remembers.', 'Leave one for the next diver.'],
};

const card_en: S.Card = {
  arm_cancel: 'CANCEL',
  armed_aim_chip: (p: { order: string | number }) => `${p.order} · AIM`,
  armed_chip: (p: { order: string | number }) => `${p.order} · PICK`,
  aspect_beam: 'BEAM',
  aspect_bow: 'BOW',
  aspect_stern: 'STERN',
  aspect_title: 'The arc of this contact that faces your selected hull, else your nearest hull. A shot on the beam or the stern deals more damage.',
  aura_lift: (p: { pct: string | number; px: string | number }) => `+${p.pct} % to guns, speed, turn and shield regen within ${p.px} px`,
  aura_off: 'off · no captain aboard',
  aura_on: (p: { px: string | number; pct: string | number }) => `on · ${p.px} px · ${p.pct} % of the captain's points`,
  aura_title: 'The command aura: each own hull near the command ship uses the higher of its own captain\'s points and a share of this captain\'s points.',
  auto_field_off: 'none — the hauler docks',
  auto_field_on: 'found by itself in own water',
  back_mark: '‹',
  back_title: 'back to the list',
  beam_needs_set: 'NEEDS SET',
  beam_off: '○ OFF',
  beam_on: (p: { left: string | number }) => `● ON ${p.left}`,
  beam_title: (p: { dur: string | number }) => `The beam of a set Beacon runs for ${p.dur}. Every set starts it, and a weigh stops it.`,
  boarding_status: 'boarding',
  bounty_credits: (p: { credits: string | number }) => `${p.credits} C to the last hit`,
  bro_grapnel_company: 'Grapnel Company',
  bro_lantern_kin: 'Lantern Kin',
  bro_ninefathom: 'Ninefathom',
  bro_saltjaw: 'Saltjaw',
  bro_undertow: 'Undertow',
  build_named: (p: { name: string | number }) => `BUILD ${p.name}`,
  cache_cancel: 'CANCEL',
  cache_close: 'CLOSE',
  cache_fee: (p: { n: string | number }) => `${p.n} credits · the game destroys them`,
  cache_find_note: 'The reward came from the game.',
  cache_find_player_note: 'The reward came from the game, not from the depositor. You take the caches of one depositor once in a season.',
  cache_finds: (p: { n: number }) => plural(p.n, {
    one: `${p.n} find`,
    other: `${p.n} finds`,
  }),
  cache_finds_head: 'your finds',
  cache_found_chip: 'found',
  cache_full_title: 'you left every cache of this season',
  cache_kind_event: 'Event cache',
  cache_kind_other: 'Cache',
  cache_kind_pirate: 'Pirate cache',
  cache_kind_player: 'Player cache',
  cache_kind_ruin: 'Ruin',
  cache_kind_seeded: 'Seeded cache',
  cache_leave_btn: 'LEAVE CACHE',
  cache_leave_btn_title: 'the fleet leaves a cache at its position, and the fee burns at once',
  cache_leave_hint: 'The finder takes a reward of the game, not from you. A cache goes down in own water or in water that no faction holds, outside the harbour limits and off the apron of a strategic object. The deposit is as loud as a SEARCH.',
  cache_leave_kind: (p: { fleet: string | number }) => `${p.fleet} · at its position`,
  cache_leave_title: 'Leave a cache',
  cache_note_bad_length: (p: { min: string | number; max: string | number }) => `A cache note has ${p.min} to ${p.max} characters.`,
  cache_note_btn: 'NOTE',
  cache_note_btn_title: 'write the note of this cache: you write it once',
  cache_note_head: 'the note',
  cache_note_hint_text: (p: { min: string | number; max: string | number }) => `Or write a note of ${p.min} to ${p.max} characters. An empty box takes the phrase.`,
  cache_note_none: 'no note',
  cache_note_none_left: 'The depositor left no note.',
  cache_note_once: 'You write the note of a cache once. Only a finder reads it.',
  cache_note_only_you: 'only you read it',
  cache_note_pick: 'Pick a phrase or write a note.',
  cache_note_quoted: (p: { note: string | number }) => `“${p.note}”`,
  cache_note_save: 'SAVE NOTE',
  cache_note_text: 'a note of your own',
  cache_note_title: 'Note of your cache',
  cache_note_unset: 'no note',
  cache_of: (p: { n: string | number; max: string | number }) => `${p.n} of ${p.max}`,
  cache_read_btn: 'READ',
  cache_read_btn_title: 'read the note of this cache',
  cache_search_here: 'SEARCH HERE',
  cache_search_here_title: 'this fleet searches the cell where it stands: it is as loud as a launch while it works',
  cache_show: 'SHOW ON MAP',
  cache_yours_head: 'your caches',
  captain: (p: { name: string | number; phase: string | number }) => `${p.name} (${p.phase})`,
  career_age: (p: { age: string | number; phase: string | number }) => `age ${p.age} · ${p.phase}`,
  career_decline: 'decline',
  career_decline_from: (p: { age: string | number }) => `decline from ${p.age}`,
  career_peak: 'peak',
  career_rise: 'rise',
  cl_cargo_head: 'WITH CARGO',
  cl_fold: (p: { n: number }) => plural(p.n, {
    one: `${p.n} wreck`,
    other: `${p.n} wrecks`,
  }),
  cl_fold_side: (p: { n: string | number; side: string | number }) => `${p.n} ${p.side}`,
  cl_next_title: 'the next page',
  cl_page: (p: { page: string | number; pages: string | number }) => `${p.page}/${p.pages}`,
  cl_prev_title: 'the previous page',
  close_title: 'close',
  cls_gulper: 'Gulper',
  cls_murkhide: 'Murkhide',
  cls_myriad: 'Myriad',
  cls_quillback: 'Quillback',
  cls_thrummer: 'Thrummer',
  commander_unknown: '? — a scan reads it',
  commit: (p: { verb: string | number; fleet: string | number }) => `${p.verb} ${p.fleet}`,
  compare: 'COMPARE',
  compare_kind: 'two hulls side by side',
  compare_note: '▲ marks the better figure of a row. A role and a weight have no better.',
  compare_tag: 'COMPARE',
  compare_title: 'set this hull beside a second one: press the name of the second hull',
  compressed_cargo: (p: { units: string | number }) => `${p.units} units aboard · they land at your hold`,
  compressed_title: (p: { alloy: string | number; biomass: string | number; volatiles: string | number; isotopes: string | number }) => `${p.alloy} alloy, ${p.biomass} biomass, ${p.volatiles} volatiles and ${p.isotopes} isotopes; a new order keeps them aboard, and a sinking leaves them in the wreck`,
  cond_anchor: 'ANCHORED',
  cond_aura_pts: (p: { short: string | number; pts: string | number }) => `${p.short} ${p.pts}`,
  cond_aura_sep: ' · ',
  cond_command: 'COMMAND',
  cond_command_lift_why: (p: { name: string | number; pct: string | number }) => `Inside the command aura of ${p.name}: the guns, the speed, the turn and the shield regen of the hull are ${p.pct} % higher.`,
  cond_command_why: (p: { name: string | number; pct: string | number }) => `Inside the command aura of ${p.name}: the hull uses ${p.pct} % of that captain's points where they are higher than its own captain's.`,
  cond_deep_run: 'DEEP RUN',
  cond_drift: 'DRIFT',
  cond_echo: 'ECHO',
  cond_factor: (p: { f: string | number }) => `×${p.f}`,
  cond_ghost: 'GHOST',
  cond_harbour: 'HARBOUR',
  cond_lane: 'LIT WATER',
  cond_lift: (p: { pct: string | number }) => `+${p.pct} %`,
  cond_net: 'NETTED',
  cond_pressure: 'PRESSURE',
  cond_screen: 'SCREENED',
  cond_share: (p: { pct: string | number }) => `${p.pct} %`,
  cond_signature: 'SIGNATURE',
  cond_slow: 'SLOWED',
  cond_surge: 'SURGE',
  cond_terrain: 'TRENCH',
  cond_value: (p: { factor: string | number; left: string | number }) => `${p.factor} · ${p.left}`,
  cond_wear: (p: { n: string | number }) => `−${p.n}/MIN`,
  cond_wire: 'WIRED',
  contact_lost: 'contact lost',
  contact_title: 'Sonar contact',
  contested_no: 'no',
  contested_title: 'another faction has pledged',
  contested_yes: 'yes',
  ddesign_broken_ridge: 'Broken Ridge',
  ddesign_down_funnel: 'Down Funnel',
  ddesign_grappled_hauler: 'Grappled Hauler',
  ddesign_hook_spur: 'Hook Spur',
  ddesign_jaw_cut: 'Jaw Cut',
  ddesign_lantern_wreck: 'Lantern Wreck',
  ddesign_rammed_pair: 'Rammed Pair',
  ddesign_sounding_ledge: 'Sounding Ledge',
  ddesign_sunken_dreadnought: 'Sunken Dreadnought',
  ddesign_survey_ship: 'Survey Ship',
  deep: 'trench · ½ speed · ½ noise',
  deep_run: 'running deep — half speed, and the fixed ears lose it',
  den_at_sea: 'group at sea',
  den_cache_seen: 'cache seen',
  den_cache_taken: 'cache taken',
  den_home: 'group home',
  den_prize: 'prize',
  den_respawn: (p: { left: string | number }) => `sails again in ${p.left}`,
  den_sunk: 'group sunk',
  den_title: 'Pirate den',
  den_unknown: 'unknown',
  depth_band: (p: { band: string | number; rating: string | number }) => `${p.band} · rated to the ${p.rating}`,
  echo_far: 'a faint return',
  echo_mid: 'a clear return',
  echo_near: 'a hard return',
  echo_title: (p: { px: string | number }) => `the echo sounder hears a cache you may take within ${p.px} px of the hull; it names no bearing`,
  edit_group_title: 'set the group of this hull',
  edit_title: 'set the group or the name of this hull',
  eff_brace: (p: { sec: string | number; mul: string | number }) => `For ${p.sec} combat s it turns its bow to the target at its normal turn speed and takes ${p.mul}× damage.`,
  eff_broadside: (p: { sec: string | number; mul: string | number; splash: string | number }) => `For ${p.sec} combat s it holds its beam to the target. Every shot deals ${p.mul}× damage, and its splash reaches ${p.splash}× as far.`,
  eff_canister: (p: { sec: string | number }) => `For ${p.sec} combat s every shot ignores the dead zone.`,
  eff_crash_dive: (p: { noise: string | number; speed: string | number; sec: string | number }) => `Noise ${p.noise}× and speed ${p.speed}× for ${p.sec} combat s.`,
  eff_dig_in: (p: { sec: string | number; px: string | number }) => `For ${p.sec} combat s it stops, shows its bow on every side and reaches ${p.px} px further. A move ends it earlier.`,
  eff_getaway: (p: { sec: string | number; speed: string | number; turn: string | number }) => `It drops its whole cargo, and the cargo is lost. For ${p.sec} combat s it sails at ${p.speed}× speed and turns ${p.turn}× as fast.`,
  eff_muster: (p: { px: string | number; mul: string | number }) => `It calls the own hulls inside ${p.px} px to their stations at ${p.mul}× pace. A hull in a fight does not answer, and the order waits while the enemy hears this hull.`,
  eff_outflank: (p: { sec: string | number; mul: string | number }) => `For ${p.sec} combat s it steers behind the stern of its target at ${p.mul}× speed. Its guns fire on the way, as they always do.`,
  effect_after: 'AFTER',
  effect_now: 'NOW',
  empty: 'empty',
  f_act: 'now',
  f_aspect: 'aspect',
  f_aura: 'aura',
  f_bounty: 'bounty',
  f_brotherhood: 'brotherhood',
  f_cache_fee: 'fee',
  f_cache_finds: 'finds',
  f_cache_season: 'this season',
  f_cache_today: 'finds today',
  f_captain: 'captain',
  f_cargo: 'cargo',
  f_clan: 'clan',
  f_commander: 'commander',
  f_compressed: 'compressed',
  f_contested: 'contested',
  f_dead_zone: 'dead zone',
  f_depth: 'depth',
  f_design: 'design',
  f_echo: 'echo',
  f_faction: 'faction',
  f_fit: 'fit',
  f_formation: 'formation',
  f_gait: 'gait',
  f_grants: 'grants',
  f_guns: 'guns',
  f_heal: 'heal',
  f_held_by: 'held by',
  f_lane_credit: 'lifted',
  f_lane_gap: 'gap',
  f_lane_light: 'Fanal',
  f_lay: 'next lay',
  f_life: 'life left',
  f_lighters: 'lights by',
  f_loud: 'loud',
  f_monster: 'monster',
  f_muster: 'muster',
  f_next_field: 'next field',
  f_noise: 'noise',
  f_order: 'order',
  f_reach: 'reach',
  f_road: 'road',
  f_round: 'round',
  f_route: 'route',
  f_side: 'side',
  f_signature: 'signature order',
  f_sonar: 'sonar',
  f_speed: 'speed',
  f_squad: 'squad',
  f_status: 'status',
  f_sunk: 'sunk',
  f_systems: 'systems',
  f_value: 'value',
  f_weight: 'weight',
  f_work: 'work',
  f_working: 'working',
  f_yield: 'yield',
  f_your_pledge: 'your pledge',
  formation_member: (p: { name: string | number }) => `station by ${p.name}`,
  formation_on: (p: { n: string | number }) => `on · members: ${p.n}`,
  formation_title: 'The formation: the own hulls on stations round the command ship. GUNS TIGHT turns it on, and an attack by the command ship ends it.',
  group_slot: (p: { n: string | number }) => `GROUP ${p.n}`,
  group_title: (p: { n: string | number }) => `control group ${p.n}`,
  guard_in_reach: 'in reach',
  guard_title: 'Takes one hostile round in reach out of the water each reload. While the clock runs, every round passes.',
  heal_blocked: 'none until the next window closes',
  heard_title: 'A hostile faction hears this hull now.',
  heat_toward: (p: { pct: string | number; hi: string | number }) => `${p.pct} toward ${p.hi}`,
  hold_fire_on: 'tight',
  hold_fire_title: 'Guns tight: the guns shoot only at a focus.',
  kind_building: (p: { level: string | number; next: string | number }) => `installation · lvl ${p.level} → ${p.next}`,
  kind_building_max: (p: { level: string | number }) => `installation · lvl ${p.level} · max`,
  kind_deposit: (p: { resource: string | number }) => `deposit · ${p.resource}`,
  kind_hold: (p: { faction: string | number }) => `hold · ${p.faction}`,
  kind_hold_own: 'hold · yours',
  kind_unclassified: 'unclassified',
  ladder_needs: (p: { codes: string | number }) => `also needs ${p.codes}`,
  ladder_this: 'this node',
  lane_chip: 'LANE',
  lane_chip_own: 'YOUR LANE',
  lane_chip_quiet: 'QUIET',
  lane_commanders: (p: { n: number }) => plural(p.n, {
    one: `${p.n} commander`,
    other: `${p.n} commanders`,
  }),
  lane_credit: (p: { h: string | number }) => `${p.h} fleet hours`,
  lane_credit_none: 'no fleet lifted yet',
  lane_credit_title: 'the map time that fleets of your faction sailed under a lift on this lane',
  lane_gap: (p: { leg: string | number }) => `at leg ${p.leg}`,
  lane_gap_title: 'one Fanal on this chain point closes the gap in the chain',
  lane_gap_view: (p: { leg: string | number }) => `VIEW GAP · LEG ${p.leg}`,
  lane_kind: 'shipping lane',
  lane_lighter: (p: { name: string | number; n: string | number }) => `${p.name} ×${p.n}`,
  lane_lighters_none: 'no Fanal yet',
  lane_lit: (p: { f: string | number; n: number }) => plural(p.n, {
    one: `${p.n} own fleet lit · ×${p.f}`,
    other: `${p.n} own fleets lit · ×${p.f}`,
  }),
  lane_lit_title: 'own fleets on this lane that a light speeds up now',
  lane_note: 'Pirates hunt on every shipping lane. SEND sends the fleet you selected last, one fleet for each press.',
  lane_offer: (p: { lane: string | number; dur: string | number }) => `via ${p.lane} · saves ${p.dur}`,
  lane_offer_title: (p: { lane: string | number }) => `Sail along ${p.lane}: the course joins the lane at its nearest point and leaves it at the point nearest the target. The direct move stands until you press.`,
  lane_quiet_note: 'A quiet lane: it had no traffic for a long time, and pirates do not hunt on it. Traffic wakes it.',
  lane_road: (p: { name: string | number }) => `${p.name} Road`,
  lane_road_val: (p: { road: string | number; px: string | number; who: string | number }) => `${p.road} · ${p.px} px · ${p.who}`,
  lane_send: (p: { name: string | number }) => `SEND ${p.name}`,
  lane_send_none: 'SEND',
  lane_send_none_title: 'select an own fleet first, then press the lane',
  lane_send_title: (p: { name: string | number }) => `send ${p.name} on the legs of this lane`,
  lane_unlit: 'no own fleet lit',
  lane_you: 'you',
  lay_pick: 'lays',
  lay_pick_title: 'LAY lays this kind. A press picks it and lays nothing.',
  lay_ready: 'ready',
  levels: 'levels',
  levels_at: (p: { level: string | number }) => `AT ${p.level}`,
  levels_cost: 'costs',
  levels_next: (p: { level: string | number }) => `NEXT ${p.level}`,
  levels_now: (p: { level: string | number }) => `NOW ${p.level}`,
  levels_pick: (p: { level: string | number }) => `${p.level}`,
  levels_pick_label: (p: { level: string | number }) => `level ${p.level}`,
  levels_time: 'takes',
  loud_left: (p: { left: string | number }) => `noise up for ${p.left}`,
  loud_title: 'a lay makes the hull loud for a time, as a launch does',
  lower_title: 'show the short card',
  mdesign_brood_sac: 'Brood Sac',
  mdesign_bud_gourd: 'Bud Gourd',
  mdesign_coil_eel: 'Coil Eel',
  mdesign_comma_flock: 'Comma Flock',
  mdesign_discharge_ray: 'Discharge Ray',
  mdesign_dot_cloud: 'Dot Cloud',
  mdesign_gullet_sack: 'Gullet Sack',
  mdesign_hinged_jaw: 'Hinged Jaw',
  mdesign_ink_veil: 'Ink Veil',
  mdesign_lamp_crown: 'Lamp Crown',
  mdesign_lure_lamp: 'Lure Lamp',
  mdesign_mantis_fold: 'Mantis Fold',
  mdesign_quill_spine: 'Quill Spine',
  mdesign_ram_plate: 'Ram Plate',
  mdesign_ribbon_school: 'Ribbon School',
  mdesign_ring_maw: 'Ring Maw',
  mdesign_ring_pack: 'Ring Pack',
  mdesign_siphon_tube: 'Siphon Tube',
  mdesign_trapdoor: 'Trapdoor',
  mdesign_twin_drum: 'Twin Drum',
  mix_part: (p: { n: string | number; name: string | number }) => `${p.n} ${p.name}`,
  mix_sep: ' · ',
  mix_short: (p: { n: string | number; letter: string | number }) => `${p.n}${p.letter}`,
  more_groups: 'group',
  more_mark: '⋯',
  more_name: 'name',
  more_title: 'more orders',
  muster_on: (p: { px: string | number; mul: string | number }) => `${p.px} px · ${p.mul}× pace to the stations`,
  muster_title: 'MUSTER calls the own hulls inside this reach into the formation, and each one sails to its station at a raised pace.',
  no_captain: 'none — captains board in the pens (FLEET · MISSIONS)',
  none: 'none',
  note_base_design: 'No print: the base design. A print comes from DRAFT · PRINTS.',
  note_commit_hint: 'Select a combat fleet, then pledge it to the window.',
  note_contact: 'A scan reads the class, the systems and the commander.',
  note_module: (p: { name: string | number; pct: string | number }) => `${p.name} +${p.pct}%`,
  note_needs_banks: 'The hold fires torpedoes from a Torpedo Battery.',
  note_no_rounds: 'No rounds in the banks. Build some, then fire.',
  note_print: (p: { name: string | number; modules: string | number }) => `Print ${p.name}: ${p.modules}.`,
  note_window_shut: 'A pledge is taken in the window only.',
  nothing_there: 'nothing there',
  npc_act_gather: 'gathers',
  npc_act_hold: 'grips a hull',
  npc_act_idle: 'holds',
  npc_act_launch: 'launches pods',
  npc_act_move: 'moves',
  npc_act_pulse: 'discharges',
  npc_act_scatter: 'scatters',
  npc_act_strike: 'strikes',
  npc_act_tell: 'warns',
  npc_monster: 'Monster',
  npc_monster_note: 'A monster sinks hulls and moves to noise. A quiet fleet draws it less.',
  npc_pirate: 'Pirate group',
  npc_pirate_note: 'A pirate group hunts outside the aprons of the holds. A quiet fleet can pass it.',
  npc_quill_pod: 'Quill pod',
  npc_side: 'NPC side',
  o_aiming: 'AIMING…',
  o_auto_field: 'AUTO FIELD',
  o_beam: 'BEAM',
  o_build_here: 'BUILD HERE',
  o_caches: 'CACHES',
  o_caches_title: 'leave a cache at the position of this fleet, and read your caches',
  o_collect: 'COLLECT',
  o_collect_title: 'stop, then take every own sea object and every sea mine in the collect radius aboard, the nearest first',
  o_commit: 'PLEDGE',
  o_decoy: 'DECOY',
  o_decoy_wait: (p: { left: string | number }) => `DECOY ${p.left}`,
  o_deep_run: 'DEEP RUN',
  o_defend: 'DEFEND',
  o_escort: 'ESCORT',
  o_fire: 'FIRE',
  o_fire_base: 'FIRE TORPEDO',
  o_gather: 'GATHER',
  o_hold: 'HOLD',
  o_hold_fire: 'GUNS TIGHT',
  o_hunt: 'HUNT',
  o_lane: 'VIA LANE',
  o_lay: 'LAY',
  o_lay_empty_title: 'nothing is aboard: the Sapper takes its loadout from the Depot at the pens',
  o_lay_kind: (p: { kind: string | number }) => `LAY ${p.kind}`,
  o_lay_title: (p: { kind: string | number }) => `lay one ${p.kind} at the point of this hull; a lay makes the hull loud`,
  o_lay_wait: (p: { left: string | number }) => `LAY ${p.left}`,
  o_move: 'MOVE',
  o_patrol: 'PATROL',
  o_pick_cell: 'PICK CELL…',
  o_pick_field: 'PICK FIELD…',
  o_pick_lane: 'PICK LANE…',
  o_pick_point: 'PICK POINT…',
  o_pick_target: 'PICK TARGET…',
  o_plot: 'PLOT',
  o_rename: 'RENAME',
  o_return: 'RETURN',
  o_scan: 'SCAN',
  o_scan_wait: (p: { left: string | number }) => `SCAN ${p.left}`,
  o_search: 'SEARCH',
  o_send_hauler: 'SEND HAULER',
  o_share: 'SHARE',
  o_share_left: (p: { left: string | number }) => `SHARING ${p.left}`,
  o_surface: 'SURFACE',
  object_default: 'strategic object',
  order_steer_figs: (p: { order: string | number; deg: string | number; step: string | number }) => `${p.order} · ${p.deg}° · ${p.step}`,
  pd_from: (p: { level: string | number }) => `lvl ${p.level}`,
  pd_wait: (p: { sec: string | number }) => `${p.sec}s`,
  plan_combat: 'combat',
  plan_combat_historical: 'berths for fighting ships',
  plan_harbour: (p: { building: string | number; level: string | number }) => `${p.building} ${p.level}`,
  plan_head: 'harbour plan',
  plan_head_historical: 'Plan of the Hold',
  plan_hull: (p: { name: string | number; weight: string | number }) => `${p.name} W${p.weight}`,
  plan_limits: (p: { px: string | number }) => `harbour limits · ${p.px} px: your fleets and your squad's mend shields at the berth rate`,
  plan_limits_historical: (p: { px: string | number }) => `within the harbour limits, ${p.px} px, a ship of the house mends her shields as at a berth`,
  plan_of_historical: (p: { used: string | number; cap: string | number }) => `${p.used} of ${p.cap}`,
  plan_support: 'support',
  plan_support_historical: 'berths for the rest',
  pledge_stands: 'yours stands',
  plot_back_leg: (p: { n: string | number }) => `back to leg ${p.n}`,
  plot_back_mark: '↺',
  plot_box_off: '▢',
  plot_box_on: '▣',
  plot_done: 'DONE',
  plot_end_title: 'end the plot and send nothing',
  plot_endless: '∞',
  plot_endless_title: 'the last loop part repeats with no end',
  plot_full: 'the course holds its most legs',
  plot_grip: '⋮⋮',
  plot_join_px: (p: { px: string | number }) => `${p.px} px from the fleet`,
  plot_leg: (p: { n: string | number }) => `leg ${p.n}`,
  plot_leg_drop: 'remove this leg',
  plot_leg_px: (p: { px: string | number }) => `${p.px} px`,
  plot_legs: (p: { n: number }) => plural(p.n, {
    one: `PLOT · ${p.n} LEG`,
    other: `PLOT · ${p.n} LEGS`,
  }),
  plot_legs_head: 'legs',
  plot_loop: 'LOOP',
  plot_mark: '◇',
  plot_name_default: 'Course',
  plot_name_hint: (p: { min: string | number; max: string | number }) => `${p.min} to ${p.max} letters, spaces, apostrophes and hyphens.`,
  plot_pass_title: 'passes of this loop part: press to step',
  plot_passes: (p: { n: string | number }) => `×${p.n}`,
  plot_rename_head: (p: { name: string | number }) => `rename ${p.name}`,
  plot_reorder: 'drag a grip to reorder',
  plot_save: 'SAVE AS PLOT',
  plot_save_head: 'save the course as a plot',
  plot_sub: (p: { name: string | number; px: string | number }) => `${p.name} · ${p.px} px`,
  plot_tap: 'tap the map to add a leg',
  plot_undo: 'UNDO',
  poi_cache: 'Seeded cache',
  poi_cache_dug: 'dug',
  poi_cache_kind: 'seeded cache · treasure',
  poi_cache_note: 'A SEARCH on this cell digs the cache. The first finder takes it.',
  poi_cache_waits: 'not dug',
  poi_found: 'found',
  poi_gate: 'Current gate',
  poi_gate_kind: 'current gate',
  poi_gate_note: 'The current runs stronger through the gate.',
  poi_lair: 'Lair',
  poi_lair_kind: 'monster lair',
  poi_lair_note: 'The home of a monster. The best treasure of the sea lies here.',
  poi_monster_back: (p: { left: string | number }) => `monster gone · sails in ${p.left}`,
  poi_monster_gone: 'monster gone',
  poi_monster_home: 'monster at home',
  poi_monster_out: 'monster on the roam',
  poi_ruin: 'Ruin',
  poi_ruin_kind: 'ruin · data cores',
  poi_ruin_note: 'Old works on the sea bed. Data Cores lie here.',
  poi_vent: 'Hydrothermal vent',
  poi_vent_dry: (p: { left: string | number }) => `worked out · fills in ${p.left}`,
  poi_vent_kind: 'vent · isotopes',
  poi_vent_note: 'A Dredger gathers isotopes here.',
  poi_vent_stock: (p: { n: string | number; full: string | number }) => `${p.n} of ${p.full} isotopes`,
  quiet_mending: 'QUIET · shields mending',
  raise_title: 'show the whole card',
  ready: 'ready',
  rename_title: 'Give this hull a new name',
  report_clear: 'Clear water. No contacts in range.',
  report_hull: 'hull',
  report_kind: (p: { from: string | number; time: string | number }) => `${p.from} · ${p.time}`,
  report_show: 'SHOW ON MAP',
  report_title: 'Probe scan report',
  round_pick: (p: { name: string | number; held: string | number }) => `${p.name} ×${p.held}`,
  round_pick_title: 'Every shot fires this round. An empty round passes to the next kind that has rounds.',
  route_below: (p: { left: string | number }) => `BELOW THE RATING IN ${p.left}`,
  route_below_now: 'BELOW THE RATING',
  route_deepest: (p: { band: string | number }) => `DEEPEST · ${p.band}`,
  route_head: 'ROUTE PROFILE',
  route_rated: (p: { band: string | number }) => `RATED TO THE ${p.band}`,
  route_within: 'WITHIN THE RATING',
  seamount_bad_length: (p: { min: string | number; max: string | number }) => `A seamount name has ${p.min} to ${p.max} characters.`,
  seamount_first: 'first word',
  seamount_hint_text: (p: { min: string | number; max: string | number }) => `Or write a name of ${p.min} to ${p.max} characters. An empty box takes the two words.`,
  seamount_hint_words: 'Pick two words. Each commander reads the name in the language of the commander.',
  seamount_kind: 'seamount · your find',
  seamount_later_btn: 'LATER',
  seamount_name_btn: 'NAME',
  seamount_named_by: (p: { commander: string | number }) => `Seamount, named by ${p.commander}.`,
  seamount_preview: (p: { name: string | number }) => `The name: ${p.name}`,
  seamount_second: 'second word',
  seamount_text: 'a name of your own',
  seamount_title: 'Unnamed seamount',
  seamount_unnamed_find: 'Your find. It has no name yet: NAME opens the naming sheet.',
  search_btn: 'SEARCH',
  search_btn_title: (p: { name: string | number }) => `${p.name} sails to the point and searches there: it is as loud as a launch while it works`,
  search_fit_away: (p: { px: string | number }) => `${p.px} px away`,
  search_fit_head: 'your fleets at sea',
  search_here: 'SEARCH HERE',
  search_here_title: 'the selected fleet sails here and searches: it finds a cache and recovers cargo from the wrecks nearby, and it is as loud as a launch while it works',
  search_no_fleet: 'No combat ship and no Dredger of yours is at sea. Put one to sea, and it can search.',
  search_pick: 'SEARCH',
  search_pick_title: 'pick an own fleet that sails here and searches: it finds a cache and recovers cargo from the wrecks nearby',
  search_sheet_hint: 'A SEARCH finds a cache and recovers cargo from the wrecks nearby. The fleet sails to the point and works there, as loud as a launch. Then it sails home with what it took, which lands at your hold.',
  search_sheet_title: 'Search for a cache',
  search_unfit_cable: 'cable out',
  search_wreck_pick_title: 'pick an own fleet that sails to the wreck and searches there: it recovers part of the cargo of the wrecks nearby',
  search_wreck_sheet_title: 'Search a wreck',
  search_wreck_title: 'the selected fleet sails to the wreck and searches there: it recovers part of the cargo of the wrecks nearby and finds a cache',
  sect_opens: 'opens',
  sect_path: 'path',
  selchip_title: 'close the menu and show the selection',
  shaft: 'a shaft on worked-out ground',
  shafted: 'Worked out. Your shaft is still cutting.',
  show_fleet: (p: { name: string | number }) => `SHOW ${p.name}`,
  sig_active: (p: { left: string | number }) => `ACTIVE ${p.left}`,
  sig_active_open: 'ACTIVE',
  sig_brace: 'BRACE',
  sig_broadside: 'BROADSIDE',
  sig_canister: 'CANISTER',
  sig_charge_ready: '● READY',
  sig_charge_spent: '○ SPENT',
  sig_crash_dive: 'CRASH DIVE',
  sig_dig_in: 'DIG IN',
  sig_getaway: 'GETAWAY',
  sig_line: (p: { name: string | number; order: string | number }) => `${p.name} · ${p.order}`,
  sig_line_getaway: (p: { name: string | number; order: string | number }) => `${p.name} · ${p.order} · cargo lost`,
  sig_line_hostile: (p: { cls: string | number; order: string | number }) => `Hostile ${p.cls} · ${p.order}`,
  sig_muster: 'MUSTER',
  sig_offline: (p: { trigger: string | number }) => `Offline: fires ${p.trigger}`,
  sig_outflank: 'OUTFLANK',
  sig_ready: (p: { order: string | number }) => `${p.order} ● READY`,
  sig_recharge: (p: { dur: string | number }) => `RECHARGE ${p.dur}`,
  sig_recharge_wait: 'WAITS FOR FULL SHIELD',
  sig_spent: (p: { order: string | number }) => `${p.order} ○ SPENT`,
  slowed: 'disrupted — running slow',
  so_anchored: 'anchored',
  so_anchoring: 'anchoring',
  so_armed: 'armed',
  so_arming: 'arming',
  so_deployable: 'deployable',
  so_heard_kind: 'heard, kind unknown',
  so_heard_note: 'A hull at sea hears it: the kind stays unknown, and no gun fires on it, until a Sapper sweep, a ping or a fixed listener shows it.',
  so_heard_title: 'Sea mine',
  so_inert: 'inert',
  so_kind_hostile: (p: { family: string | number }) => `${p.family} · hostile`,
  so_kind_mate: (p: { family: string | number }) => `${p.family} · faction mate`,
  so_kind_own: (p: { family: string | number }) => `${p.family} · own`,
  so_list_back: (p: { n: string | number }) => `‹ all ${p.n} in this cell`,
  so_list_hull: 'hull',
  so_list_kind: 'in this cell',
  so_list_more: (p: { n: string | number }) => `${p.n} more in this cell ›`,
  so_list_title: (p: { n: number }) => plural(p.n, {
    one: `${p.n} object in this cell`,
    other: `${p.n} objects in this cell`,
  }),
  so_mine: 'sea mine',
  so_note_hostile_deployable: 'A gun must sink it: a Sapper cannot collect it.',
  so_note_mine: 'No hull is spared: it detonates on own hulls too.',
  so_note_mine_hostile: 'A gun fires on it when it is a target, and a Sapper at rest beside it takes it aboard.',
  so_note_own_deployable: 'No hull is spared: it acts on own hulls too.',
  sonar_heard: 'HEARD',
  speed: (p: { speed: string | number; noise: string | number }) => `${p.speed} px/min · noise ${p.noise}`,
  squad_member: 'squad member',
  st_at_sea: 'at sea',
  st_base_design: 'base design',
  st_cadet: 'cadet',
  st_done: 'done',
  st_heard: 'heard',
  st_locked: 'locked',
  st_max: 'max',
  st_open: 'open',
  st_print: (p: { name: string | number }) => `print ${p.name}`,
  st_prisoner: 'prisoner',
  st_queued: 'queued',
  st_ready: 'ready',
  st_recovering: 'recovering',
  st_scanned: 'scanned',
  st_scanned_age: (p: { age: string | number }) => `scanned · ${p.age}`,
  st_short: 'short',
  st_window: (p: { hour: string | number }) => `window ${p.hour}:00`,
  step_next: '›',
  step_next_title: 'the item after this one',
  step_of: (p: { n: string | number; m: string | number }) => `${p.n} of ${p.m}`,
  step_prev: '‹',
  step_prev_title: 'the item before this one',
  story_less: 'LESS',
  story_more: 'MORE',
  stow_empty: 'Nothing is aboard. The Sapper takes its loadout from the Depot when it puts to sea.',
  stow_head: (p: { used: string | number; cap: string | number }) => `load ${p.used}/${p.cap}`,
  stow_last: 'last',
  stow_lay: 'LAY',
  stow_row: (p: { name: string | number; n: string | number }) => `${p.name} × ${p.n}`,
  stow_row_sub_deployable: (p: { cargo: string | number }) => `deployable · ${p.cargo} cargo each`,
  stow_row_sub_mine: (p: { cargo: string | number }) => `sea mine · ${p.cargo} cargo each`,
  taken_hull: 'Taken hull',
  taken_hull_note: 'A pirate group took this hull. It sails to a den.',
  talent_title: 'talent',
  telegraph_full: 'FULL',
  telegraph_half: 'HALF',
  telegraph_slow: 'SLOW',
  telegraph_stop: 'STOP',
  trig_below_half: (p: { pct: string | number }) => `BELOW ${p.pct} % HULL`,
  trig_formation_travel: 'IN FORMATION TRAVEL',
  trig_hit_first: 'WHEN HIT FIRST',
  trig_opening_shot: 'AT THE OPENING SHOT',
  unclaimed: 'unclaimed',
  unknown: '?',
  v_cargo: 'cargo',
  v_gauge: 'gauge',
  v_hull: 'hull',
  v_magazine: 'magazine',
  v_pledges: 'pledges',
  v_point_def: 'point def',
  v_ready: 'ready',
  v_refit: 'refit',
  v_reserve: 'reserve',
  v_rounds: 'rounds',
  v_scan: 'scan',
  v_shield: 'shield',
  v_stow: 'load',
  v_tubes: 'tubes',
  v_window: 'window',
  wait_min: (p: { n: string | number }) => `↻${p.n}m`,
  wait_sec: (p: { n: string | number }) => `↻${p.n}s`,
  window_in: (p: { left: string | number }) => `in ${p.left}`,
  window_open: 'OPEN',
  work_left: (p: { left: string | number }) => `${p.left} left at the point`,
  work_sailing: 'sails to the point',
  worked_out: 'Worked out. The field silts back up within hours.',
  wreck_ago: (p: { ago: string | number }) => `${p.ago} ago`,
  wreck_cargo: 'what a SEARCH at the wreck takes, as your sonar last heard the wreck',
  wreck_note: 'A hull went down here this season.',
  wreck_pirate_note: 'The commander of the last hit holds the chart fragment of its den.',
  wreck_recovered: 'recovered',
  wreck_seen: (p: { ago: string | number }) => `seen ${p.ago} ago`,
  wreck_title: 'Wreck',
};

const chart_en: S.Chart = {
  aim_historical: (p: { px: string | number }) => `The fuze, ${p.px} paces`,
  aim_modern: (p: { px: string | number }) => `aim · fuse ${p.px} px`,
  band_words: ['SHELF', 'SLOPE', 'DEEP', 'ABYSS'],
  band_words_historical: ['shelf', 'slope', 'deep', 'abyss'],
  bank_part: (p: { count: string | number; short: string | number }) => `${p.count} ${p.short}`,
  bank_sub_modern: (p: { fields: string | number; yield: string | number }) => `${p.fields} fields · ${p.yield}`,
  bearing_eta_hours_historical: (p: { n: string | number }) => `${p.n} hours`,
  bearing_eta_minutes_historical: (p: { n: string | number }) => `${p.n} minutes`,
  bearing_historical: (p: { point: string | number; hour: string | number; eta: string | number }) => `${p.point}, at ${p.hour}, ${p.eta} away`,
  bearing_historical_brief: (p: { point: string | number }) => `${p.point}`,
  bearing_historical_short: (p: { point: string | number; eta: string | number }) => `${p.point}, ${p.eta}`,
  bearing_modern: (p: { brg: string | number; eta: string | number }) => `brg ${p.brg}° · eta ${p.eta}`,
  bearing_modern_brief: (p: { brg: string | number }) => `${p.brg}°`,
  bearing_modern_short: (p: { brg: string | number; eta: string | number }) => `${p.brg}° · ${p.eta}`,
  burgee_historical: (p: { clan: string | number; faction: string | number }) => `The ${p.clan}, a clan of the ${p.faction}`,
  burgee_modern: (p: { tag: string | number; clan: string | number; squad: string | number }) => `[${p.tag}] · ${p.clan} · squad ${p.squad}`,
  cable_historical: 'The courier, hourly',
  cable_modern: (p: { rung: string | number }) => `share · rung ${p.rung} · Oracle → squad`,
  cartouche_min_title: 'fold the chart plate',
  cartouche_scale: (p: { cells: string | number; px: string | number }) => `${p.cells} cells · ${p.px} px`,
  cartouche_season_historical: (p: { season: string | number; day: string | number }) => `Season the ${p.season}, Day ${p.day}`,
  cartouche_season_modern: (p: { season: string | number; day: string | number }) => `Season ${p.season} · day ${p.day}`,
  cartouche_season_stage_historical: (p: { season: string | number; day: string | number; stage: string | number }) => `Season the ${p.season}, Day ${p.day} · ${p.stage}`,
  cartouche_season_stage_modern: (p: { season: string | number; day: string | number; stage: string | number }) => `Season ${p.season} · day ${p.day} · ${p.stage}`,
  cartouche_season_truce_historical: (p: { season: string | number; day: string | number; left: string | number }) => `Season the ${p.season}, Day ${p.day} · Truce ${p.left}`,
  cartouche_season_truce_modern: (p: { season: string | number; day: string | number; left: string | number }) => `Season ${p.season} · day ${p.day} · truce ${p.left}`,
  cartouche_title_historical: (p: { world: string | number }) => `A Chart of ${p.world}`,
  cartouche_title_modern: (p: { world: string | number; region: string | number }) => `${p.world} · ${p.region}`,
  compass_home: (p: { brg: string | number }) => `${p.brg}°`,
  compass_north: 'N',
  compass_points: ['N', 'N by E', 'NNE', 'NE by N', 'NE', 'NE by E', 'ENE', 'E by N', 'E', 'E by S', 'ESE', 'SE by E', 'SE', 'SE by S', 'SSE', 'S by E', 'S', 'S by W', 'SSW', 'SW by S', 'SW', 'SW by W', 'WSW', 'W by S', 'W', 'W by N', 'WNW', 'NW by W', 'NW', 'NW by N', 'NNW', 'N by W'],
  designation: (p: { n: string | number; cls: string | number }) => `S${p.n} · ${p.cls}`,
  designation_historical: (p: { nth: string | number }) => `The ${p.nth} sail`,
  designation_historical_cls: (p: { nth: string | number; cls: string | number }) => `The ${p.nth} sail, ${p.cls}`,
  designation_historical_n: (p: { n: string | number }) => `Sail ${p.n}`,
  designation_unknown: (p: { n: string | number }) => `S${p.n} · ?`,
  faction_key_title: 'FACTIONS',
  faction_key_you: (p: { name: string | number }) => `${p.name} (you)`,
  fairway_narrows: 'the Narrows',
  gut_historical: 'the Gut',
  harbour_limits_historical: 'Harbour limits',
  harbour_limits_modern: 'HARBOUR LIMITS',
  hemi_e: 'E',
  hemi_n: 'N',
  hemi_s: 'S',
  hemi_w: 'W',
  heraldry_historical: (p: { faction: string | number }) => `The Seat of ${p.faction}`,
  heraldry_modern: (p: { name: string | number; index: string | number }) => `Port ${p.name} ${p.index}`,
  heraldry_sub_modern: 'faction installation',
  hold_fire_legend: 'guns housed',
  hold_site_historical: (p: { name: string | number }) => `Here stood the hold of ${p.name}`,
  hold_site_modern: (p: { name: string | number }) => `Here Stood the Hold of ${p.name}`,
  imprint_historical_1: (p: { name: string | number; edition: string | number }) => `Printed at ${p.name}, the ${p.edition} Impression`,
  imprint_historical_2: (p: { notices: string | number; build: string | number }) => `Corrected to the ${p.notices} Notice · by the hand of the Hub, ${p.build}`,
  imprint_modern_1: (p: { world: string | number; edition: string | number; notices: string | number; protocol: string | number }) => `ap ${p.world} · ed. ${p.edition} · nm ${p.notices} · protocol v${p.protocol}`,
  imprint_modern_2: (p: { hash: string | number; build: string | number }) => `pack ${p.hash} · build ${p.build}`,
  lane_corsairs: 'Corsairs reported',
  lane_course: (p: { deg: string | number }) => `${p.deg}°`,
  lane_gap_historical: 'Lt missing',
  lane_gap_tag: 'GAP',
  lane_lights_line: (p: { deg: string | number }) => `Lts in line ${p.deg}°`,
  lane_quiet_historical: 'Quiet lane',
  legend_bank: 'bank · deposits that lie together',
  legend_battle_mark: 'battle mark · a hull sunk in the last day',
  legend_card_title: 'LEGEND',
  legend_card_title_historical: 'The Legend',
  legend_commodity: 'the commodity of a field',
  legend_contested: 'contested · a siege window',
  legend_current: 'CURRENT',
  legend_current_historical: 'The Current',
  legend_current_row: (p: { n: string | number }) => `CURRENT · UP TO ${p.n} PX/MIN`,
  legend_current_row_historical: (p: { n: string | number }) => `the current: up to ${p.n} px a minute`,
  legend_danger_line: 'danger line · no passage',
  legend_depth: 'DEPTH',
  legend_depth_historical: 'The Depths',
  legend_drying_rock: 'drying rock · a single rock cell',
  legend_factions_historical: 'The Factions',
  legend_harbour_limits: 'harbour limits · fleets mend their shields',
  legend_heat: (p: { mode: string | number }) => `HEAT · ${p.mode}`,
  legend_light: 'light · a sonar ring\'s cadence and reach',
  legend_limit_line: 'limit of beam · a Beacon\'s reach',
  legend_min_title: 'minimize the legend',
  legend_npc_monsters: 'NPC MONSTERS',
  legend_npc_pirates: 'NPC PIRATES',
  legend_open_title: 'open the legend',
  legend_rock_awash: 'rock awash · a rim cell',
  legend_spoil_ground: 'spoil ground · a worked-out field',
  legend_tidal_diamond: 'tidal diamond · a structure\'s two clocks',
  legend_tide: (p: { f: string | number; step: string | number; steps: string | number }) => `TIDE · ×${p.f} · STEP ${p.step} OF ${p.steps}`,
  legend_tide_historical: (p: { f: string | number; step: string | number; steps: string | number }) => `The tide: ×${p.f}, step ${p.step} of ${p.steps}`,
  legend_tide_next: (p: { at: string | number }) => `NEXT STEP ${p.at}`,
  legend_tide_next_historical: (p: { at: string | number }) => `next step at ${p.at}`,
  legend_tide_steady: 'NO TURN',
  legend_tide_steady_historical: 'no turn',
  legend_tide_turns: (p: { at: string | number }) => `TURNS ${p.at}`,
  legend_tide_turns_historical: (p: { at: string | number }) => `turns at ${p.at}`,
  legend_title_historical: '❧ Explanation ❧',
  legend_title_modern: 'SYMBOLS · CHART 5011 · THIS READING',
  legend_torpedo_run: 'torpedo run · the reach of the round',
  letters: 'ABCDEFGHI',
  light_historical: (p: { every: string | number; range: string | number }) => `Pings each ${p.every} sec. · hears ${p.range}`,
  light_hull_historical: (p: { cls: string | number; range: string | number }) => `${p.cls} · hears ${p.range}`,
  light_modern: (p: { every: string | number; range: string | number }) => `pg ${p.every} s · ${p.range} px`,
  light_share_historical: (p: { every: string | number; range: string | number }) => `Two pings each ${p.every} sec. · hears ${p.range}`,
  light_share_modern: (p: { every: string | number; range: string | number }) => `fl(2) ${p.every} s · ${p.range} px`,
  limit_historical: 'Beyond this line the Beacon reaches not',
  limit_modern: (p: { rings: string | number }) => `LIMIT OF BEAM · ${p.rings} RINGS`,
  mark_historical: (p: { day: string | number }) => `A sinking, the ${p.day} day`,
  mark_modern: (p: { day: string | number; at: string | number }) => `day ${p.day} · ${p.at}`,
  monster_bio: 'BIO',
  monster_last: (p: { time: string | number }) => `BIOLOGICS · LAST ${p.time}`,
  monster_last_historical: 'Hic sunt dracones',
  monsters_historical: 'Here be monsters',
  monsters_modern: 'HERE BE MONSTERS',
  monument_champion_historical: (p: { season: string | number }) => `Champion of Season ${p.season}`,
  monument_champion_modern: (p: { season: string | number }) => `champion · season ${p.season}`,
  monument_champion_world_historical: (p: { world: string | number; season: string | number }) => `Champion of the ${p.world} Sea, Season ${p.season}`,
  monument_champion_world_modern: (p: { world: string | number; season: string | number }) => `champion · ${p.world} · season ${p.season}`,
  named_trench_dedication_historical: (p: { war: string | number; clan: string | number }) => `In honour of the champions of Clan War ${p.war}: ${p.clan}`,
  named_trench_dedication_modern: (p: { war: string | number; clan: string | number }) => `Clan War ${p.war} · ${p.clan}`,
  nature_ridge: 'R',
  nature_trench: 'Oz',
  picket_line: (p: { r: string | number }) => `OBSTN · PICKET · HEARD AT ${p.r}`,
  picket_line_historical: 'The boom: heard, not held',
  poi_abbr_cache: 'Cache',
  poi_abbr_dry: (p: { left: string | number }) => `dry ${p.left}`,
  poi_abbr_dug: 'dug',
  poi_abbr_ebb: (p: { mul: string | number }) => `${p.mul} eb`,
  poi_abbr_empty: 'empty',
  poi_abbr_empty_left: (p: { left: string | number }) => `empty ${p.left}`,
  poi_abbr_flood: (p: { mul: string | number }) => `${p.mul} fl`,
  poi_abbr_gate: 'Current gate',
  poi_abbr_lair: 'Lair',
  poi_abbr_left: (p: { n: string | number }) => `${p.n} left`,
  poi_abbr_ruin: 'Ru',
  poi_abbr_search: 'search',
  poi_abbr_slack: 'slack',
  poi_abbr_taken: 'taken',
  poi_abbr_vent: 'Vent',
  poi_dot_cache: 'CACHE',
  poi_dot_dug: 'DUG',
  poi_dot_ebb: (p: { mul: string | number }) => `×${p.mul} ←`,
  poi_dot_empty: 'empty',
  poi_dot_flood: (p: { mul: string | number }) => `×${p.mul} →`,
  poi_dot_gate: 'CURRENT GATE',
  poi_dot_lair: 'LAIR',
  poi_dot_ruin: 'RUIN',
  poi_dot_ruin_cores: (p: { n: string | number }) => `RUIN ▣${p.n}`,
  poi_dot_slack: (p: { mul: string | number }) => `×${p.mul} slack`,
  poi_dot_vent: 'VENT',
  poi_dot_vent_left: (p: { left: string | number }) => `VENT ${p.left}`,
  poi_dot_vent_stock: (p: { n: string | number }) => `VENT ☢${p.n}`,
  pool_monument_historical: (p: { name: string | number; world: string | number }) => `${p.name} of the ${p.world} Sea`,
  pool_monument_modern: (p: { name: string | number; world: string | number }) => `${p.name} · ${p.world}`,
  pos: (p: { lat: string | number; lon: string | number }) => `${p.lat} ${p.lon}`,
  pos_lat: (p: { d: string | number; m: string | number; h: string | number }) => `${p.d}°${p.m}′${p.h}`,
  pos_lon: (p: { d: string | number; m: string | number; h: string | number }) => `${p.d}°${p.m}′${p.h}`,
  profile_foot: 'rock · impassable · destroys a torpedo',
  profile_kind: (p: { cells: string | number }) => `ridge · ${p.cells} cells`,
  profile_step: (p: { k: string | number }) => `+${p.k}`,
  quake_historical: (p: { day: string | number; hour: string | number }) => `Here the sea shall shake next, the ${p.day} day, at ${p.hour}`,
  quake_modern: (p: { stage: string | number; px: string | number; pct: string | number; next: string | number }) => `STAGE ${p.stage} · SHOCK ${p.px} px · ${p.pct} % HULL · NEXT ${p.next}`,
  quake_ring_historical: (p: { pct: string | number }) => `So far the shock shall reach, ${p.pct} parts in the hundred`,
  quake_ring_modern: (p: { px: string | number }) => `LIMIT OF SHOCK · ${p.px} px`,
  reef_coral: 'Co',
  reef_title_historical: (p: { name: string | number }) => `Reef of ${p.name}`,
  reef_title_modern: (p: { name: string | number }) => `${p.name} Reef`,
  reload_label_ready: (p: { n: string | number; round: string | number }) => `${p.n} ${p.round}`,
  reload_label_reloading: (p: { n: string | number; round: string | number; sec: string | number }) => `${p.n} ${p.round} · ${p.sec}s`,
  reload_tag_empty: 'EMPTY',
  reload_tag_ready: 'READY',
  reload_tag_reloading: (p: { sec: string | number }) => `RLD ${p.sec}`,
  restricted_historical: (p: { hour: string | number }) => `Here they fight until ${p.hour}`,
  restricted_modern: (p: { at: string | number }) => `SIEGE WINDOW · CONTESTED · CLOSES ${p.at}`,
  restricted_open_modern: (p: { at: string | number }) => `SIEGE WINDOW · OPEN · CLOSES ${p.at}`,
  restricted_shut_historical: (p: { hour: string | number }) => `Here they may fight from ${p.hour}`,
  restricted_shut_modern: (p: { at: string | number }) => `SIEGE WINDOW · OPENS ${p.at}`,
  restricted_word_historical: 'Danger',
  rings_historical: (p: { k: string | number }) => `${p.k} cables`,
  rings_historical_one: 'A cable',
  rings_modern: (p: { k: string | number }) => `${p.k} rings`,
  rings_modern_one: (p: { px: string | number }) => `1 ring · ${p.px} px`,
  rock_historical: 'A rock',
  rock_modern: 'Rk',
  run_historical: 'The reach of the ordnance',
  run_hold_historical: 'The reach of the hold',
  run_hold_modern: (p: { kind: string | number; px: string | number }) => `${p.kind} · run ${p.px} px · the hold`,
  run_modern: (p: { kind: string | number; px: string | number }) => `${p.kind} · run ${p.px} px`,
  sail_ordinals: ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth', 'eleventh', 'twelfth'],
  seamount_dedication_historical: (p: { commander: string | number }) => `Named by ${p.commander}`,
  seamount_dedication_modern: (p: { commander: string | number }) => `Seamount · ${p.commander}`,
  speed_historical: (p: { px: string | number }) => `${p.px} paces the minute`,
  speed_modern: (p: { px: string | number }) => `${p.px} px/min`,
  spoil_historical: 'Here the ground is worked out',
  spoil_modern: 'Spoil Gnd',
  spoil_respawn: (p: { short: string | number; in: string | number }) => `${p.short} · respawn ${p.in}`,
  spoil_silts: 'silts back',
  sweep_reveal: (p: { left: string | number; painted: string | number }) => `reveal ${p.left} · ${p.painted} painted`,
  tidal_contested: (p: { own: string | number }) => `${p.own} own · contested`,
  tidal_contested_historical: (p: { own: string | number }) => `${p.own} of your own, and contested`,
  tidal_establishment: (p: { hour: string | number }) => `Est. of the Port ${p.hour}`,
  tidal_open: (p: { at: string | number }) => `open · closes ${p.at}`,
  tidal_open_historical: (p: { hour: string | number }) => `Open, and it closes at ${p.hour}`,
  tidal_opens: (p: { in: string | number }) => `vulnerable · opens in ${p.in}`,
  tidal_opens_historical: (p: { in: string | number }) => `Shut, and it opens in ${p.in}`,
  tidal_quiet: (p: { own: string | number }) => `${p.own} own · quiet`,
  tidal_quiet_historical: (p: { own: string | number }) => `${p.own} of your own, and quiet`,
  tidal_span_historical: (p: { m: string | number }) => `${p.m} m.`,
  warning_lines_modern: ['LIMIT OF THE WORLD', 'no order past this line', 'a move stops at the edge'],
  warning_sub_historical: 'Ultra hos fines nulla est navigatio',
  warning_title_historical: 'HIC SVNT DRACONES',
  warning_title_modern: 'CAUTION',
  watch_designation: (p: { n: string | number }) => `S${p.n}`,
  watch_head: (p: { min: string | number }) => `PICKET · WATERFALL · LAST ${p.min} MIN`,
  watch_head_historical: 'The listening watch',
  watch_quiet: 'NOTHING HEARD',
  watch_quiet_historical: 'A quiet watch',
  works_historical: (p: { job: string | number }) => `A ${p.job} a-building`,
  works_modern: (p: { job: string | number; min: string | number }) => `works · ${p.job} · ${p.min} min`,
  works_next: (p: { job: string | number }) => `then ${p.job}`,
};

const chatfilter_en: S.Chatfilter = {
  words: 'fuck fucks fucked fucker fuckers fucking fuckin fuk fck motherfucker motherfuckers cunt cunts twat cocksucker cocksuckers bitch bitches whore whores slut sluts nigger niggers nigga niggas faggot faggots fag fags retard retards retarded kike kikes spic spics chink chinks tranny trannies wetback wetbacks gook gooks paki pakis',
};

const choice_en: S.Choice = {
  close_title: 'close',
  locked_title: 'locked',
  now: 'NOW',
};

const chronicle_en: S.Chronicle = {
  book_title: 'SEASON CHRONICLE',
  close_down: ['WE FELL {places} PLACES TO RANK {rank}. SCORE {score}.', 'DOWN {places} TO RANK {rank}, WITH {score} POINTS.'],
  close_level: ['WE HOLD RANK {rank}. SCORE {score}.', 'NO CHANGE: RANK {rank}, {score} POINTS.'],
  close_up: ['WE CLIMBED {places} PLACES TO RANK {rank}. SCORE {score}.', 'UP {places} TO RANK {rank}, WITH {score} POINTS.'],
  closed_tag: 'CLOSED',
  copy_by_hand: 'COPY THIS ADDRESS:',
  copy_link: 'COPY LINK',
  day_header: (p: { day: string | number; season: string | number; world: string | number }) => `DAY ${p.day} · SEASON ${p.season} · ${p.world}`,
  kind_building_done: ['THE {building} REACHED LEVEL {level}.', 'OUR ENGINEERS FINISHED THE {building}, LEVEL {level}.'],
  kind_cache_taken: ['{finder} FOUND YOUR CACHE ON THE SEA BED.', 'YOUR CACHE HAD A VISITOR: {finder}.'],
  kind_captain_captured: ['THE ENEMY PULLED {captain} FROM THE WATER. THE RANSOM IS {ransom}.', '{captain} IS A PRISONER. THEY ASK {ransom} FOR THE RETURN.'],
  kind_captain_ransomed: ['WE PAID THE RANSOM. {captain} IS HOME.', '{captain} CAME BACK FROM THE ENEMY BRIG.'],
  kind_captain_recruited: ['{captain} JOINED THE WARDROOM.', 'WE TOOK {captain} INTO THE WARDROOM.', 'A NEW OFFICER CAME ABOARD: {captain}.'],
  kind_captain_taken: ['WE TOOK {captain} OF {owner} PRISONER. THE RANSOM IS {ransom}.', '{captain}, AN OFFICER OF {owner}, SITS IN OUR BRIG.'],
  kind_cells_taken: ['WE TOOK {cells} CELLS OF WATER.', 'OUR BEACONS MOVED THE LINE BY {cells} CELLS.', '{cells} NEW CELLS FLY OUR BANNER.'],
  kind_expedition_core: ['{captain} CAME UP WITH {isotopes} ISOTOPES AND A DATA CORE.', 'A DATA CORE FROM THE DEEP. {captain} FOUND IT, WITH {isotopes} ISOTOPES.'],
  kind_expedition_hurt: ['{captain} CAME UP HURT, WITH {isotopes} ISOTOPES.', 'THE DEEP HURT {captain}. THE DIVE BROUGHT {isotopes} ISOTOPES.'],
  kind_expedition_hurt_core: ['{captain} CAME UP HURT, BUT WITH A DATA CORE AND {isotopes} ISOTOPES.', 'A DATA CORE, AND A PRICE: {captain} IS HURT. {isotopes} ISOTOPES CAME UP TOO.'],
  kind_expedition_ok: ['{captain} CAME UP FROM THE DEEP WITH {isotopes} ISOTOPES.', 'THE DIVE OF {captain} BROUGHT BACK {isotopes} ISOTOPES.'],
  kind_first_siege: ['WE PLEDGED OUR FIRST FLEET TO A SIEGE, AT {site}.', 'OUR FIRST SIEGE OF THE SEASON: {site}.'],
  kind_fleet_killed: ['OUR FIRE SANK {fleet} OF {owner}.', 'WE SENT {fleet} OF {owner} TO THE BOTTOM.', '{owner} LOST {fleet} TO OUR GUNS.'],
  kind_fleet_lost: ['WE LOST {fleet}.', '{fleet} WENT DOWN WITH ALL HULLS.', '{fleet} DID NOT COME BACK.'],
  kind_fleet_lost_captain: ['WE LOST {fleet}, AND {captain} WITH IT.', '{fleet} WENT DOWN WITH {captain} ON THE BRIDGE.', '{captain} WAS ON {fleet} WHEN IT SANK.'],
  kind_hold_under_fire: ['THE {foe} FIRED CLOSE TO OUR HOLD.', 'WE HEARD {foe} GUNS NEAR THE HOLD.'],
  kind_milestone_first_kill: ['WE SANK OUR FIRST ENEMY HULL.', 'FIRST KILL.'],
  kind_milestone_first_loss: ['WE LOST OUR FIRST HULL.', 'FIRST LOSS.'],
  kind_milestone_first_ship: ['OUR FIRST HULL LEFT THE YARD.', 'FIRST HULL READY IN THE PENS.'],
  kind_milestone_first_siege: ['WE PLEDGED OUR FIRST FLEET TO A SIEGE.', 'FIRST SIEGE.'],
  kind_milestone_first_tech: ['WE RECOVERED OUR FIRST TECH NODE.', 'FIRST TECH RECOVERED.'],
  kind_object_fell: ['{site} FELL TO THE {faction}.', 'THE {faction} TOOK {site}.'],
  kind_quake_stage: ['THE SEAQUAKE REACHED STAGE {stage}.', 'THE SEA FLOOR SHOOK. THE SEAQUAKE IS AT STAGE {stage}.'],
  kind_research_done: ['WE RECOVERED {tech}.', 'THE LABORATORY GAVE US {tech}.'],
  kind_season_captains: ['{carried} CAPTAINS CROSSED THE LINE. {lost} DID NOT.', 'THE CATACLYSM LEFT US {carried} CAPTAINS AND TOOK {lost}.'],
  kind_season_honour: ['THE SEASON GAVE US {honour} HONOUR.', '{honour} HONOUR FOR THE SEASON.'],
  kind_season_most_lost: ['THE STORAGE CAP DESTROYED {units} {resource}.', 'MOST LOST TO THE CAP: {units} {resource}.'],
  kind_season_most_mined: ['WE MINED {units} {resource}, MORE THAN ANY OTHER RESOURCE.', 'MOST MINED: {units} {resource}.'],
  kind_season_most_spent: ['WE SPENT {units} {resource}, MORE THAN ANY OTHER RESOURCE.', 'MOST SPENT: {units} {resource}.'],
  kind_season_rank: ['WE CLOSED THE SEASON AT RANK {rank} OF {of}.', 'RANK {rank} OF {of} AT THE CATACLYSM.'],
  kind_season_score: ['OUR SEASON SCORE: {score}.', 'WE SCORED {score} THIS SEASON.'],
  kind_season_tech: ['{branch}: {nodes} NODES.', '{nodes} NODES OF {branch}.'],
  kind_season_title: ['WE CARRY THE TITLE {title}.', 'OUR TITLE NOW: {title}.'],
  kind_siege_broken: ['THE {foe} HIT {site} HARD. WE KEPT IT, BUT AT A PRICE.', 'WE LOST THE WINDOW AT {site} TO THE {foe}. THE SITE IS STILL OURS.'],
  kind_siege_fell: ['{site} FELL TO THE {foe}.', 'WE LOST {site}. THE {foe} FLY THEIR BANNER THERE NOW.', 'THE {foe} TOOK {site} FROM US.'],
  kind_siege_held: ['WE HELD {site} AGAINST THE {foe}.', 'THE {foe} CAME FOR {site}. THEY LEFT WITH NOTHING.', '{site} STANDS. THE {foe} ATTACK BROKE ON OUR LINE.'],
  kind_siege_mauled: ['WE STRUCK {site} HARD. THE {foe} STILL HOLD IT, BUT BARELY.', 'THE {foe} BLED AT {site}. THE SITE DID NOT FALL.', 'WE WON THE WINDOW AT {site}, BUT THE {foe} KEPT THE SITE.'],
  kind_siege_opened_attack: ['OUR FACTION OPENED A SIEGE AT {site}.', 'THE FIRST PLEDGES WENT OUT AGAINST {site}.'],
  kind_siege_opened_defend: ['AN ENEMY SIEGE OPENED AGAINST {site}.', 'THE ENEMY PLEDGED FLEETS AGAINST {site}.'],
  kind_siege_repulsed: ['THE {foe} THREW US BACK FROM {site}.', 'OUR ATTACK ON {site} FAILED. THE {foe} HELD.', 'WE WITHDREW FROM {site}. THE {foe} WERE TOO STRONG.'],
  kind_siege_took: ['WE STORMED {site} AND TOOK IT FROM THE {foe}.', '{site} IS OURS. THE {foe} COULD NOT HOLD IT.', 'OUR FLEETS BROKE THE {foe} AT {site} AND RAISED OUR BANNER.'],
  kind_territory_lost: ['THE {foe} PUSHED OUR LINE BACK.', 'WE LOST WATER TO THE {foe}.'],
  kind_torpedo_hit: ['OUR {torpedo} FROM {launcher} FOUND {count} HULLS.', '{launcher} FIRED A {torpedo}. IT HIT {count} HULLS.'],
  kind_torpedo_struck: ['A {torpedo} OF {owner} STRUCK {count} OF OUR HULLS.', '{owner} HIT {count} OF OUR HULLS WITH A {torpedo}.'],
  kind_truce_ended: ['THE FOUNDING TRUCE ENDED. THE WAR BEGINS.', 'NO MORE TRUCE. THE GUNS ARE FREE.'],
  label_captains: 'CAPTAINS',
  label_ledger: 'LEDGER',
  label_milestones: 'MILESTONES',
  label_tech: 'TECH BY BRANCH',
  link_copied: 'LINK COPIED',
  live_tag: 'LIVE',
  moment_day: (p: { day: string | number }) => `DAY ${p.day}`,
  moment_mark: 'MOMENT',
  moments: 'MOMENTS',
  neutral_foe: 'GARRISON',
  no_page: 'NO PAGE IS WRITTEN YET',
  no_volume: 'NO VOLUME IS WRITTEN YET',
  no_volume_why: 'THE GAME WRITES A DAY PAGE AT THE END OF EACH SEASON DAY.',
  not_shared: 'THIS VOLUME IS NOT SHARED',
  not_shared_why: 'THE COMMANDER KEEPS IT PRIVATE, OR THE ADDRESS IS WRONG.',
  open_book: 'OPEN THE BOOK',
  quiet: ['THE HOLD WAS QUIET.', 'NOTHING MOVED ON OUR WATER TODAY.', 'A QUIET DAY. THE CREWS RESTED.'],
  reader_anon: (p: { world: string | number }) => `A SHARED CHRONICLE · ${p.world}`,
  reader_home: 'PLAY AQUAPHOBIA',
  reader_title: (p: { commander: string | number; world: string | number }) => `THE CHRONICLE OF ${p.commander} · ${p.world}`,
  reader_what: 'A SHARED VOLUME. ANY PLAYER WITH THIS ADDRESS CAN READ IT.',
  replay: 'REPLAY',
  replay_link_gone: 'THAT FIGHT IS NOT IN THE COMBAT LOG OF THIS SEASON.',
  season_header: (p: { season: string | number; world: string | number }) => `SEASON ${p.season} · ${p.world}`,
  share_live: 'A LIVE SEASON CANNOT BE SHARED',
  share_off: 'PRIVATE',
  share_on: 'SHARED',
  share_what: 'ONLY YOU CAN READ A PRIVATE VOLUME. ANY PLAYER CAN READ A SHARED VOLUME.',
  times_suffix: (p: { times: string | number }) => `(×${p.times})`,
  voice_command: ['FOLLOW ME.', 'THE CREW STOOD FIRM.', 'WE GO TOGETHER OR NOT AT ALL.', 'HOLD THE LINE.'],
  voice_engineering: ['SHE WILL HOLD.', 'THE PATCHES KEPT HER AFLOAT.', 'GIVE ME AN HOUR AND A WRENCH.', 'THE ENGINES NEVER FAILED US.'],
  voice_gunnery: ['AIM FOR THE WATERLINE.', 'EVERY SHOT COUNTS.', 'LOAD AGAIN.', 'THE GUNS DID THEIR WORK.'],
  voice_helmsmanship: ['HARD TO PORT.', 'KEEP HER STEADY.', 'THE CURRENT WAS WITH US.', 'I KNOW THESE WATERS.'],
  voice_prospecting: ['THE DEEP HAS MORE TO GIVE.', 'I SMELL ISOTOPES.', 'MARK THE SPOT.', 'RICH WATER, THIS.'],
  voice_quiet_hand: ['SILENT RUNNING.', 'THEY NEVER HEARD US.', 'NOT A SOUND.', 'STAY LOW. STAY QUIET.'],
  voice_remark: (p: { captain: string | number; remark: string | number }) => `${p.captain}: “${p.remark}”`,
  volume_label: (p: { season: string | number; world: string | number }) => `VOLUME ${p.season} · ${p.world}`,
  volume_newer: 'NEWER VOLUME',
  volume_older: 'OLDER VOLUME',
  volume_place: (p: { at: string | number; of: string | number }) => `${p.at} / ${p.of}`,
};

const connection_en: S.Connection = {
  protocol_refused: (p: { proto: string | number }) => `the server refused protocol v${p.proto}`,
  ticket_refused: 'the server refused the join ticket',
};

const designerApp_en: S.DesignerApp = {
  chip_size: (p: { cols: string | number; rows: string | number; cells: string | number }) => `${p.cols} × ${p.rows} · ${p.cells} CELLS`,
  live_core_figure: 'core figure',
  notice_downloaded: (p: { file: string | number }) => `${p.file} downloaded`,
  notice_downloaded_errors: (p: { count: number; file: string | number }) => plural(p.count, {
    one: `${p.file} downloaded, and it holds ${p.count} error`,
    other: `${p.file} downloaded, and it holds ${p.count} errors`,
  }),
  notice_draft_restored: 'draft restored',
  notice_dropped: (p: { count: number }) => plural(p.count, {
    one: `${p.count} item fell outside the new grid and was dropped`,
    other: `${p.count} items fell outside the new grid and were dropped`,
  }),
  notice_laid_rock: 'a laid object stands on water or a trench, not on rock',
  notice_loaded_clean: (p: { file: string | number }) => `${p.file} loaded, and every rule passes`,
  notice_loaded_errors: (p: { count: number; file: string | number }) => plural(p.count, {
    one: `${p.file} loaded, and the validator finds ${p.count} error`,
    other: `${p.file} loaded, and the validator finds ${p.count} errors`,
  }),
  notice_marker_ceiling: (p: { max_markers: string | number }) => `${p.max_markers} markers is the ceiling`,
  notice_new_map: 'a new map, at the size you were on',
  notice_no_seat: (p: { slot: string | number }) => `seat ${p.slot} is not on the map: add it in the MAP tab`,
  notice_no_variant: 'the map lists no ship variant',
  notice_not_a_map: (p: { file: string | number; error: string | number }) => `${p.file} is not a map file: ${p.error}`,
  notice_open_path_differs: (p: { opened: string | number; category: string | number; file: string | number }) => `opened maps/${p.opened}; PUBLISH writes maps/${p.category}/${p.file}`,
  notice_preset_dropped: (p: { count: number; preset: string | number }) => plural(p.count, {
    one: `${p.preset}: ${p.count} item fell outside the new grid and was dropped`,
    other: `${p.preset}: ${p.count} items fell outside the new grid and were dropped`,
  }),
  notice_seat_ceiling: (p: { max_players: string | number }) => `${p.max_players} seats is the ceiling`,
  notice_sym_dropped: 'the symmetry does not fit the new grid, so the map states none',
  notice_sym_pick_120: 'press the map near a cell centre or a vertex',
  notice_sym_pick_180: 'press the map near a cell centre or an edge midpoint',
  notice_sym_rocked: (p: { count: number }) => plural(p.count, {
    one: `${p.count} unpaired cell turned to rock`,
    other: `${p.count} unpaired cells turned to rock`,
  }),
  notice_sym_set: (p: { cell: string | number; at: string | number }) => `the map turns about cell ${p.cell} · ${p.at}`,
  notice_undo_back: 'brings it back',
  notice_unpaired: 'an unpaired cell stays rock',
  notice_wrote: (p: { path: string | number }) => `wrote ${p.path}`,
  notice_wrote_errors: (p: { path: string | number; count: string | number }) => `wrote ${p.path}, and it holds ${p.count} errors`,
};

const designerCommunity_en: S.DesignerCommunity = {
  arm_body: (p: { likes: string | number; name: string | number; plays: number; revision: string | number }) => plural(p.plays, {
    one: `A replace starts a new map with a new code. ${p.name} leaves COMMUNITY with its ${p.likes} ♥︎, ${p.plays} play and r${p.revision}.`,
    other: `A replace starts a new map with a new code. ${p.name} leaves COMMUNITY with its ${p.likes} ♥︎, ${p.plays} plays and r${p.revision}.`,
  }),
  arm_head: (p: { name: string | number }) => `REPLACE ${p.name}?`,
  btn_publish: 'PUBLISH',
  btn_sign_in: 'SIGN IN TO PUBLISH',
  btn_sign_in_short: 'SIGN IN',
  check_cap: 'CHECK',
  check_clean: (p: { kb: string | number }) => `every rule passes · ${p.kb} KB`,
  check_errors: (p: { count: number }) => plural(p.count, {
    one: `${p.count} error · mend it to publish`,
    other: `${p.count} errors · mend them to publish`,
  }),
  check_ok: (p: { count: number; kb: string | number }) => plural(p.count, {
    one: `${p.count} warning · ${p.kb} KB`,
    other: `${p.count} warnings · ${p.kb} KB`,
  }),
  check_open: 'OPEN CHECK ›',
  chip_featured: 'FEATURED',
  chip_in_play: (p: { revision: string | number }) => `IN PLAY r${p.revision}`,
  chip_taken_down: 'TAKEN DOWN',
  chip_waits: (p: { revision: string | number }) => `r${p.revision} WAITS`,
  done: (p: { revision: string | number; hash: string | number }) => `Published r${p.revision} · ${p.hash} · the arcade gets it within one heartbeat`,
  done_same: (p: { revision: string | number; hash: string | number }) => `No change: the bytes match r${p.revision} · ${p.hash}`,
  eff_full: 'No space is free. Pick a map to replace, or UNPUBLISH one in MY MAPS of the arcade lobby.',
  eff_new: 'A new map: a new code, 0 ♥︎, 0 plays.',
  eff_pick: 'Pick the space that gets this map.',
  eff_pin: (p: { revision: string | number }) => `The PLAY lane keeps r${p.revision} until an operator moves the pin.`,
  eff_revision: (p: { revision: string | number }) => `COMMUNITY shows r${p.revision} within one heartbeat. The likes and the plays stay with the map.`,
  eff_same: (p: { revision: string | number }) => `This document has the bytes of r${p.revision}. A publish makes no new revision.`,
  eff_same_hint: 'Pick another space to start a new map from it.',
  effect_head: 'WHAT THE PUBLISH DOES',
  lock_body: (p: { slots: string | number }) => `Premium gives ${p.slots} map spaces in COMMUNITY. DOWNLOAD FILE in ⋯ works for every account.`,
  lock_head: 'Publishing needs Premium',
  lock_link: 'PREMIUM IN THE SHOP ›',
  note_cap: 'NOTE',
  note_hint: 'a change note, optional',
  open_failed: (p: { error: string | number }) => `The map did not load: ${p.error}`,
  opened: (p: { name: string | number; revision: string | number }) => `${p.name} r${p.revision} opened from COMMUNITY`,
  opened_copy: (p: { code: string | number }) => `${p.code} is not a map of your spaces. It opened as a new document with no tie to it.`,
  place: (p: { code: string | number; revision: string | number }) => `COMMUNITY · ${p.code} · r${p.revision}`,
  place_dot: (p: { revision: string | number }) => `This document differs from r${p.revision}.`,
  press_busy: 'PUBLISHING',
  press_cancel: 'CANCEL',
  press_pick: 'PICK A SPACE',
  press_publish: (p: { revision: string | number }) => `PUBLISH r${p.revision}`,
  press_replace: (p: { name: string | number }) => `REPLACE ${p.name}`,
  press_same: 'NO CHANGE',
  refused: (p: { error: string | number }) => `The publish was refused: ${p.error}`,
  rev: (p: { revision: string | number }) => `r${p.revision}`,
  same_cap: 'NO CHANGE',
  same_line: (p: { revision: string | number; hash: string | number }) => `the bytes match r${p.revision} · ${p.hash}`,
  sheet_close: 'close',
  sheet_head: 'PUBLISH',
  sign_in_body: 'The hub opens in a new tab. This tab keeps the document while you sign in.',
  sign_in_head: 'Sign in to publish',
  sign_in_link: 'SIGN IN ›',
  size_cap: 'SIZE',
  size_line: (p: { kb: string | number; max_kb: string | number }) => `${p.kb} KB · the limit is ${p.max_kb} KB`,
  slot_empty: (p: { slot: string | number }) => `EMPTY · SPACE ${p.slot}`,
  slot_empty_sub: 'a new map with a new code',
  slot_open: 'OPEN',
  slot_open_title: 'open this map in the designer',
  slot_sub: (p: { code: string | number; likes: string | number; plays: number; revision: string | number }) => plural(p.plays, {
    one: `r${p.revision} · ${p.likes} ♥︎ · ${p.plays} play · ${p.code}`,
    other: `r${p.revision} · ${p.likes} ♥︎ · ${p.plays} plays · ${p.code}`,
  }),
  slot_tag: (p: { slot: string | number }) => `SPACE ${p.slot}`,
  slots_failed: (p: { error: string | number }) => `The map spaces did not load: ${p.error}`,
  slots_head: 'MAP SPACES',
  slots_loading: 'The map spaces load.',
  slots_used: (p: { used: string | number; slots: string | number }) => `${p.used} of ${p.slots} · PREMIUM`,
};

const designerDrawer_en: S.DesignerDrawer = {
  add_slot: '+ ADD SEAT',
  add_variant: '+ ADD VARIANT',
  advanced_title: 'open or shut the raw keys of the map file',
  base_no: 'no base',
  base_yes: '1 base',
  bases_placed: 'BASES PLACED',
  bound_finding: (p: { field: string | number; value: string | number; min: string | number; max: string | number }) => `${p.field} is ${p.value}, outside the community bounds ${p.min} to ${p.max}`,
  bounty_less: 'smaller bounty',
  bounty_more: 'larger bounty',
  bounty_value: (p: { credits: string | number }) => `${p.credits} credits`,
  brief_base: 'One base per seat, exactly.',
  brief_battery: 'A structure that fires at what it hears.',
  brief_breakwater: 'A structure that takes rounds out of the water.',
  brief_den: 'A pirate group sails from it on a timer.',
  brief_deployable: 'A deployable on its anchor from the start.',
  brief_erase: 'Lifts all but the terrain.',
  brief_fairway: 'One drag paints one fairway chain. Buoys and lit water.',
  brief_fbase: 'A team base with its sonar range.',
  brief_field: 'A field of a resource and its units.',
  brief_fleet: 'A fleet: a seat and a variant.',
  brief_inspect: 'Reads a cell. Changes nothing.',
  brief_lair: 'A monster on a trench. Its kill pays.',
  brief_marker: 'A note on a tile. No effect.',
  brief_ridge: 'Rock blocks and carries nothing.',
  brief_seamine: 'A sea mine, armed from the start.',
  brief_sov: 'Paints a team. UNCLAIMED lifts it.',
  brief_spire: 'A structure that gives sonar.',
  brief_throne: 'A structure with no effect. A win goal.',
  brief_trench: 'Navigable, and slower.',
  brief_ward: 'A structure that mends hulls in its aura.',
  brief_water: 'Paints water under the brush.',
  brush_cells: (p: { cells: number }) => plural(p.cells, {
    one: `${p.cells} cell`,
    other: `${p.cells} cells`,
  }),
  brush_note: (p: { cells: number; radius: string | number; size: string | number }) => plural(p.cells, {
    one: `A brush of size ${p.size} paints ${p.cells} cell: the hex disc of radius ${p.radius}. Terrain and sov paint on a drag; an object or a fleet is placed by one press.`,
    other: `A brush of size ${p.size} paints ${p.cells} cells: the hex disc of radius ${p.radius}. Terrain and sov paint on a drag; an object or a fleet is placed by one press.`,
  }),
  btn_download: 'DOWNLOAD FILE',
  btn_load: 'LOAD FILE',
  btn_load_map: 'LOAD MAP',
  btn_new: '✦ NEW',
  btn_open: '⌸ OPEN',
  btn_publish: '↥ PUBLISH TO REPO',
  btn_redo: '↷ REDO',
  btn_sym_cancel: 'STOP PICK',
  btn_sym_pick: 'PICK ON MAP',
  btn_undo: '↶ UNDO',
  buyable_chip: 'BUY',
  cell_ref: (p: { cell: string | number }) => `cell ${p.cell}`,
  chip_fit: 'FIT',
  chip_fit_title: 'show the whole map',
  chip_inspect_title: 'INSPECT: the next tap on the map reads a cell',
  clean_report: (p: { cells: string | number; seats: string | number; rows: string | number }) => `Every rule passes. ${p.cells} cells, ${p.seats} seats, ${p.rows} terrain rows.`,
  clean_sub: 'the map is ready to download',
  count_errors: 'ERRORS',
  count_file: 'FILE',
  count_warnings: 'WARNINGS',
  current_scale_less: 'weaker current',
  current_scale_more: 'stronger current',
  del_title: 'take this row out',
  download_broken: 'DOWNLOAD IS A BROKEN MAP',
  errors_chip: (p: { count: number }) => plural(p.count, {
    one: `✕ ${p.count} ERROR`,
    other: `✕ ${p.count} ERRORS`,
  }),
  fix_title: 'open the section that edits this',
  group_advanced: 'ADVANCED',
  group_auto_spawn: 'AUTO-SPAWN',
  group_brush_subject: 'THE BRUSH SUBJECT',
  group_clocks: 'CLOCKS & TIMEOUT',
  group_dimensions: 'DIMENSIONS',
  group_economy: 'ECONOMY',
  group_file: 'FILE',
  group_identity: 'IDENTITY',
  group_players: 'PLAYERS & TEAMS',
  group_rules: 'RULES',
  group_sea_objects: 'SEA OBJECTS',
  group_ship_variants: 'SHIP VARIANTS',
  group_sovereignty: 'SOVEREIGNTY',
  group_starting_torpedoes: 'STARTING TORPEDOES',
  group_structures: 'STRUCTURES',
  group_symmetry: 'SYMMETRY',
  group_torpedoes: 'TORPEDOES',
  group_win: 'WIN CONDITION',
  group_winline: 'THE LINE, AS THE LOBBY READS IT',
  guard_default: (p: { value: string | number }) => `${p.value} · default`,
  handle_title: 'shut or open the column',
  heading_less: 'turn the line anticlockwise',
  heading_more: 'turn the line clockwise',
  heading_value: (p: { deg: string | number }) => `${p.deg}°`,
  insp_at: (p: { col: string | number; row: string | number }) => `col ${p.col} · row ${p.row}`,
  insp_empty: 'Nothing is placed on this cell.',
  insp_errors: (p: { count: number }) => plural(p.count, {
    one: `${p.count} ERROR`,
    other: `${p.count} ERRORS`,
  }),
  insp_findings: 'FINDINGS',
  insp_fleet: 'fleet',
  insp_laid: 'sea object',
  insp_marker: 'marker',
  insp_note: 'INSPECT changes nothing. ESC lets the cell go; the next press pins another cell.',
  insp_object: 'object',
  insp_pinned: 'PINNED',
  insp_sov: 'sov',
  insp_terrain: 'terrain',
  insp_title: (p: { cell: string | number }) => `CELL ${p.cell}`,
  insp_warnings: (p: { count: number }) => plural(p.count, {
    one: `${p.count} WARNING`,
    other: `${p.count} WARNINGS`,
  }),
  key_base: 'player base',
  key_capture: 'capture ring',
  key_den: 'den of a pirate group',
  key_deployable: 'laid deployable · a line lies across its heading',
  key_fairway: 'painted fairway',
  key_fbase: 'faction base',
  key_field: 'resource field',
  key_finding: 'a finding, by its number',
  key_fleet: 'starting fleet',
  key_lair: 'lair of a monster',
  key_marker: 'marker',
  key_objective: 'objective structure',
  key_ridge: 'ridge',
  key_seamine: 'laid sea mine · dashed: neutral',
  key_sov: 'starting sov of a team',
  key_sov_rock: 'sov on rock · a finding',
  key_structure: 'structure, in the owner ink',
  key_symmetry: 'symmetry centre and sector edges',
  key_title: 'KEY',
  key_trench: 'trench',
  key_unpaired: 'unpaired cell · stays rock',
  key_water: 'water',
  line_seats: (p: { count: number }) => plural(p.count, {
    one: `${p.count} SEAT`,
    other: `${p.count} SEATS`,
  }),
  live_capture_default: (p: { seconds: string | number }) => `default ${p.seconds} s`,
  marker_arrow: '➜ ARROW',
  marker_circle: '◯ CIRCLE',
  marker_headings: ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'],
  mend_base_slot: (p: { erase: string | number }) => `To mend it: add the seat in the MAP tab, or ERASE (${p.erase}) the base.`,
  mend_cell_unique: (p: { erase: string | number }) => `To mend it: ERASE (${p.erase}) the cell, then place one thing on it again.`,
  mend_den_apron: (p: { erase: string | number }) => `To mend it: ERASE (${p.erase}) the den and place it further from the player bases and the structures.`,
  mend_den_brotherhood: 'To mend it: pick a BROTHERHOOD on this card.',
  mend_den_design: 'To mend it: pick a DESIGN on this card.',
  mend_den_wave: 'To mend it: step WAVE TIMER on this card back inside its bounds.',
  mend_fairway_cell_unique: (p: { erase: string | number }) => `To mend it: ERASE (${p.erase}) the cell, then paint one chain over it.`,
  mend_fairway_chain: (p: { erase: string | number }) => `To mend it: ERASE (${p.erase}) the chain and paint it again in one drag, cell by cell.`,
  mend_fairway_on_ridge: (p: { erase: string | number; water: string | number }) => `To mend it: ERASE (${p.erase}) the fairway cell, or paint WATER (${p.water}) under it.`,
  mend_field_units: 'To mend it: place the field again with units over 0, or set the field units in ADVANCED of the MAP tab.',
  mend_fleet_class_cap: (p: { erase: string | number }) => `To mend it: ERASE (${p.erase}) the starting fleet past the cap of its class, or take the variant out of the auto spawns in the UNITS tab.`,
  mend_fleet_on_ridge: (p: { erase: string | number; water: string | number }) => `To mend it: ERASE (${p.erase}) lifts the fleet, WATER (${p.water}) clears the rock.`,
  mend_fleet_slot: (p: { erase: string | number }) => `To mend it: add the seat in the MAP tab, or ERASE (${p.erase}) the fleet.`,
  mend_fleet_variant: (p: { erase: string | number }) => `To mend it: add the variant in the UNITS tab, or ERASE (${p.erase}) the fleet.`,
  mend_guard_reach: 'To mend it: step REACH on this card back inside its bounds. Only a Reef Breakwater carries a reach.',
  mend_guard_reload: 'To mend it: step RELOAD on this card back inside its bounds. Only a Reef Breakwater carries a reload.',
  mend_lair_bounty: 'To mend it: step BOUNTY on this card back inside its bounds.',
  mend_lair_design: 'To mend it: pick a DESIGN on this card.',
  mend_lair_kind: 'To mend it: pick a KIND on this card.',
  mend_lair_respawn: 'To mend it: step RESPAWN on this card back inside its bounds.',
  mend_lair_trench: (p: { erase: string | number }) => `To mend it: paint TRENCH under the lair, or ERASE (${p.erase}) it and place it on a trench.`,
  mend_load: 'LOAD IT',
  mend_load_title: 'add the round to the mix of the first hull that fires it',
  mend_npc_field: (p: { erase: string | number }) => `To mend it: ERASE (${p.erase}) the object and place it again. Only a den or a lair carries these fields.`,
  mend_object_on_ridge: (p: { erase: string | number; water: string | number }) => `To mend it: ERASE (${p.erase}) lifts the object, WATER (${p.water}) clears the rock.`,
  mend_objective_unused: 'To mend it: pick HOLD OBJECTIVES in the WIN tab, or turn OBJECTIVE off on this card.',
  mend_sapper: 'ADD SAPPER',
  mend_sapper_title: 'add a Sapper variant to the ships list',
  mend_sell: 'SELL A SEA MINE',
  mend_sell_title: 'sell the cheapest sea mine at its derived price',
  mend_sov_on_ridge: (p: { sov: string | number; water: string | number }) => `To mend it: PAINT SOV (${p.sov}) with UNCLAIMED lifts the claim, WATER (${p.water}) clears the rock.`,
  mend_stow: 'MEND STOW',
  mend_stow_title: 'take out each stow row the map does not stock, and cut the stow to the Sapper cargo',
  mend_structure_flag: (p: { erase: string | number }) => `To mend it: ERASE (${p.erase}) the object and place it again. Only a structure carries the two flags.`,
  mend_structure_objective: 'To mend it: turn CAPTURABLE on on this card, or turn OBJECTIVE off.',
  mend_structure_team: 'To mend it: pick NEUTRAL or a seated team as OWNER on this card, or add the seat in the MAP tab.',
  mend_symmetry_content: (p: { erase: string | number }) => `To mend it: place the entry again with MIRROR EDITS on, or ERASE (${p.erase}) it and its image.`,
  mend_symmetry_terrain: 'To mend it: paint the cell again with MIRROR EDITS on, and one press writes the cell and every image.',
  mend_win_cell: (p: { water: string | number }) => `To mend it: pick another tile for the SOV CELL condition in the WIN tab, or paint WATER (${p.water}) here.`,
  menu_edit: 'EDIT',
  menu_file: 'FILE',
  menu_repo: 'REPO',
  name_placeholder: 'Map name',
  no_cell: 'no cell',
  no_seat_yet: 'the map has no seat yet',
  no_variant_yet: 'the map lists no ship variant yet',
  not_buyable_chip: 'AUTO ONLY',
  note_advanced_head: 'file · clocks · economy · sov · structures',
  note_auto: 'A period is <b>wall</b> seconds, like the timeout. Ships spawn at every player base; rounds are stocked there.',
  note_auto_head: 'every_sec, wall',
  note_base: 'One base per seat, exactly. A second press for the base of a seat moves it: the tool cannot write the error.',
  note_breakwater: 'A Reef Breakwater takes one round of another team out of the water every reload, inside its reach: no detonation and no splash. A NEUTRAL breakwater that is not capturable takes a round of any team; a NEUTRAL capturable one takes nothing until a team holds it. The reload is wall seconds, the unit of the capture time. The faint ring on the map is the reach of the breakwater the pointer or the pin is on.',
  note_capture: (p: { count: string | number; objectives: string | number }) => `How long the fleets of one team stand alone in the capture ring before a capturable structure changes hands, in <b>wall</b> seconds. 0 means the default. Structures on the map: ${p.count}. Objectives: ${p.objectives}.`,
  note_check: 'The game server checks a map with the same rules, and every finding carries the id of its rule. DOWNLOAD FILE stays on while a map is broken: a half-finished map is a file you keep working on.',
  note_clocks_head: 'wall seconds · two clocks',
  note_combat_pace: 'The combat clock divides every damage rate: gun damage, shield regen and every reload. It is a ratio and not a duration, so no clock conversion touches it. The arcade has its own figure, which is not the core figure; a map file may state its own. A higher figure makes a fight last longer.',
  note_den: 'A den sails one pirate group of its brotherhood. When the group sinks, the den sails the next group after its wave timer, in wall seconds. A den must stand outside the apron of every player base, the base cell and the three rings round it, and outside ring 1 of every structure. A den has no team, and no team can take it.',
  note_deployable: 'A laid deployable stands on its anchor from the first second of the match. A Seine or a Palisade is a line: HEADING turns it, and the image of a stated symmetry turns with it. A map lays no Feint. A NEUTRAL object is public, as a NEUTRAL sea mine is.',
  note_dimensions: 'cols × rows',
  note_economy: 'Income accrues on the <b>world clock</b> at timescale, and it is the one rate that is not wall seconds. The scan cooldown is <b>wall</b> seconds; 0 means the core figure.',
  note_economy_head: 'credits · units',
  note_erase: 'Erase lifts every object, fleet, sov claim, marker and laid object off the brush. Terrain does not change: paint WATER to clear rock.',
  note_fairway: (p: { min_cells: string | number; max_chains: string | number }) => `One drag paints one fairway chain, cell by cell, in the order of the drag: the first cell to the last cell defines port and starboard. A chain goes on open water, holds ${p.min_cells} cells at least, and a cell is on one chain once; a map holds ${p.max_chains} chains at most. The match places a buoy every four cells and lights the water from the first buoy to the last: a hull on lit water sails faster. ERASE lifts a cell and cuts its chain in two.`,
  note_fbase: 'A faction base gives its team sonar cover and nothing else.',
  note_field: 'Units of 0 take the field units of the map, in ADVANCED of the MAP tab.',
  note_file_head: 'category · version · revision · status',
  note_fleet: 'A starting fleet may not sit on rock.',
  note_grid: 'A size is a preset of columns and rows. A new grid keeps the map at its top-left cell and keeps every cell that still exists. Nothing moves, because an odd row stands half a hex off an even one, and a moved map is another map.',
  note_hold_auto_capture: 'On, every player base claims and defends the water round it, as a hold does in a season. Off, a cell changes hands under a Beacon alone. It needs SOVEREIGNTY.',
  note_identity: 'name · description',
  note_inspect: 'Press a cell to pin it. The panel says what stands on that cell and which findings name it. INSPECT changes nothing: press ✕ or ESC to let the cell go.',
  note_lair: 'A lair sails one monster of its kind, and it must stand on a trench cell. The seat that sinks the monster gets the bounty in credits. ONCE sails one monster a match; a respawn in wall seconds sails the next monster that long after the kill. A lair has no team, and no team can take it.',
  note_marker: (p: { max_markers: string | number }) => `A marker says "this tile" and does nothing else: it has no gameplay effect, it stands on rock, and it shares a cell with an object or a fleet. A map carries ${p.max_markers} markers at most. The colour is a faction colour, or WHITE for a mark that belongs to nobody.`,
  note_not_buyable: 'Press BUY to take a variant off the build pane. An AUTO ONLY hull reaches the water through an auto spawn or a starting fleet only, and it carries no price, because nobody buys it. AUTO ONLY adds an auto spawn of the variant, and BUY takes it away again.',
  note_players: (p: { max_players: string | number; max_per_team: string | number; max_teams: string | number }) => `Max ${p.max_players} seats, max ${p.max_per_team} a team, max ${p.max_teams} teams. The team of a seat is its faction colour in the match.`,
  note_players_head: (p: { max_players: string | number }) => `seats · teams · max ${p.max_players}`,
  note_plot: 'PLOT gives each hull the PLOT order in place of PATROL: a course of legs with loop parts. The match saves no plot and plays no shipping lane. A painted fairway lights the water with PLOT on or off.',
  note_revision: 'The file name carries the revision, so DOWNLOAD writes <slug>-v<revision>.json. A new drawing of a map is a new revision, and the old file stays in the tree. Only an ACTIVE file enters a lobby lane.',
  note_rounds: 'ROUNDS is the load a tubed hull takes from the base magazine at every deploy. With no row it loads AUTO. A round with * is manual: AUTO never loads it, so a map that stocks one must name it here. A match has no LOADOUT sheet, so this mix is the load.',
  note_rules: 'DEPTH gives each water cell a depth band from the terrain: water near rock is shallow, and water near a trench is deep. A hull below its depth rating loses hull. CURRENTS gives the water a current along the lines of equal depth, which moves each hull that is not at anchor; every hull can anchor. The current scale multiplies the current. A map with a d2 symmetry cannot set currents. The tide does not turn in a match.',
  note_rules_head: 'the rules of v2 this map turns on',
  note_sea_objects: 'A seat buys a kind on sale at once into its seat stock. The cap of a kind is the most one seat holds at once: the stock, the stow of its Sappers and its objects on the water count together. A grant opens the seat stock of every seat. A map that sells or grants a sea object must list a Sapper in the UNITS tab.',
  note_sea_objects_head: 'kind · price · cap',
  note_seamine: 'A laid sea mine is armed from the first second of the match. A NEUTRAL field is public: every seat sees it from the start, and it bars the route of every team. A laid object stands on water or a trench, off every object cell and outside ring 1 of a player base.',
  note_shield_regen: 'The natural shield regen, in <b>wall</b> seconds. The calm gate is how long a hull goes without damage before its shield refills, and the refill is the time from an empty shield to the maximum. 0 means the arcade figure. With no_shield_regen on, no shield refills by itself; the Tender\'s berth and the Coral Ward still mend.',
  note_ships: 'A roll is a fixed number, never a draw: a map plays identically every time. A price is pre-filled from the hull\'s material cost at generation time, and the author owns the final number: a class change never rewrites a price you typed.',
  note_ships_head: 'class · modules · price',
  note_sov: (p: { painted: string | number }) => `${p.painted} starting cells are painted. With sovereignty off no cell holds sovereignty at all.`,
  note_sov_head: 'three flags',
  note_sov_off: 'SOVEREIGNTY is off in ADVANCED of the MAP tab, so painted ground is only a warning until you turn it on.',
  note_starting: 'Every seat opens the match with these rounds in its base magazine, the way starting_credits opens its bank. A count is a number of rounds and states no time. A starting fleet loads its magazine from this stock.',
  note_starting_head: 'kind · count',
  note_status_community: 'A map you publish is a community map: the meta server keeps its revision, and the pacing and the economy stand inside the community bounds. A field you leave outside its bound takes the nearest figure inside it.',
  note_stow: 'STOW is the load a Sapper takes from the seat stock at every deploy and at every RETURN. With no row it loads AUTO. A row names a kind the map sells or grants in the SEA OBJECTS group of the MAP tab, and the whole stow must fit the Sapper cargo.',
  note_structure: 'A structure starts with its owner team, or NEUTRAL. A capturable structure changes hands when the fleets of one team stand alone in its capture ring for the capture time of the MAP tab. The capture ring is the dashed outline of the cell and the six cells round it. An objective counts for the hold_structures win, and it must be capturable. A NEUTRAL structure that is not capturable serves every team, and a Deep Battery of that kind fires at every hull.',
  note_structures_head: 'the capture time',
  note_symmetry: 'With MIRROR EDITS on, each edit writes every image of its cell too: the terrain, an object, a starting fleet, a sov cell and a marker, with the seat and the team turned and an arrow turned with the map. An unpaired cell has no image, so it stays rock and takes no paint. Turn MIRROR EDITS off to break the symmetry on purpose; CHECK then names each cell that differs.',
  note_symmetry_head: 'every seat gets the same ground',
  note_terrain: 'Paint the cell terrain. Water is navigable, a trench is navigable and slower, rock blocks and carries nothing.',
  note_timeout: (p: { wall: string | number }) => `Every duration in a map file is <b>wall</b> seconds, and the server puts it on the map clock once. ${p.wall} is what a player sits through. The match ends in a draw when it expires.`,
  note_torpedoes: 'A match has no buildings, so a base fires only when this flag is set. A base round — the Culverin — needs it, and a hull can never carry one.',
  note_torpedoes_head: 'kind · price',
  note_win: 'A map has exactly one win condition. The timeout draw is always on. In a team map a team wins and loses together.',
  note_win_cell: 'Press a cell on the map while this tab stands: the press names the tile, whatever brush the TOOLS tab holds.',
  note_win_head: 'one of eight',
  note_win_none: 'No parameters. The last team with a fleet wins.',
  note_win_objectives: (p: { have: string | number }) => `The map places ${p.have} objectives. A team wins when it owns count of them at one time for hold_sec wall seconds.`,
  note_winline: 'This preview is written here. The game server writes the sentence a player reads, and that sentence is the authority. A hold time is stated in wall seconds and said here in wall time.',
  note_winline_head: 'approximation',
  npc_sec: (p: { sec: string | number }) => `${p.sec} s`,
  objective_needs_capturable: 'OBJECTIVE needs CAPTURABLE: an objective must change hands.',
  open_close_title: 'shut the list of maps',
  open_none: 'The dev server lists no map file.',
  open_title: 'OPEN A REPO MAP',
  owner_neutral: 'NEUTRAL',
  preview_bands_title: 'Tint the water by the depth band the match derives from the terrain. The preview changes nothing in the file.',
  rail_title: 'open the column on this section',
  reach_less: 'less reach',
  reach_more: 'more reach',
  reach_value: (p: { px: string | number }) => `${p.px} px`,
  ready_size: (p: { kb: string | number }) => `READY · ${p.kb} KB`,
  reload_less: 'shorter reload',
  reload_more: 'longer reload',
  reload_value: (p: { sec: string | number }) => `${p.sec} s`,
  respawn_less: 'shorter respawn',
  respawn_more: 'longer respawn',
  respawn_once: 'once',
  rounds_auto: 'AUTO',
  rounds_cargo: (p: { cargo: string | number; room: string | number }) => `${p.cargo} of ${p.room} cargo`,
  row_add: 'add',
  row_add_round: 'add round',
  row_add_ship: 'add ship',
  row_auto_ship: (p: { variant: string | number }) => `ship · ${p.variant}`,
  row_auto_torpedo: (p: { kind: string | number }) => `torpedo · ${p.kind}`,
  row_base_fires: 'bases fire torpedoes',
  row_bounty: 'bounty',
  row_brotherhood: 'brotherhood',
  row_brush: 'brush',
  row_capturable: 'capturable',
  row_capture_sec: 'capture time',
  row_category: 'category',
  row_cells: 'cells',
  row_colour: 'colour',
  row_cols: 'columns',
  row_combat_pace: 'combat pace',
  row_credits_per_sec: 'income',
  row_current_scale: 'current scale',
  row_currents: 'currents',
  row_depth: 'depth',
  row_description: 'description',
  row_design: 'design',
  row_field_units: 'field units',
  row_heading: 'heading',
  row_hold_auto_capture: 'bases claim water',
  row_hold_sec: 'hold_sec <b>wall</b>',
  row_kind: 'kind',
  row_mined_rate: 'mined credit rate',
  row_mirror_edits: 'mirror edits',
  row_monster: 'kind',
  row_name: 'map name',
  row_no_shield_regen: 'no shield regen',
  row_objective: 'objective',
  row_owner: 'owner',
  row_plot: 'plot',
  row_preset: 'size',
  row_preview_bands: 'preview bands',
  row_reach: 'reach',
  row_regen_calm: 'shield calm',
  row_regen_refill: 'shield refill',
  row_reload: 'reload',
  row_respawn: 'respawn',
  row_revision: 'revision',
  row_rounds: 'rounds',
  row_rows: 'rows',
  row_scan_cooldown: 'scan cooldown',
  row_sea_cap: 'cap',
  row_sea_grant: 'grant',
  row_sea_sell: 'sell',
  row_seat: 'seat',
  row_shield_type: 'shield type',
  row_slot: (p: { slot: string | number }) => `seat ${p.slot}`,
  row_sonar: 'sonar range',
  row_sov_enabled: 'sovereignty',
  row_starting_credits: 'starting credits',
  row_status: 'status',
  row_stow: 'stow',
  row_sym_centre: 'centre',
  row_symmetry: 'kind',
  row_tacticalscale: 'map clock',
  row_team: 'team',
  row_timeout: 'match timeout',
  row_timescale: 'world clock',
  row_unpaired: 'unpaired cells',
  row_version: 'schema version',
  row_wave: 'wave timer',
  row_weapon_type: 'weapon type',
  scale_value: (p: { scale: string | number }) => `×${p.scale}`,
  sea_cap_less: 'smaller cap',
  sea_cap_more: 'larger cap',
  sea_cap_value: (p: { cap: string | number }) => `cap ${p.cap}`,
  ship_class_cap_note: (p: { cap: string | number; hull: string | number }) => `A seat holds ${p.cap} ${p.hull} at most. The build pane refuses the next, and a spawn past the cap puts nothing to sea.`,
  slot_chip: (p: { slot: string | number }) => `S${p.slot}`,
  start_base_key: (p: { key: string | number; seat: string | number }) => `Or press ${p.key} and place the base of ${p.seat} on the map.`,
  start_base_touch: (p: { seat: string | number }) => `Or press PLACE BASE, then tap the map for the base of ${p.seat}.`,
  start_copy: 'LOAD MAP copies a map of this build. The copy is yours to change.',
  start_kind: 'two ways in',
  start_press_base: 'PLACE BASE',
  start_title: 'A NEW MAP',
  status_community: 'community',
  struct_capturable: 'capturable',
  struct_fixed: 'fixed',
  struct_guard: (p: { reach: string | number; reload: string | number }) => `${p.reach} · ${p.reload}`,
  struct_objective: 'objective',
  sym_centre_at: (p: { cell: string | number; at: string | number }) => `cell ${p.cell} · ${p.at}`,
  sym_centre_grid: 'the grid centre',
  sym_d2: 'D2',
  sym_d2_rows: (p: { rows: string | number }) => `D2 needs an odd row count, and this map has ${p.rows} rows`,
  sym_line_kind: 'symmetry',
  sym_line_mirror_off: 'mirror edits off',
  sym_line_mirror_on: 'mirror edits on',
  sym_line_none: 'no symmetry',
  sym_none: 'NONE',
  sym_rot120: '120°',
  sym_rot180: '180°',
  tabs: ['TOOLS', 'MAP', 'UNITS', 'WIN', 'CHECK'],
  tag_dev: 'DEV',
  team_chip: (p: { team: string | number }) => `TEAM ${p.team}`,
  todo_chip: (p: { count: string | number }) => `${p.count} TO DO`,
  tool_base: 'PLAYER BASE',
  tool_battery: 'DEEP BATTERY',
  tool_breakwater: 'REEF BREAKWATER',
  tool_den: 'DEN',
  tool_deployable: 'DEPLOYABLE',
  tool_erase: 'ERASE',
  tool_fairway: 'FAIRWAY',
  tool_fbase: 'FACTION BASE',
  tool_field: 'RESOURCE FIELD',
  tool_fleet: 'FLEET',
  tool_inspect: 'INSPECT',
  tool_lair: 'LAIR',
  tool_marker: 'MARKER',
  tool_ridge: 'RIDGE',
  tool_seamine: 'SEA MINE',
  tool_sov: 'PAINT SOV',
  tool_spire: 'RELAY SPIRE',
  tool_throne: 'TRENCH THRONE',
  tool_trench: 'TRENCH',
  tool_ward: 'CORAL WARD',
  tool_water: 'WATER',
  tools_erase: 'ERASE & READ',
  tools_npc: 'NPC SIDE',
  tools_objects: 'BASES & FIELDS',
  tools_sea: 'SEA OBJECTS',
  tools_structures: 'STRUCTURES',
  tools_terrain: 'TERRAIN',
  tools_units: 'FLEETS, SOV & MARKERS',
  typed_basic_chip: 'BASIC',
  unclaimed_chip: 'UNCLAIMED',
  unit_kb: 'KB',
  unit_rounds: 'rounds',
  unit_sea_objects: 'objects',
  valid_chip: '✓ VALID',
  validator_head: 'THE VALIDATOR',
  wall_minutes: (p: { minutes: string | number }) => `= ${p.minutes} wall min`,
  wall_seconds: (p: { seconds: string | number }) => `= ${p.seconds} wall s`,
  watermark: 'MAP DESIGNER',
  wave_less: 'shorter wave timer',
  wave_more: 'longer wave timer',
  white_chip: 'WHITE',
  win_chip_hold_structures: 'HOLD OBJECTIVES',
  win_chip_kill_all: 'KILL ALL',
  win_chip_kill_class: 'KILL CLASS',
  win_chip_kills: 'KILLS',
  win_chip_mine: 'MINE',
  win_chip_scan_class: 'SCAN CLASS',
  win_chip_sov_cell: 'SOV CELL',
  win_chip_sov_share: 'SOV SHARE',
};

const designerLoad_en: S.DesignerLoad = {
  categories: 'CATEGORIES',
  close_title: 'shut the map window',
  filter: 'STATUS',
  filter_active: 'ACTIVE',
  filter_all: 'ALL',
  filter_draft: 'DRAFT',
  filter_retired: 'RETIRED',
  load_failed: (p: { error: string | number }) => `The maps did not load: ${p.error}`,
  loading: 'The maps of this category load.',
  none: 'This category holds no map.',
  none_status: 'No map of this category has this status.',
  revision: (p: { revision: string | number }) => `r${p.revision}`,
  row_title: (p: { name: string | number }) => `load ${p.name} into the designer`,
  seats: (p: { count: number }) => plural(p.count, {
    one: `${p.count} SEAT`,
    other: `${p.count} SEATS`,
  }),
  size: (p: { cols: string | number; rows: string | number }) => `${p.cols} × ${p.rows}`,
  sub: 'the maps this build carries · a press loads a map',
  symmetry: (p: { kind: string | number }) => `symmetry ${p.kind}`,
  tag_draft: 'DRAFT',
  tag_retired: 'RETIRED',
  teams: (p: { count: number }) => plural(p.count, {
    one: `${p.count} TEAM`,
    other: `${p.count} TEAMS`,
  }),
  timeout_min: (p: { minutes: string | number }) => `timeout ${p.minutes} min`,
  timeout_none: 'no timeout',
  timeout_sec: (p: { seconds: string | number }) => `timeout ${p.seconds} s`,
  title: 'LOAD MAP',
  versus: 'V',
};

const designerPublish_en: S.DesignerPublish = {
  no_answer: (p: { error: string | number }) => `the dev server did not answer: ${p.error}`,
  read_failed: (p: { status: string | number }) => `the read failed (${p.status})`,
  write_failed: (p: { status: string | number }) => `the write failed (${p.status})`,
};

const designerRender_en: S.DesignerRender = {
  slot_caption: (p: { slot: string | number }) => `S${p.slot}`,
};

const effects_en: S.Effects = {
  anchor_rings_desc: 'Two rings stand round the Bulwark and take the breath in turn.',
  anchor_rings_how: 'Granted by the operators for a special occasion.',
  anchor_rings_name: 'ANCHOR RINGS',
  aurora_desc: 'Three faint bands drift above the hold, and each band drifts toward white and back.',
  aurora_how: 'Granted by the operators for a special occasion.',
  aurora_name: 'AURORA',
  basilisk_gaze_desc: 'A narrow faint cone stands ahead of the bow of the Basilisk and breathes every nine seconds.',
  basilisk_gaze_how: 'Granted by the operators for a special occasion.',
  basilisk_gaze_name: 'BASILISK GAZE',
  beacon_crown_desc: 'Six pips stand round the Beacon and light in turn, twelve seconds to the round.',
  beacon_crown_how: 'Granted by the operators for a special occasion.',
  beacon_crown_name: 'BEACON CROWN',
  beacon_lantern_desc: 'A soft glow lies over the hold and breathes one time every eight seconds.',
  beacon_lantern_how: 'Granted by the operators for a special occasion.',
  beacon_lantern_name: 'BEACON LANTERN',
  bow_arcs_desc: 'Two small arcs stand ahead of the nose and pulse every two seconds.',
  bow_arcs_how: 'Granted by the operators for a special occasion.',
  bow_arcs_name: 'BOW ARCS',
  bow_shimmer_desc: 'Two lines of grains open astern in a V, the way a lit bow wave opens.',
  bow_shimmer_how: 'Granted by the operators for a special occasion.',
  bow_shimmer_name: 'BOW SHIMMER',
  bubble_breath_desc: 'Small white bubbles leave the hull a few at a time and rise off the track.',
  bubble_breath_how: 'Granted by the operators for a special occasion.',
  bubble_breath_name: 'BUBBLE BREATH',
  bubble_column_desc: 'White bubbles leave the hold a few at a time and rise off the cartouche.',
  bubble_column_how: 'Granted by the operators for a special occasion.',
  bubble_column_name: 'BUBBLE COLUMN',
  bubble_ring_desc: 'A ring of eight bubbles stands round the round and turns slowly.',
  bubble_ring_how: 'Granted by the operators for a special occasion.',
  bubble_ring_name: 'BUBBLE RING',
  bulwark_lattice_desc: 'A hex lattice turns round the Bulwark, one revolution in sixteen seconds.',
  bulwark_lattice_how: 'Granted by the operators for a special occasion.',
  bulwark_lattice_name: 'BULWARK LATTICE',
  cavitation_cloud_desc: 'Three neutral fog blobs leave the round astern, drift wide, and thin away.',
  cavitation_cloud_how: 'Granted by the operators for a special occasion.',
  cavitation_cloud_name: 'CAVITATION CLOUD',
  chase_flare_desc: 'A bright white core runs on the Interceptor with a short tail of four pips.',
  chase_flare_how: 'Granted by the operators for a special occasion.',
  chase_flare_name: 'CHASE FLARE',
  comet_tail_desc: 'A long tail of grains follows the round and thins to nothing behind it.',
  comet_tail_how: 'Granted by the operators for a special occasion.',
  comet_tail_name: 'COMET TAIL',
  compass_rose_desc: 'A faint four-point star lies under the hull and turns one revolution in sixty seconds.',
  compass_rose_how: 'Granted by the operators for a special occasion.',
  compass_rose_name: 'COMPASS ROSE',
  corsair_blaze_desc: 'A soft flare sits at the bow of the Corsair and breathes every six seconds.',
  corsair_blaze_how: 'Granted by the operators for a special occasion.',
  corsair_blaze_name: 'CORSAIR BLAZE',
  crown_desc: 'Six pips sit on the coverage ring of the hold and light in turn, eighteen seconds to the round.',
  crown_how: 'Granted by the operators for a special occasion.',
  crown_name: 'CROWN',
  cutlass_glint_desc: 'A white glint runs along the blade edge of the Cutlass, from the shoulder to the tip.',
  cutlass_glint_how: 'Granted by the operators for a special occasion.',
  cutlass_glint_name: 'CUTLASS GLINT',
  echo_lines_desc: 'Three arcs leave one side of the hold every nine seconds and fade out over the claim.',
  echo_lines_how: 'Granted by the operators for a special occasion.',
  echo_lines_name: 'ECHO LINES',
  ember_bed_desc: 'Small embers glow on the ground at the base of the hold and fade out.',
  ember_bed_how: 'Granted by the operators for a special occasion.',
  ember_bed_name: 'EMBER BED',
  ember_rim_desc: 'The rim of the silhouette drifts from the faction colour toward white and back.',
  ember_rim_how: 'Granted by the operators for a special occasion.',
  ember_rim_name: 'EMBER RIM',
  ember_trail_desc: 'The round sheds dull glow grains astern, and every grain swells and goes out.',
  ember_trail_how: 'Granted by the operators for a special occasion.',
  ember_trail_name: 'EMBER TRAIL',
  falconet_feathers_desc: 'Two feather streaks leave the fins of the Falconet astern and fade slowly.',
  falconet_feathers_how: 'Granted by the operators for a special occasion.',
  falconet_feathers_name: 'FALCONET FEATHERS',
  frost_desc: 'White glints twinkle on the outline of the hull alone, and they scatter slowly.',
  frost_how: 'Granted by the operators for a special occasion.',
  frost_name: 'FROST',
  guardian_rays_desc: 'Six pale spokes stand out of the hold and turn one revolution in sixty seconds.',
  guardian_rays_how: 'Granted by the operators for a special occasion.',
  guardian_rays_name: 'GUARDIAN RAYS',
  halo_desc: 'One soft disc rests under the mark and breathes over six seconds.',
  halo_how: 'Awarded to the season\'s first commander for one season.',
  halo_name: 'HALO',
  halo_round_desc: 'One soft disc lies under the round and breathes one time every four seconds.',
  halo_round_how: 'Granted by the operators for a special occasion.',
  halo_round_name: 'HALO ROUND',
  heartbeat_desc: 'The anchor ring swells with a double beat every eight seconds and then rests.',
  heartbeat_how: 'Granted by the operators for a special occasion.',
  heartbeat_name: 'HEARTBEAT',
  heavy_wake_desc: 'A wide neutral fog wake lies astern of the Heavy and widens behind it.',
  heavy_wake_how: 'Granted by the operators for a special occasion.',
  heavy_wake_name: 'HEAVY WAKE',
  hold_compass_desc: 'A faint four-point star lies under the hold and turns one revolution in ninety seconds.',
  hold_compass_how: 'Granted by the operators for a special occasion.',
  hold_compass_name: 'HOLD COMPASS',
  hold_halo_desc: 'One wide soft disc lies under the whole claim and breathes every eight seconds.',
  hold_halo_how: 'Granted by the operators for a special occasion.',
  hold_halo_name: 'HOLD HALO',
  interceptor_thread_desc: 'A fine dashed thread runs behind the Interceptor, and the dashes walk astern.',
  interceptor_thread_how: 'Granted by the operators for a special occasion.',
  interceptor_thread_name: 'INTERCEPTOR THREAD',
  kelp_drift_desc: 'Two thin strands trail astern of the hull and sway in a slow current.',
  kelp_drift_how: 'Granted by the operators for a special occasion.',
  kelp_drift_name: 'KELP DRIFT',
  kelp_garden_desc: 'Four strands stand round the hold and sway, twenty-four seconds to the sway.',
  kelp_garden_how: 'Granted by the operators for a special occasion.',
  kelp_garden_name: 'KELP GARDEN',
  kraken_ink_desc: 'Five neutral fog rolls turn slowly round the hold at a low alpha.',
  kraken_ink_how: 'Granted by the operators for a special occasion.',
  kraken_ink_name: 'KRAKEN INK',
  lancer_spearhead_desc: 'One pip runs from the stern of the Lancer to the tip every six seconds.',
  lancer_spearhead_how: 'Granted by the operators for a special occasion.',
  lancer_spearhead_name: 'LANCER SPEARHEAD',
  lantern_chain_desc: 'Three white pips trail astern in a line, and every pip is dimmer than the pip in front of it.',
  lantern_chain_how: 'Granted by the operators for a special occasion.',
  lantern_chain_name: 'LANTERN CHAIN',
  lantern_desc: 'A warm glow hangs under the Tender on a short cable and breathes every ten seconds.',
  lantern_how: 'Granted by the operators for a special occasion.',
  lantern_name: 'LANTERN',
  light_lantern_desc: 'A small lamp sits on the nose of the Light and breathes every two seconds.',
  light_lantern_how: 'Granted by the operators for a special occasion.',
  light_lantern_name: 'LIGHT LANTERN',
  lighthouse_desc: 'One pale beam stands out of the hold and turns one revolution in thirty seconds.',
  lighthouse_how: 'Awarded to the best commander of the winning faction for one season.',
  lighthouse_name: 'LIGHTHOUSE',
  moonlight_desc: 'One very faint wide pale disc drifts across the hold, thirty seconds to the pass.',
  moonlight_how: 'Granted by the operators for a special occasion.',
  moonlight_name: 'MOONLIGHT',
  orbiting_sentries_desc: 'Three pips circle the hold on one faint track, thirty seconds to the orbit.',
  orbiting_sentries_how: 'Granted by the operators for a special occasion.',
  orbiting_sentries_name: 'ORBITING SENTRIES',
  pearl_chain_desc: 'Twelve white pips lie on the anchor ring and light in turn.',
  pearl_chain_how: 'Granted by the operators for a special occasion.',
  pearl_chain_name: 'PEARL CHAIN',
  pulse_core_desc: 'The glow of the round breathes one time every three seconds and never goes out.',
  pulse_core_how: 'Granted by the operators for a special occasion.',
  pulse_core_name: 'PULSE CORE',
  ring_chain_desc: 'The round drops small pale rings, and each ring holds its place in the water and fades.',
  ring_chain_how: 'Granted by the operators for a special occasion.',
  ring_chain_name: 'RING CHAIN',
  ring_wake_desc: 'A ring leaves the track of the round every two seconds, spreads, and fades.',
  ring_wake_how: 'Granted by the operators for a special occasion.',
  ring_wake_name: 'RING WAKE',
  sea_glitter_desc: 'Grains twinkle inside the coverage ring of the hold, each one time.',
  sea_glitter_how: 'Granted by the operators for a special occasion.',
  sea_glitter_name: 'SEA GLITTER',
  searchlight_desc: 'A faint pale cone stands ahead of the nose and sways across the track.',
  searchlight_how: 'Granted by the operators for a special occasion.',
  searchlight_name: 'SEARCHLIGHT',
  seeker_eye_desc: 'A faint arc sweeps ahead of the Seeker, the way a search beam sweeps.',
  seeker_eye_how: 'Granted by the operators for a special occasion.',
  seeker_eye_name: 'SEEKER EYE',
  seeker_pulse_desc: 'A ping ring leaves the nose of the Seeker and holds its place while the round runs on.',
  seeker_pulse_how: 'Granted by the operators for a special occasion.',
  seeker_pulse_name: 'SEEKER PULSE',
  sentinel_watch_desc: 'A short accent arc circles the Sentinel one time in twenty seconds.',
  sentinel_watch_how: 'Granted by the operators for a special occasion.',
  sentinel_watch_name: 'SENTINEL WATCH',
  silt_plume_desc: 'Three silt clouds leave the Dredger astern, grow, and thin away.',
  silt_plume_how: 'Granted by the operators for a special occasion.',
  silt_plume_name: 'SILT PLUME',
  spiral_desc: 'White grains twist round the track of the round and thin away astern.',
  spiral_how: 'Granted by the operators for a special occasion.',
  spiral_name: 'SPIRAL',
  spokes_desc: 'Eight dashed spokes run out of the hold and turn one revolution in sixty seconds.',
  spokes_how: 'Granted by the operators for a special occasion.',
  spokes_name: 'SPOKES',
  star_field_desc: 'Grains twinkle over the whole claim and scatter slowly outward.',
  star_field_how: 'Granted by the operators for a special occasion.',
  star_field_name: 'STAR FIELD',
  stardust_wake_desc: 'The hull sheds faint grains astern, and each grain twinkles one time and goes out.',
  stardust_wake_how: 'Granted by the operators for a special occasion.',
  stardust_wake_name: 'STARDUST WAKE',
  third_eye_desc: 'One thin ring stands round the needle of the Oracle and breathes every eight seconds.',
  third_eye_how: 'Granted by the operators for a special occasion.',
  third_eye_name: 'THIRD EYE',
  tidal_pull_desc: 'Grains drift in from the claim toward the hold and go out at the cartouche.',
  tidal_pull_how: 'Granted by the operators for a special occasion.',
  tidal_pull_name: 'TIDAL PULL',
  twin_sprites_desc: 'Two small pips orbit the hull, twenty seconds to the orbit.',
  twin_sprites_how: 'Granted by the operators for a special occasion.',
  twin_sprites_name: 'TWIN SPRITES',
  twin_tails_desc: 'Two short tails of grains open astern in a V, one off each fin.',
  twin_tails_how: 'Granted by the operators for a special occasion.',
  twin_tails_name: 'TWIN TAILS',
};

export const tables = {
  achievements: achievements_en,
  advisor: advisor_en,
  alarms: alarms_en,
  api: api_en,
  arcadeCatalog: arcadeCatalog_en,
  arcadeChrome: arcadeChrome_en,
  arcadeCommunity: arcadeCommunity_en,
  arcadeDrill: arcadeDrill_en,
  arcadeFormat: arcadeFormat_en,
  arcadeHistory: arcadeHistory_en,
  arcadeHosting: arcadeHosting_en,
  arcadeLobby: arcadeLobby_en,
  arcadeMain: arcadeMain_en,
  arcadeMapschema: arcadeMapschema_en,
  arcadeMatch: arcadeMatch_en,
  arcadeMoments: arcadeMoments_en,
  arcadeStructures: arcadeStructures_en,
  arcadeViewer: arcadeViewer_en,
  arcadeWinline: arcadeWinline_en,
  banner: banner_en,
  battlelab: battlelab_en,
  brandart: brandart_en,
  brandartDiscord: brandartDiscord_en,
  briefing: briefing_en,
  cacheNote: cacheNote_en,
  card: card_en,
  chart: chart_en,
  chatfilter: chatfilter_en,
  choice: choice_en,
  chronicle: chronicle_en,
  connection: connection_en,
  designerApp: designerApp_en,
  designerCommunity: designerCommunity_en,
  designerDrawer: designerDrawer_en,
  designerLoad: designerLoad_en,
  designerPublish: designerPublish_en,
  designerRender: designerRender_en,
  effects: effects_en,
} satisfies Partial<S.StringTables>;
